(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("foundation"), require("mio-core"));
	else if(typeof define === 'function' && define.amd)
		define(["foundation", "mio-core"], factory);
	else if(typeof exports === 'object')
		exports["UIKit"] = factory(require("foundation"), require("mio-core"));
	else
		root["UIKit"] = factory(root["foundation"], root["mio-core"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_foundation__, __WEBPACK_EXTERNAL_MODULE_mio_core__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./sources/CoreAnimation/CAButtonLayer.ts":
/*!************************************************!*\
  !*** ./sources/CoreAnimation/CAButtonLayer.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAButtonLayer: () => (/* binding */ CAButtonLayer)
/* harmony export */ });
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CAButtonLayer = /** @class */ (function (_super) {
    __extends(CAButtonLayer, _super);
    function CAButtonLayer(contents) {
        var _this = _super.call(this, contents) || this;
        if (contents == null)
            _this.addStyle("button");
        return _this;
    }
    Object.defineProperty(CAButtonLayer.prototype, "title", {
        get: function () { return this.contents.innerHTML; },
        set: function (title) { this.contents.innerHTML = title; },
        enumerable: false,
        configurable: true
    });
    return CAButtonLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_0__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CACollectionLayer.ts":
/*!****************************************************!*\
  !*** ./sources/CoreAnimation/CACollectionLayer.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CACollectionLayer: () => (/* binding */ CACollectionLayer)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/UICoreNibParser */ "./sources/core/UICoreNibParser.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CACollectionLayer = /** @class */ (function (_super) {
    __extends(CACollectionLayer, _super);
    function CACollectionLayer(contents) {
        var _this = _super.call(this, contents) || this;
        _this.cellLayersByIdentifier = {};
        _this.supplementaryLayersByIdentifier = {};
        _this.contents.style.width = "100%";
        _this.contents.style.overflowX = "scroll";
        if (_this.contents.childNodes.length > 0) {
            for (var _i = 0, _a = _this.contents.childNodes; _i < _a.length; _i++) {
                var element = _a[_i];
                if (element.tagName != "DIV")
                    continue;
                if (element.getAttribute("data-cell-identifier") != null) {
                    _this._add_cell_layer(element);
                }
                else if (element.getAttribute("data-supplementary-view-identifier") != null) {
                    _this._add_supplementary_layer(element);
                }
                // else if (subLayer.getAttribute("data-collection-view-layout") != null){
                //     let classname = subLayer.getAttribute("data-class");
                //     this._collectionViewLayout = NSClassFromString(classname);
                //     this._collectionViewLayout.initWithLayer(subLayer, owner);
                // }
            }
        }
        return _this;
    }
    CACollectionLayer.prototype.newCellViewByIdentifier = function (identifier) {
        var item = this.cellLayersByIdentifier[identifier];
        if (item == null)
            throw Error("Can't find collection view cell for identifier " + identifier);
        return this.newViewFromItem(item);
    };
    CACollectionLayer.prototype._add_cell_layer = function (element) {
        var _a;
        element.style.display = "none";
        var identifier = element.getAttribute("data-cell-identifier");
        var classname = (_a = element.getAttribute("data-class")) !== null && _a !== void 0 ? _a : "UICollectionViewCell";
        var item = {};
        item["class"] = classname;
        item["contents"] = element;
        // let size = new CGSize(subLayer.clientWidth, subLayer.clientHeight);
        // if (size != null) item["size"] = size;
        // let bg = window.getComputedStyle(subLayer ,null).getPropertyValue('background-color');
        // if (bg != null) item["bg"] = bg;
        this.cellLayersByIdentifier[identifier] = item;
    };
    CACollectionLayer.prototype.newSupplementaryViewByIdentifier = function (identifier, owner) {
        var item = this.supplementaryLayersByIdentifier[identifier];
        if (item == null)
            throw Error("Can't find supplementary view for identifier " + identifier);
        //instance creation here
        return this.newViewFromItem(item);
    };
    CACollectionLayer.prototype.newViewFromItem = function (item) {
        var c = (0,mio_core__WEBPACK_IMPORTED_MODULE_2__.MIOCoreClassByName)(item["class"]);
        var v = (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSClassFromString)(item["class"]);
        var content_prototype = item["contents"];
        var contents = content_prototype.cloneNode(true);
        contents.style.display = "";
        v.layer = new c.layerClass(contents);
        (0,_core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_3__.UICoreNibLoad)(contents, v);
        return v;
    };
    CACollectionLayer.prototype._add_supplementary_layer = function (element) {
        var _a;
        element.style.display = "none";
        var identifier = element.getAttribute("data-supplementary-view-identifier");
        var classname = (_a = element.getAttribute("data-class")) !== null && _a !== void 0 ? _a : "UIView";
        var item = {};
        item["class"] = classname;
        item["contents"] = element;
        // var size = new CGSize(subLayer.clientWidth, subLayer.clientHeight);
        // if (size != null) item["size"] = size;
        // var bg = window.getComputedStyle(subLayer ,null).getPropertyValue('background-color');
        // if (bg != null) item["bg"] = bg;
        this.supplementaryLayersByIdentifier[identifier] = item;
    };
    return CACollectionLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_1__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CAImageLayer.ts":
/*!***********************************************!*\
  !*** ./sources/CoreAnimation/CAImageLayer.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAImageLayer: () => (/* binding */ CAImageLayer)
/* harmony export */ });
/* harmony import */ var _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/UICoreLayer */ "./sources/core/UICoreLayer.ts");
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CAImageLayer = /** @class */ (function (_super) {
    __extends(CAImageLayer, _super);
    function CAImageLayer(contents) {
        var _this = _super.call(this, contents) || this;
        if (contents != null)
            _this.imageElement = (0,_core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, "IMG");
        if (_this.imageElement == null) {
            _this.imageElement = document.createElement("IMG");
            _this.contents.appendChild(_this.imageElement);
        }
        return _this;
    }
    Object.defineProperty(CAImageLayer.prototype, "imageURL", {
        get: function () { return this.imageElement.getAttribute("src"); },
        set: function (url) { this.imageElement.setAttribute("src", url); },
        enumerable: false,
        configurable: true
    });
    return CAImageLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_1__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CAInputLayer.ts":
/*!***********************************************!*\
  !*** ./sources/CoreAnimation/CAInputLayer.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAInputLayer: () => (/* binding */ CAInputLayer)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/UICoreLayer */ "./sources/core/UICoreLayer.ts");
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CAInputLayer = /** @class */ (function (_super) {
    __extends(CAInputLayer, _super);
    function CAInputLayer(contents) {
        var _a;
        var _this = _super.call(this, contents) || this;
        // HTML Related events
        _this._onChangeBlock = null;
        _this._inputElement = (_a = (0,_core_UICoreLayer__WEBPACK_IMPORTED_MODULE_1__._UICoreLayerGetFirstElementWithTag)(contents, "INPUT")) !== null && _a !== void 0 ? _a : document.createElement("INPUT");
        var placeholderKey = contents.getAttribute("data-placeholder");
        if (placeholderKey != null)
            _this._inputElement.setAttribute("placeholder", (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLocalizeString)(placeholderKey, placeholderKey));
        return _this;
        // this.element.addEventListener("input", this.on_input);
        // this.element.addEventListener("click", this.on_click);
        // this.element.addEventListener("focus", this.on_focus);
        // this.element.addEventListener("blur", this.on_blur);
    }
    Object.defineProperty(CAInputLayer.prototype, "inputElement", {
        get: function () { return this._inputElement; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CAInputLayer.prototype, "string", {
        get: function () {
            return this._inputElement.value;
        },
        set: function (text) {
            var newValue = text != null ? text : "";
            this._inputElement.value = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CAInputLayer.prototype, "placeHolderText", {
        set: function (text) { this.contents.setAttribute("placeholder", text); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CAInputLayer.prototype, "onChangeBlock", {
        set: function (block) {
            if (block == null && this._onChangeBlock != null) {
                // Remove callback
                this._onChangeBlock = null;
                this._inputElement.removeEventListener("input", this.on_input.bind(this));
            }
            else if (block != null) {
                this._onChangeBlock = block;
                this._inputElement.addEventListener("input", this.on_input.bind(this));
            }
        },
        enumerable: false,
        configurable: true
    });
    CAInputLayer.prototype.on_input = function () {
        this._onChangeBlock(this._inputElement.value);
    };
    CAInputLayer.prototype.on_focus = function () {
    };
    CAInputLayer.prototype.on_blur = function () {
    };
    return CAInputLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_2__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CALayer+HTML.ts":
/*!***********************************************!*\
  !*** ./sources/CoreAnimation/CALayer+HTML.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAGetOrCreateElementWithTag: () => (/* binding */ CAGetOrCreateElementWithTag)
/* harmony export */ });
/* harmony import */ var _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/UICoreLayer */ "./sources/core/UICoreLayer.ts");

function CAGetOrCreateElementWithTag(layer, contents, tag) {
    var element = null;
    if (contents != null) {
        element = (0,_core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, tag);
    }
    if (element == null) {
        element = document.createElement(tag);
        contents.appendChild(element);
    }
    return element;
}


/***/ }),

/***/ "./sources/CoreAnimation/CALayer.ts":
/*!******************************************!*\
  !*** ./sources/CoreAnimation/CALayer.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CALayer: () => (/* binding */ CALayer),
/* harmony export */   CALayerEvent: () => (/* binding */ CALayerEvent)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);

var CALayer = /** @class */ (function () {
    function CALayer(contents) {
        this.delegate = null;
        this._layerID = null;
        // private _contents:any;
        // get contents() : any {
        //     return this._contents;
        // }
        // set contents( contents:any ) {
        //     this._contents = contents;
        // }
        this.superlayer = null;
        this.sublayers = [];
        this._isLayerInDOM = false;
        //
        // Events
        // 
        this._event_target = null;
        this._event_action = null;
        this.contents = contents !== null && contents !== void 0 ? contents : document.createElement('div');
        this._layerID = contents === null || contents === void 0 ? void 0 : contents.getAttribute("id");
    }
    Object.defineProperty(CALayer.prototype, "isHidden", {
        set: function (value) {
            if (value)
                this.contents.style.display = "none";
            else
                this.contents.style.display = "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CALayer.prototype, "opacity", {
        get: function () { var _a; return (_a = Number(this.contents.style.opacity)) !== null && _a !== void 0 ? _a : 1.0; },
        set: function (opacity) { this.contents.style.opacity = String(opacity); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CALayer.prototype, "disabled", {
        get: function () { return this.contents.disabled; },
        set: function (disabled) { this.contents.disabled = disabled; },
        enumerable: false,
        configurable: true
    });
    CALayer.prototype.addStyle = function (style) { this.contents.classList.add(style); };
    CALayer.prototype.removeStyle = function (style) { this.contents.classList.remove(style); };
    CALayer.prototype.addSublayer = function (layer) {
        if (layer._isLayerInDOM == true)
            return;
        layer.superlayer = this;
        this.sublayers.addObject(layer);
        // HTML Stuff
        this.contents.appendChild(layer.contents);
        layer._isLayerInDOM = true;
    };
    CALayer.prototype.removeFromSuperlayer = function () {
        if (this.superlayer == null)
            return;
        this.superlayer.sublayers.removeObject(this);
        if (this._isLayerInDOM == false)
            return;
        this.superlayer.contents.removeChild(this.contents);
        this._isLayerInDOM = false;
    };
    CALayer.prototype.registerEventAction = function (target, action) {
        if (action == null)
            throw new Error("CALayer: Can't add a null action");
        this._event_target = target;
        this._event_action = action;
        this.contents.addEventListener("click", this.on_click.bind(this));
        this.contents.addEventListener("mouseup", this.on_mouse_up.bind(this));
        this.contents.addEventListener("mousedown", this.on_mouse_down.bind(this));
    };
    CALayer.prototype.unregisterEventAction = function (target, action) {
        if (action == null)
            throw new Error("CALayer: Can't remove a null action");
        this._event_target = null;
        this._event_action = null;
        var instance = this;
        this.contents.removeEventListener("click", this.on_click.bind(this));
        this.contents.removeEventListener("mouseup", this.on_mouse_down.bind(this));
        this.contents.removeEventListener("mousedown", this.on_mouse_down.bind(this));
    };
    CALayer.prototype.on_click = function (e) { e.stopPropagation(); };
    CALayer.prototype.on_mouse_up = function (e) {
        if (this._event_action != null)
            this._event_action.call(this._event_target, CALayerEvent.mouseUp);
    };
    CALayer.prototype.on_mouse_down = function (e) {
        if (this._event_action != null)
            this._event_action.call(this._event_target, CALayerEvent.mouseDown);
    };
    return CALayer;
}());

function MUICoreViewSearchViewTag(view, tag) {
    if (view.tag == tag)
        return view;
    for (var index = 0; index < view.subviews.length; index++) {
        var v = view.subviews[index];
        v = MUICoreViewSearchViewTag(v, tag);
        if (v != null)
            return v;
    }
    return null;
}
function MUICoreViewCreateView(layer, owner) {
    var className = layer.getAttribute("data-class");
    if (className == null || className.length == 0)
        className = "UIView";
    var sv = (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSClassFromString)(className);
    sv.initWithLayer(layer, owner);
    sv.awakeFromHTML();
    sv._checkSegues();
    var id = layer.getAttribute("id");
    if (id != null)
        owner._outlets[id] = sv;
    return sv;
}
var CALayerEvent;
(function (CALayerEvent) {
    CALayerEvent[CALayerEvent["mouseUp"] = 0] = "mouseUp";
    CALayerEvent[CALayerEvent["mouseDown"] = 1] = "mouseDown";
    CALayerEvent[CALayerEvent["mouseMove"] = 2] = "mouseMove";
    CALayerEvent[CALayerEvent["click"] = 3] = "click";
    CALayerEvent[CALayerEvent["change"] = 4] = "change";
})(CALayerEvent || (CALayerEvent = {}));


/***/ }),

/***/ "./sources/CoreAnimation/CATableCellLayer.ts":
/*!***************************************************!*\
  !*** ./sources/CoreAnimation/CATableCellLayer.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CATableCellLayer: () => (/* binding */ CATableCellLayer)
/* harmony export */ });
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CATableCellLayer = /** @class */ (function (_super) {
    __extends(CATableCellLayer, _super);
    function CATableCellLayer(contents) {
        var _this = _super.call(this, contents) || this;
        if (_this.contents.childNodes.length > 0) {
            for (var _i = 0, _a = _this.contents.childNodes; _i < _a.length; _i++) {
                var element = _a[_i];
                if (element.tagName != "DIV")
                    continue;
                // TODO: let style = layer.getAttribute("data-cell-style");
                if (element.getAttribute("data-accessory-type") != null) {
                    _this._add_accessoryView(element);
                }
                if (element.getAttribute("data-editing-accessory-view") != null) {
                    _this._add_editing_accessoryView(element);
                }
            }
        }
        return _this;
    }
    //data-accessory-type="checkmark"
    CATableCellLayer.prototype._add_accessoryView = function (element) {
        var type = element.getAttribute("data-accessory-type");
        // this.accessoryView = new UIView();
        // this.accessoryView.initWithLayer(layer, owner);
        // if (type == "checkmark") this.accessoryType = UITableViewCellAccessoryType.checkmark;
        // else this.accessoryType = UITableViewCellAccessoryType.none;
        // if (this.accessoryType != UITableViewCellAccessoryType.none) return;
        // this.accessoryView.layer.addEventListener("click", this.accessoryViewDidClick.bind(this));
    };
    CATableCellLayer.prototype._add_editing_accessoryView = function (element) {
        // let type = layer.getAttribute("data-editing-accessory-view");
        // if (type == "insert") {
        //     this.editingAccessoryInsertView = new UIView();
        //     // this.editingAccessoryInsertView.initWithLayer(layer, owner);
        //     // this.editingAccessoryInsertView.layer.addEventListener("click", this.editingAccessoryViewDidClick.bind(this));
        // }
        // else if (type == "delete") {
        //     this.editingAccessoryDeleteView = new UIView();
        //     // this.editingAccessoryDeleteView.initWithLayer(layer, owner);
        //     // this.editingAccessoryDeleteView.layer.addEventListener("click", this.editingAccessoryViewDidClick.bind(this));
        // }
        // else {
        //     this.editingAccessoryView = new UIView();
        //     // this.editingAccessoryView.initWithLayer(layer, owner);    
        //     // this.editingAccessoryView.layer.addEventListener("click", this.editingAccessoryViewDidClick.bind(this));
        // }
        // // TODO: Change for a gesuture recongnizer or something independent of the html
        // let instance = this;
        // this.editingAccessoryView.layer.onclick = function (e) {
        //     if (instance._onAccessoryClickFn != null) {
        //         e.stopPropagation();
        //         instance._onAccessoryClickFn.call(instance._target, instance);
        //     }
        // };
    };
    CATableCellLayer.prototype.setSelected = function (value, animated) {
        if (value == true)
            this.addStyle("selected");
        else
            this.removeStyle("selected");
    };
    return CATableCellLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_0__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CATableLayer.ts":
/*!***********************************************!*\
  !*** ./sources/CoreAnimation/CATableLayer.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CATableLayer: () => (/* binding */ CATableLayer)
/* harmony export */ });
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
/* harmony import */ var _core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/UICoreNibParser */ "./sources/core/UICoreNibParser.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UIView */ "./sources/UIView.ts");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_4__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CATableLayer = /** @class */ (function (_super) {
    __extends(CATableLayer, _super);
    function CATableLayer(contents) {
        var _this = _super.call(this, contents) || this;
        _this.cellLayersByIdentifier = {};
        _this.headerLayer = null;
        _this.footerLayer = null;
        _this.supplementaryLayersByIdentifier = {};
        _this.contents.style.width = "100%";
        _this.contents.style.overflowY = "scroll";
        if (_this.contents.childNodes.length > 0) {
            for (var _i = 0, _a = _this.contents.childNodes; _i < _a.length; _i++) {
                var element = _a[_i];
                if (element.tagName != "DIV")
                    continue;
                if (element.getAttribute("data-cell-identifier") != null) {
                    _this._add_cell_layer(element);
                }
                else if (element.getAttribute("data-tableview-header") != null) {
                    _this._add_header_layer(element);
                }
                else if (element.getAttribute("data-tableview-footer") != null) {
                    _this._add_footer_layer(element);
                }
            }
        }
        return _this;
    }
    CATableLayer.prototype._add_cell_layer = function (element) {
        var _a;
        element.style.display = "none";
        var identifier = element.getAttribute("data-cell-identifier");
        var classname = (_a = element.getAttribute("data-class")) !== null && _a !== void 0 ? _a : "UITableViewCell";
        var item = {};
        item["class"] = classname;
        item["contents"] = element;
        this.cellLayersByIdentifier[identifier] = item;
    };
    CATableLayer.prototype._add_header_layer = function (element) {
        var _a;
        element.style.display = "none";
        var classname = (_a = element.getAttribute("data-class")) !== null && _a !== void 0 ? _a : "UIView";
        var item = {};
        item["class"] = classname;
        item["contents"] = element;
        this.headerLayer = item;
    };
    CATableLayer.prototype._add_footer_layer = function (element) {
        var _a;
        element.style.display = "none";
        var classname = (_a = element.getAttribute("data-class")) !== null && _a !== void 0 ? _a : "UIView";
        var item = {};
        item["class"] = classname;
        item["layer"] = element;
        this.footerLayer = item;
    };
    CATableLayer.prototype.newContentView = function () {
        var v = new _UIView__WEBPACK_IMPORTED_MODULE_2__.UIView();
        v.init();
        v.layer.contents.classList.add("table-cell-content");
        return v;
    };
    CATableLayer.prototype.newHeaderView = function () {
        if (this.headerLayer == null)
            return null;
        return this.newViewFromItem(this.headerLayer);
    };
    CATableLayer.prototype.newFooterView = function () {
        if (this.footerLayer == null)
            return null;
        return this.newViewFromItem(this.footerLayer);
    };
    CATableLayer.prototype.newCellViewByIdentifier = function (identifier) {
        var item = this.cellLayersByIdentifier[identifier];
        if (item == null)
            throw Error("Can't find collection view cell for identifier " + identifier);
        return this.newViewFromItem(item);
    };
    CATableLayer.prototype.newSupplementaryViewByIdentifier = function (identifier, owner) {
        var item = this.supplementaryLayersByIdentifier[identifier];
        if (item == null)
            throw Error("Can't find supplementary view for identifier " + identifier);
        //instance creation here
        return this.newViewFromItem(item);
    };
    CATableLayer.prototype.newViewFromItem = function (item) {
        var c = (0,mio_core__WEBPACK_IMPORTED_MODULE_4__.MIOCoreClassByName)(item["class"]);
        var v = (0,foundation__WEBPACK_IMPORTED_MODULE_3__.NSClassFromString)(item["class"]);
        var content_prototype = item["contents"];
        var contents = content_prototype.cloneNode(true);
        contents.style.display = "";
        v.layer = new c.layerClass(contents);
        (0,_core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_1__.UICoreNibLoad)(contents, v);
        return v;
    };
    return CATableLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_0__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CATextAreaLayer.ts":
/*!**************************************************!*\
  !*** ./sources/CoreAnimation/CATextAreaLayer.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CATextAreaLayer: () => (/* binding */ CATextAreaLayer)
/* harmony export */ });
/* harmony import */ var _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/UICoreLayer */ "./sources/core/UICoreLayer.ts");
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CATextAreaLayer = /** @class */ (function (_super) {
    __extends(CATextAreaLayer, _super);
    function CATextAreaLayer(contents) {
        var _this = _super.call(this, contents) || this;
        if (contents != null)
            _this.textElement = (0,_core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, "TEXTAREA");
        if (_this.textElement == null) {
            _this.textElement = document.createElement("TEXTAREA");
            _this.contents.appendChild(_this.textElement);
        }
        return _this;
    }
    Object.defineProperty(CATextAreaLayer.prototype, "string", {
        get: function () {
            return this.textElement.value;
        },
        set: function (text) {
            var newValue = text != null ? text : "";
            this.textElement.value = newValue;
        },
        enumerable: false,
        configurable: true
    });
    return CATextAreaLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_1__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CATextLayer.ts":
/*!**********************************************!*\
  !*** ./sources/CoreAnimation/CATextLayer.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CATextLayer: () => (/* binding */ CATextLayer)
/* harmony export */ });
/* harmony import */ var _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/UICoreLayer */ "./sources/core/UICoreLayer.ts");
/* harmony import */ var _CALayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CALayer */ "./sources/CoreAnimation/CALayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CATextLayer = /** @class */ (function (_super) {
    __extends(CATextLayer, _super);
    function CATextLayer(contents) {
        var _this = _super.call(this, contents) || this;
        if (contents != null)
            _this.textElement = (0,_core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, "SPAN");
        if (_this.textElement == null) {
            _this.textElement = document.createElement("SPAN");
            _this.contents.appendChild(_this.textElement);
        }
        return _this;
    }
    Object.defineProperty(CATextLayer.prototype, "string", {
        get: function () {
            return this.textElement.innerHTML;
        },
        set: function (text) {
            var newValue = text != null ? text : "";
            this.textElement.innerHTML = newValue;
        },
        enumerable: false,
        configurable: true
    });
    return CATextLayer;
}(_CALayer__WEBPACK_IMPORTED_MODULE_1__.CALayer));



/***/ }),

/***/ "./sources/CoreAnimation/CoreAnimation+Animations.ts":
/*!***********************************************************!*\
  !*** ./sources/CoreAnimation/CoreAnimation+Animations.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _CAAddAnimations: () => (/* binding */ _CAAddAnimations),
/* harmony export */   _CAAnimationType: () => (/* binding */ _CAAnimationType),
/* harmony export */   _CAClassListForAnimationType: () => (/* binding */ _CAClassListForAnimationType),
/* harmony export */   _CARemoveAnimations: () => (/* binding */ _CARemoveAnimations)
/* harmony export */ });
var _CAAnimationType;
(function (_CAAnimationType) {
    _CAAnimationType[_CAAnimationType["None"] = 0] = "None";
    _CAAnimationType[_CAAnimationType["BeginSheet"] = 1] = "BeginSheet";
    _CAAnimationType[_CAAnimationType["EndSheet"] = 2] = "EndSheet";
    _CAAnimationType[_CAAnimationType["Push"] = 3] = "Push";
    _CAAnimationType[_CAAnimationType["Pop"] = 4] = "Pop";
    _CAAnimationType[_CAAnimationType["FlipLeft"] = 5] = "FlipLeft";
    _CAAnimationType[_CAAnimationType["FlipRight"] = 6] = "FlipRight";
    _CAAnimationType[_CAAnimationType["FadeIn"] = 7] = "FadeIn";
    _CAAnimationType[_CAAnimationType["FadeOut"] = 8] = "FadeOut";
    _CAAnimationType[_CAAnimationType["LightSpeedIn"] = 9] = "LightSpeedIn";
    _CAAnimationType[_CAAnimationType["LightSpeedOut"] = 10] = "LightSpeedOut";
    _CAAnimationType[_CAAnimationType["Hinge"] = 11] = "Hinge";
    _CAAnimationType[_CAAnimationType["SlideInUp"] = 12] = "SlideInUp";
    _CAAnimationType[_CAAnimationType["SlideOutDown"] = 13] = "SlideOutDown";
    _CAAnimationType[_CAAnimationType["SlideInRight"] = 14] = "SlideInRight";
    _CAAnimationType[_CAAnimationType["SlideOutRight"] = 15] = "SlideOutRight";
    _CAAnimationType[_CAAnimationType["SlideInLeft"] = 16] = "SlideInLeft";
    _CAAnimationType[_CAAnimationType["SlideOutLeft"] = 17] = "SlideOutLeft";
    _CAAnimationType[_CAAnimationType["HorizontalOutFlip"] = 18] = "HorizontalOutFlip";
    _CAAnimationType[_CAAnimationType["HorizontalInFlip"] = 19] = "HorizontalInFlip";
    _CAAnimationType[_CAAnimationType["ZoomIn"] = 20] = "ZoomIn";
    _CAAnimationType[_CAAnimationType["ZoomInUp"] = 21] = "ZoomInUp";
    _CAAnimationType[_CAAnimationType["ZoomOut"] = 22] = "ZoomOut";
    _CAAnimationType[_CAAnimationType["BounceIn"] = 23] = "BounceIn";
    _CAAnimationType[_CAAnimationType["BounceOut"] = 24] = "BounceOut";
})(_CAAnimationType || (_CAAnimationType = {}));
// ANIMATION TYPES
function _CAClassListForAnimationType(type) {
    var array = [];
    array.push("animated");
    switch (type) {
        case _CAAnimationType.BeginSheet:
            array.push("slideInDown");
            break;
        case _CAAnimationType.EndSheet:
            array.push("slideOutUp");
            break;
        case _CAAnimationType.Push:
            array.push("slideInRight");
            break;
        case _CAAnimationType.Pop:
            array.push("slideOutRight");
            break;
        case _CAAnimationType.FadeIn:
            array.push("fadeIn");
            break;
        case _CAAnimationType.FadeOut:
            array.push("fadeOut");
            break;
        case _CAAnimationType.LightSpeedOut:
            array.push("lightSpeedOut");
            break;
        case _CAAnimationType.Hinge:
            array.push("hinge");
            break;
        case _CAAnimationType.SlideInUp:
            array.push("slideInUp");
            break;
        case _CAAnimationType.SlideOutDown:
            array.push("slideOutDown");
            break;
        case _CAAnimationType.SlideInRight:
            array.push("slideInRight");
            break;
        case _CAAnimationType.SlideOutRight:
            array.push("slideOutRight");
            break;
        case _CAAnimationType.SlideInLeft:
            array.push("slideInLeft");
            break;
        case _CAAnimationType.SlideOutLeft:
            array.push("slideOutLeft");
            break;
        case _CAAnimationType.HorizontalOutFlip:
            array.push("flipOutY");
            break;
        case _CAAnimationType.HorizontalInFlip:
            array.push("flipInY");
            break;
        case _CAAnimationType.ZoomIn:
            array.push("zoomIn");
            break;
        case _CAAnimationType.ZoomInUp:
            array.push("zoomInUp");
            break;
        case _CAAnimationType.ZoomOut:
            array.push("zoomOut");
            break;
        case _CAAnimationType.BounceIn:
            array.push("bounceIn");
            break;
        case _CAAnimationType.BounceOut:
            array.push("bounceOut");
            break;
    }
    return array;
}
function _CAAddAnimations(element, animations) {
    for (var index = 0; index < animations.length; index++)
        element.classList.add("animate__" + animations[index]);
}
function _CARemoveAnimations(element, animations) {
    for (var index = 0; index < animations.length; index++)
        element.classList.remove("animate__" + animations[index]);
}


/***/ }),

/***/ "./sources/CoreAnimation/CoreAnimation+ViewController.ts":
/*!***************************************************************!*\
  !*** ./sources/CoreAnimation/CoreAnimation+ViewController.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _CAAnimationDidFinish: () => (/* binding */ _CAAnimationDidFinish),
/* harmony export */   _CAAnimationStart: () => (/* binding */ _CAAnimationStart)
/* harmony export */ });
/* harmony import */ var _CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CoreAnimation+Animations */ "./sources/CoreAnimation/CoreAnimation+Animations.ts");

function _CAAnimationStart(layer, animationController, animationContext, completion) {
    if (animationController == null) {
        if (completion != null)
            completion();
        return;
    }
    var duration = animationController.transitionDuration(animationContext);
    var animations = animationController.animations(animationContext);
    animationController.animateTransition(animationContext);
    if (duration == 0 || animations == null) {
        // NO animation
        animationController.animationEnded(true);
        if (completion != null)
            completion();
        return;
    }
    var element = layer.contents;
    element.style.animationDuration = duration + "s";
    (0,_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_0__._CAAddAnimations)(element, animations);
    element.animationParams = {};
    element.animationParams["animationController"] = animationController;
    element.animationParams["animations"] = animations;
    if (completion != null)
        element.animationParams["completion"] = completion;
    element.addEventListener("animationend", _CAAnimationDidFinish);
}
function _CAAnimationDidFinish(event) {
    var animationController = event.target.animationParams["animationController"];
    var animations = event.target.animationParams["animations"];
    var completion = event.target.animationParams["completion"];
    var element = event.target;
    (0,_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_0__._CARemoveAnimations)(element, animations);
    element.removeEventListener("animationend", _CAAnimationDidFinish);
    animationController.animationEnded(true);
    if (completion != null)
        completion();
}


/***/ }),

/***/ "./sources/CoreAnimation/CoreAnimation.ts":
/*!************************************************!*\
  !*** ./sources/CoreAnimation/CoreAnimation.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/*
    ANIMATIONS
 */



/***/ }),

/***/ "./sources/CoreGraphics/CGContext.ts":
/*!*******************************************!*\
  !*** ./sources/CoreGraphics/CGContext.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CGContext: () => (/* binding */ CGContext)
/* harmony export */ });
var CGContext = /** @class */ (function () {
    function CGContext() {
    }
    return CGContext;
}());



/***/ }),

/***/ "./sources/CoreGraphics/CGPoint.ts":
/*!*****************************************!*\
  !*** ./sources/CoreGraphics/CGPoint.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CGPoint: () => (/* binding */ CGPoint)
/* harmony export */ });
var CGPoint = /** @class */ (function () {
    function CGPoint(x, y) {
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    CGPoint.Zero = function () {
        var p = new CGPoint(0, 0);
        return p;
    };
    return CGPoint;
}());



/***/ }),

/***/ "./sources/CoreGraphics/CGRect.ts":
/*!****************************************!*\
  !*** ./sources/CoreGraphics/CGRect.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CGRect: () => (/* binding */ CGRect),
/* harmony export */   NSRectMaxY: () => (/* binding */ NSRectMaxY),
/* harmony export */   NSRectMinY: () => (/* binding */ NSRectMinY)
/* harmony export */ });
/* harmony import */ var _CGPoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CGPoint */ "./sources/CoreGraphics/CGPoint.ts");
/* harmony import */ var _CGSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CGSize */ "./sources/CoreGraphics/CGSize.ts");


var CGRect = /** @class */ (function () {
    function CGRect() {
    }
    CGRect.zero = function () {
        var r = new CGRect();
        r.origin = _CGPoint__WEBPACK_IMPORTED_MODULE_0__.CGPoint.Zero();
        r.size = _CGSize__WEBPACK_IMPORTED_MODULE_1__.CGSize.Zero();
        return r;
    };
    CGRect.rectFromPointAndSize = function (p, s) {
        var rect = new CGRect();
        rect.origin = p;
        rect.size = s;
        return rect;
    };
    CGRect.rectFromValues = function (x, y, w, h) {
        var rect = new CGRect();
        rect.origin = new _CGPoint__WEBPACK_IMPORTED_MODULE_0__.CGPoint(x, y);
        rect.size = new _CGSize__WEBPACK_IMPORTED_MODULE_1__.CGSize(w, h);
        return rect;
    };
    return CGRect;
}());

function NSRectMaxY(rect) {
    return rect.origin.y;
}
function NSRectMinY(rect) {
    return rect.origin.y + rect.size.height;
}


/***/ }),

/***/ "./sources/CoreGraphics/CGSize.ts":
/*!****************************************!*\
  !*** ./sources/CoreGraphics/CGSize.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CGSize: () => (/* binding */ CGSize)
/* harmony export */ });
var CGSize = /** @class */ (function () {
    function CGSize(w, h) {
        this.width = 0;
        this.height = 0;
        this.width = w;
        this.height = h;
    }
    CGSize.Zero = function () {
        var s = new CGSize(0, 0);
        return s;
    };
    CGSize.prototype.isEqualTo = function (size) {
        if (this.width == size.width
            && this.height == size.height)
            return true;
        return false;
    };
    return CGSize;
}());



/***/ }),

/***/ "./sources/UIApplication.ts":
/*!**********************************!*\
  !*** ./sources/UIApplication.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIApplication: () => (/* binding */ UIApplication)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UIWindow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIWindow */ "./sources/UIWindow.ts");
/**
 * Created by godshadow on 11/3/16.
 */



var UIApplication = /** @class */ (function () {
    function UIApplication() {
        this.delegate = null;
        this.isMobile = false;
        this.defaultLanguage = null;
        this.currentLanguage = null;
        this.languages = null;
        this.ready = false;
        this.downloadCoreFileCount = 0;
        this._sheetViewController = null;
        this._sheetSize = null;
        //private _popUpMenuView = null;
        this._popUpMenu = null;
        this._popUpMenuControl = null;
        this._popOverWindow = null;
        this._popOverWindowFirstClick = false;
        this._popOverViewController = null;
        this._windows = [];
        this._keyWindow = null;
        this._mainWindow = null;
        this.mainStoryboard = null;
        if (UIApplication._sharedInstance != null) {
            throw new Error("UIWebApplication: Instantiation failed: Use sharedInstance() instead of new.");
        }
    }
    Object.defineProperty(UIApplication, "shared", {
        get: function () {
            if (UIApplication._sharedInstance == null) {
                UIApplication._sharedInstance = new UIApplication();
            }
            return UIApplication._sharedInstance;
        },
        enumerable: false,
        configurable: true
    });
    //TODO: Set language in the webworker also.
    UIApplication.prototype.setLanguage = function (lang, completion) {
        var languages = (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreGetLanguages)();
        if (languages == null) {
            completion();
            return;
        }
        var url = languages[lang];
        if (url == null) {
            completion();
            return;
        }
        (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreGetContentsFromURLString)(url, this, function (code, data) {
            if (code == 200) {
                (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOLocalizedStringsSet)(JSON.parse(data.replace(/(\r\n|\n|\r)/gm, "")));
            }
            completion();
        });
    };
    UIApplication.prototype.run = function (args) {
        var _this = this;
        (0,foundation__WEBPACK_IMPORTED_MODULE_0__._MIOBundleLoadBundles)("app.bundles.json", function (error) {
            if (error != null) {
                (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLog)(error);
                return;
            }
            // Get Languages from the app.plist
            var appPlistData = (0,foundation__WEBPACK_IMPORTED_MODULE_0__._MIOBundleAppGetResource)("Main", "app", "plist");
            if (appPlistData == null)
                throw new Error("We couldn't download the app.plist");
            var config = foundation__WEBPACK_IMPORTED_MODULE_0__.PropertyListSerialization.propertyListWithData(appPlistData, 0, 0, null);
            // Get Main story board
            // let mainStoryBoardFile = config["UIMainStoryboardFile"];
            // if (mainStoryBoardFile != null) {
            //     MIOCoreDownloadResource(mainStoryBoardFile, "json", this, function(data){
            //         this.mainStoryboard = new UIStoryboard();
            //         this.mainStoryboard.initWithName(mainStoryBoardFile, null);
            //         this.downloadLanguages(config);
            //     });
            var langs = config["Languages"];
            for (var key in langs) {
                var url = langs[key];
                (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreAddLanguage)(key, url);
            }
            var lang = (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreGetPlatformLanguage)();
            _this.setLanguage(lang, function () {
                var args = _this._parse_options();
                _this._run(args);
            });
        });
        // // Get App.plist
        // MIOCoreGetContentsFromURLString("app.plist", this, function(this:UIApplication, code:number, data:any) {
        //     if (data == null) throw new Error("We couldn't download the app.plist");
        //     let config = PropertyListSerialization.propertyListWithData(data, 0, 0, null);
        //     let mainStoryBoardFile = "layout/" + config["UIMainStoryboardFile"];
        //     // Get Main story board
        //     if (mainStoryBoardFile != null) {
        // //         MIOCoreBundleDownloadResource(mainStoryBoardFile, "json", this, function(data){
        // //             this.mainStoryboard = new UIStoryboard();
        // //             this.mainStoryboard.initWithName(mainStoryBoardFile, null);
        // //             this.downloadLanguages(config);
        // //         });
        //     }
        //     else {
        //         this.downloadLanguages(config);
        //     }
        // });
    };
    UIApplication.prototype._parse_options = function () {
        var url = (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreGetMainURLString)();
        var queryOptions = (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreGetQueryOptions)();
        var options = {};
        options["url"] = url;
        for (var index = 0; index < queryOptions.length; index++) {
            var op = queryOptions[index];
            var array = op.split("=");
            options[array[0]] = decodeURIComponent(array[1]);
        }
        return options;
    };
    UIApplication.prototype._run = function (args) {
        if (this.delegate.applicationDidFinishLaunchingWithOptions(this, args) == false) {
            (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLog)("Error in applicationDidFinishLaunchingWithOptions");
            return;
        }
        ;
        this._mainWindow = this.delegate.window;
        if (this._mainWindow == null) {
            var vc = this.mainStoryboard.instantiateInitialViewController();
            this.delegate.window = new _UIWindow__WEBPACK_IMPORTED_MODULE_2__.UIWindow();
            this.delegate.window.initWithRootViewController(vc);
            this._launchApp();
            // MUICoreBundleLoadNibName( this.initialResourceURLString, this, function(vc:UIViewController){
            //     this.delegate.window = new UIWindow();
            //     this.delegate.window.initWithRootViewController(vc);
            //     this._launchApp()
            // });
        }
        else
            this._launchApp();
    };
    UIApplication.prototype._launchApp = function () {
        var _this = this;
        this.delegate.window.makeKeyAndVisible();
        this.delegate.window.rootViewController.onLoadView(function () {
            var window = _this.delegate.window;
            window.addSubview(window.rootViewController.view);
            _this.delegate.window.rootViewController.viewWillAppear(false);
            _this.delegate.window.rootViewController.viewDidAppear(false);
            _this.ready = true;
            // MIOCoreEventRegisterObserverForType(MIOCoreEventType.Click, this, this._clickEvent);
            // MIOCoreEventRegisterObserverForType(MIOCoreEventType.Resize, this, this._resizeEvent);
        });
    };
    UIApplication.prototype.setLanguageURL = function (key, url) {
        if (this.languages == null)
            this.languages = {};
        this.languages[key] = url;
    };
    UIApplication.prototype.setDefaultLanguage = function (key) {
        this.defaultLanguage = key;
    };
    UIApplication.prototype.downloadLanguage = function (key, fn) {
        var url = this.languages[key];
        // Download
        var conn = new foundation__WEBPACK_IMPORTED_MODULE_0__.URLConnection();
        conn.initWithRequestBlock(foundation__WEBPACK_IMPORTED_MODULE_0__.URLRequest.requestWithURL(url), this, function (error, data) {
            if (data != null) {
                var json = JSON.parse(data.replace(/(\r\n|\n|\r)/gm, ""));
                // MIOCoreStringSetLocalizedStrings(json);
            }
            fn.call(this);
        });
    };
    UIApplication.prototype.showModalViewContoller = function (vc) {
        var w = new _UIWindow__WEBPACK_IMPORTED_MODULE_2__.UIWindow();
        w.initWithRootViewController(vc);
        // Add new window
        document.body.appendChild(vc.view.layer);
        //this.addWindow(w);
    };
    UIApplication.prototype.showMenuFromControl = function (control, menu) {
        if (this._popUpMenu != null) {
            if (menu.layerID != this._popUpMenu.layerID)
                this._popUpMenu.hide();
        }
        this._popUpMenuControl = control;
        this._popUpMenu = menu;
        this.delegate.window.addSubview(this._popUpMenu);
        var x = control.layer.getBoundingClientRect().left;
        var y = control.layer.getBoundingClientRect().top + control.layer.getBoundingClientRect().height;
        this._popUpMenu.setX(x);
        this._popUpMenu.setY(y);
        this._popUpMenu.layer.style.zIndex = 200;
        this._popUpMenu.layout();
    };
    UIApplication.prototype.hideMenu = function () {
        if (this._popUpMenu != null) {
            this._popUpMenu.removeFromSuperview();
            this._popUpMenu = null;
        }
    };
    // private _resizeEvent(event:MUICoreEvent) {        
    //     this.delegate.window.layoutSubviews();
    // }
    // private _clickEvent(event:MUICoreEventInput){
    //     let target = event.coreEvent.target;
    //     let x = event.x;
    //     let y = event.y;
    //     // Checking popup menus
    //     if (this._popUpMenu != null) {
    //         let controlRect = this._popUpMenuControl.layer.getBoundingClientRect();
    //         if ((x > controlRect.left && x < controlRect.right)
    //             && (y > controlRect.top && y < controlRect.bottom)) {
    //             // Nothing
    //         }
    //         else {
    //             this._popUpMenu.hide();
    //         }
    //     }
    //     // Checking windows
    //     if (this._keyWindow != null) {        
    //     //     let controlRect = this._keyWindow.layer.getBoundingClientRect();
    //     //     //console.log("x: " + controlRect.left + " mx: " + x);
    //     //     if ((x > controlRect.left && x < controlRect.right)
    //     //         && (y > controlRect.top && y < controlRect.bottom)) {
    //     //         //Nothing. Forward the event
    //     //     }
    //     //     else
    //     //         this._keyWindow._eventHappendOutsideWindow();
    //     }
    // }
    // setPopOverViewController(vc) {
    //     if (this._popOverViewController != null)
    //         this._popOverViewController.dismissViewController(true);
    //     this._popOverViewController = vc;
    // }
    // showPopOverControllerFromRect(vc, frame) {
    //     if (this._popOverWindow != null) {
    //         this.hidePopOverController();
    //     }
    //     if (this._popOverWindow == null) {
    //         this._popOverWindow = new UIWindow("popover_window");
    //         this._popOverWindow.initWithRootViewController(vc.popoverPresentationController());
    //         //this._popOverWindow.layer.style.border = "2px solid rgb(170, 170, 170)";
    //         this._popOverWindow.setFrame(vc.popoverPresentationController().frame);
    //         //this.addWindow(this._popOverWindow);
    //     }
    //     this._popOverWindow.rootViewController.onLoadView(this, function () {
    //         this._popOverWindow.rootViewController.viewWillAppear(true);
    //         this._popOverWindow.rootViewController.viewDidAppear(true);
    //     });
    //     this._popOverWindowFirstClick = true;
    // }
    // hidePopOverController() {
    //     this._popOverWindow.rootViewController.viewWillDisappear(true);
    //     this._popOverWindow.removeFromSuperview();
    //     this._popOverWindow.rootViewController.viewDidDisappear(true);
    //     this._popOverWindow = null;
    // }
    // addWindow(window:UIWindow){
    //     this._windows.push(window);
    // }
    // private windowZIndexOffset = 0;
    UIApplication.prototype.makeKeyWindow = function (window) {
        if (this._keyWindow === window)
            return;
        if (this._keyWindow != null) {
            this._keyWindow._resignKeyWindow();
            //this.windowZIndexOffset -= 10;
        }
        //this.addWindow(window);
        this._keyWindow = window;
        //window.layer.style.zIndex = this.windowZIndexOffset;
        //this.windowZIndexOffset += 10;
    };
    return UIApplication;
}());



/***/ }),

/***/ "./sources/UIApplicationDelegate.ts":
/*!******************************************!*\
  !*** ./sources/UIApplicationDelegate.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./sources/UIApplicationMain.ts":
/*!**************************************!*\
  !*** ./sources/UIApplicationMain.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIApplicationMain: () => (/* binding */ UIApplicationMain)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _UIApplication__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIApplication */ "./sources/UIApplication.ts");


function UIApplicationMain(argc, argv, principalClassName, delegateClassName) {
    var delegate = (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSClassFromString)(delegateClassName);
    _UIApplication__WEBPACK_IMPORTED_MODULE_1__.UIApplication.shared.delegate = delegate;
    _UIApplication__WEBPACK_IMPORTED_MODULE_1__.UIApplication.shared.run(argv);
    return 0;
}


/***/ }),

/***/ "./sources/UIBarButtonItem.ts":
/*!************************************!*\
  !*** ./sources/UIBarButtonItem.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIBarButtonItem: () => (/* binding */ UIBarButtonItem),
/* harmony export */   UIBarButtonSystemItem: () => (/* binding */ UIBarButtonSystemItem)
/* harmony export */ });
/* harmony import */ var _UIBarItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIBarItem */ "./sources/UIBarItem.ts");
/* harmony import */ var _UIButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIButton */ "./sources/UIButton.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/// <reference path="UIBarItem.ts" />
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var UIBarButtonSystemItem;
(function (UIBarButtonSystemItem) {
    UIBarButtonSystemItem[UIBarButtonSystemItem["Done"] = 0] = "Done";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Cancel"] = 1] = "Cancel";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Edit"] = 2] = "Edit";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Save"] = 3] = "Save";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Add"] = 4] = "Add";
    UIBarButtonSystemItem[UIBarButtonSystemItem["FlexibleSpace"] = 5] = "FlexibleSpace";
    UIBarButtonSystemItem[UIBarButtonSystemItem["FixedSpace"] = 6] = "FixedSpace";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Compose"] = 7] = "Compose";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Reply"] = 8] = "Reply";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Action"] = 9] = "Action";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Organize"] = 10] = "Organize";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Bookmarks"] = 11] = "Bookmarks";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Search"] = 12] = "Search";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Refresh"] = 13] = "Refresh";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Stop"] = 14] = "Stop";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Camera"] = 15] = "Camera";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Trash"] = 16] = "Trash";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Play"] = 17] = "Play";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Pause"] = 18] = "Pause";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Rewind"] = 19] = "Rewind";
    UIBarButtonSystemItem[UIBarButtonSystemItem["FastForward"] = 20] = "FastForward";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Undo"] = 21] = "Undo";
    UIBarButtonSystemItem[UIBarButtonSystemItem["Redo"] = 22] = "Redo";
})(UIBarButtonSystemItem || (UIBarButtonSystemItem = {}));
var UIBarButtonItem = /** @class */ (function (_super) {
    __extends(UIBarButtonItem, _super);
    function UIBarButtonItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.layer = null;
        _this.owner = null;
        _this.customView = null;
        return _this;
    }
    UIBarButtonItem.prototype.initWithCustomView = function (view) {
        _super.prototype.init.call(this);
        this.customView = view;
    };
    UIBarButtonItem.prototype.initWithBarButtonSystemItem = function (systemItem, target, action) {
        _super.prototype.init.call(this);
        var button = new _UIButton__WEBPACK_IMPORTED_MODULE_1__.UIButton();
        button.init();
        // MUICoreLayerAddStyle(button.layer, "system-" + UIBarButtonSystemItem[systemItem] + "-icon");
        this.customView = button;
    };
    UIBarButtonItem.prototype.initWithLayer = function (layer, owner) {
        _super.prototype.init.call(this);
        this.layer = layer;
        this.owner = owner;
        var button = new _UIButton__WEBPACK_IMPORTED_MODULE_1__.UIButton();
        button.init();
        button.owner = owner;
        var systemStyle = layer.getAttribute("data-bar-button-item-system");
        // if (systemStyle != null) MUICoreLayerAddStyle(button.layer, "system-" + systemStyle + "-icon");
        var imageStyle = layer.getAttribute("data-bar-button-item-image");
        if (imageStyle != null)
            button.setImageURL("assets/" + imageStyle + ".png");
        var titleStyle = layer.getAttribute("data-bar-button-item-title");
        if (titleStyle != null) {
            button.setTitle(titleStyle);
            // button.layer.style.position = "absolute";
            // button.layer.style.left = "10px";
            // button.layer.style.top = "15px";
        }
        if (layer.childNodes.length > 0) {
            for (var index = 0; index < layer.childNodes.length; index++) {
                var subLayer = layer.childNodes[index];
                if (subLayer.tagName != "DIV" && subLayer.tagName != "SECTION")
                    continue;
                if (subLayer.getAttribute("data-action-selector")) {
                    var action = subLayer.getAttribute("data-action-selector");
                    this.target = owner;
                    this.action = owner[action];
                    button.addTarget(this.target, this.action, _UIControl__WEBPACK_IMPORTED_MODULE_2__.UIControl.Event.touchUpInside);
                }
                else if (subLayer.getAttribute("data-connections") == "true") {
                    var obj = this;
                    //if (options != null && options["Object"] != null) obj = options["Object"];
                    // MUICoreStoryboardParseConnectionsLayer(subLayer, button, owner);
                    continue;
                }
            }
        }
        this.customView = button;
    };
    return UIBarButtonItem;
}(_UIBarItem__WEBPACK_IMPORTED_MODULE_0__.UIBarItem));



/***/ }),

/***/ "./sources/UIBarItem.ts":
/*!******************************!*\
  !*** ./sources/UIBarItem.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIBarItem: () => (/* binding */ UIBarItem)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIBarItem = /** @class */ (function (_super) {
    __extends(UIBarItem, _super);
    function UIBarItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UIBarItem;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIButton.ts":
/*!*****************************!*\
  !*** ./sources/UIButton.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIButton: () => (/* binding */ UIButton),
/* harmony export */   UIButtonType: () => (/* binding */ UIButtonType)
/* harmony export */ });
/* harmony import */ var _CoreAnimation_CAButtonLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CoreAnimation/CAButtonLayer */ "./sources/CoreAnimation/CAButtonLayer.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/**
 * Created by godshadow on 12/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UIButtonType;
(function (UIButtonType) {
    UIButtonType[UIButtonType["MomentaryPushIn"] = 0] = "MomentaryPushIn";
    UIButtonType[UIButtonType["PushOnPushOff"] = 1] = "PushOnPushOff";
    UIButtonType[UIButtonType["PushIn"] = 2] = "PushIn";
})(UIButtonType || (UIButtonType = {}));
var UIButton = /** @class */ (function (_super) {
    __extends(UIButton, _super);
    function UIButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._statusStyle = null;
        _this._titleStatusStyle = null;
        _this._titleLayer = null;
        _this._imageStatusStyle = null;
        _this._imageLayer = null;
        _this._type = UIButtonType.MomentaryPushIn;
        return _this;
    }
    Object.defineProperty(UIButton.prototype, "type", {
        get: function () { return this._type; },
        set: function (value) { this._type = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIButton, "layerClass", {
        get: function () { return _CoreAnimation_CAButtonLayer__WEBPACK_IMPORTED_MODULE_0__.CAButtonLayer; },
        enumerable: false,
        configurable: true
    });
    UIButton.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        var type = coder.decodeIntegerForKey("type");
        switch (type) {
            case "MomentaryPushIn":
                this.type = UIButtonType.MomentaryPushIn;
                break;
            case "PushOnPushOff":
                this.type = UIButtonType.PushOnPushOff;
                break;
            case "PushIn":
                this.type = UIButtonType.PushIn;
                break;
        }
    };
    //
    // Event handling
    //
    UIButton.prototype.touchesBeginWithEvent = function (touches, event) {
        switch (this.type) {
            case UIButtonType.MomentaryPushIn:
            case UIButtonType.PushIn:
                this.setSelected(true);
                break;
            case UIButtonType.PushOnPushOff:
                this.setSelected(!this.selected);
                break;
        }
    };
    UIButton.prototype.touchesEndedWithEvent = function (touches, event) {
        _super.prototype.touchesEndedWithEvent.call(this, touches, event);
        if (this.type == UIButtonType.MomentaryPushIn)
            this.setSelected(false);
    };
    //
    // Properties
    //
    UIButton.prototype.setTitle = function (title) {
        this.layer.title = title;
    };
    Object.defineProperty(UIButton.prototype, "title", {
        get: function () { return this.layer.title; },
        set: function (title) { this.setTitle(title); },
        enumerable: false,
        configurable: true
    });
    UIButton.prototype.setTitleColorFor = function (color) {
        this._titleLayer.style.color = "#" + color.hex;
    };
    UIButton.prototype.setImageURL = function (urlString) {
        if (urlString != null) {
            this._imageLayer.setAttribute("src", urlString);
        }
        else {
            this._imageLayer.removeAttribute("src");
        }
    };
    return UIButton;
}(_UIControl__WEBPACK_IMPORTED_MODULE_1__.UIControl));



/***/ }),

/***/ "./sources/UICheckButton.ts":
/*!**********************************!*\
  !*** ./sources/UICheckButton.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICheckButton: () => (/* binding */ UICheckButton)
/* harmony export */ });
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/**
 * Created by godshadow on 12/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UICheckButton = /** @class */ (function (_super) {
    __extends(UICheckButton, _super);
    function UICheckButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.target = null;
        _this.action = null;
        _this._on = false;
        return _this;
    }
    // init(){
    //     super.init();
    //     MUICoreLayerAddStyle(this.layer, "checkbox"); 
    // }
    // initWithLayer(layer, owner, options?){
    //     super.initWithLayer(layer, owner, options);        
    //     this.layer.addEventListener("click", this._on_click.bind(this), false);
    // }
    // private _on_click(ev:Event){
    //     if (this.enabled) {
    //         this.toggleValue();
    //     }
    // }
    // setOnChangeValue(target, action){
    //     this.target = target;
    //     this.action = action;
    // }
    UICheckButton.prototype.touchesBeganWithEvent = function (touches, event) {
        _super.prototype.touchesBeganWithEvent.call(this, touches, event);
        this.toggleValue();
    };
    Object.defineProperty(UICheckButton.prototype, "on", {
        get: function () {
            return this._on;
        },
        set: function (value) {
            this.setOn(value);
        },
        enumerable: false,
        configurable: true
    });
    UICheckButton.prototype.setOn = function (on) {
        this._on = on;
        this.selected = on;
    };
    UICheckButton.prototype.toggleValue = function () {
        this.setOn(!this._on);
    };
    return UICheckButton;
}(_UIControl__WEBPACK_IMPORTED_MODULE_0__.UIControl));



/***/ }),

/***/ "./sources/UICollectionView.ts":
/*!*************************************!*\
  !*** ./sources/UICollectionView.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICollectionView: () => (/* binding */ UICollectionView),
/* harmony export */   UICollectionViewCell: () => (/* binding */ UICollectionViewCell),
/* harmony export */   UICollectionViewSection: () => (/* binding */ UICollectionViewSection)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _UICollectionViewLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UICollectionViewLayout */ "./sources/UICollectionViewLayout.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _CoreAnimation_CACollectionLayer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreAnimation/CACollectionLayer */ "./sources/CoreAnimation/CACollectionLayer.ts");
/* harmony import */ var _UITapGestureRecognizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./UITapGestureRecognizer */ "./sources/UITapGestureRecognizer.ts");
/* harmony import */ var _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./UIGestureRecognizer */ "./sources/UIGestureRecognizer.ts");
/**
 * Created by godshadow on 09/11/2016.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __setFunctionName = (undefined && undefined.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};






var UICollectionViewCell = /** @class */ (function (_super) {
    __extends(UICollectionViewCell, _super);
    function UICollectionViewCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UICollectionViewCell.prototype, "selected", {
        set: function (value) {
            if (value == true) {
                this.layer.addStyle("selected");
            }
            else {
                this.layer.removeStyle("selected");
            }
        },
        enumerable: false,
        configurable: true
    });
    return UICollectionViewCell;
}(_UIView__WEBPACK_IMPORTED_MODULE_2__.UIView));

var UICollectionViewSection = /** @class */ (function (_super) {
    __extends(UICollectionViewSection, _super);
    function UICollectionViewSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.header = null;
        _this.footer = null;
        _this.cells = [];
        return _this;
    }
    return UICollectionViewSection;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));

var UICollectionView = /** @class */ (function (_super) {
    __extends(UICollectionView, _super);
    function UICollectionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSource = null;
        _this.delegate = null;
        _this._collectionViewLayout = null;
        _this._cellPrototypes = {};
        // private _supplementaryViews = {};
        _this._sections = [];
        _this.selectedIndexPath = null;
        _this.contentView = null;
        return _this;
    }
    Object.defineProperty(UICollectionView, "layerClass", {
        get: function () { return _CoreAnimation_CACollectionLayer__WEBPACK_IMPORTED_MODULE_3__.CACollectionLayer; },
        enumerable: false,
        configurable: true
    });
    UICollectionView.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this.contentView = new _UIView__WEBPACK_IMPORTED_MODULE_2__.UIView();
        this.contentView.init();
        this.addSubview(this.contentView);
    };
    Object.defineProperty(UICollectionView.prototype, "collectionViewLayout", {
        get: function () {
            if (this._collectionViewLayout == null) {
                this._collectionViewLayout = new _UICollectionViewLayout__WEBPACK_IMPORTED_MODULE_1__.UICollectionViewFlowLayout();
                this._collectionViewLayout.init();
            }
            return this._collectionViewLayout;
        },
        set: function (layout) {
            //TODO: Set animations for changing layout
            layout.collectionView = this;
            this._collectionViewLayout = layout;
            layout.invalidateLayout();
        },
        enumerable: false,
        configurable: true
    });
    UICollectionView.prototype.registerClassForCellWithReuseIdentifier = function (classname, identifier) {
        var item = {};
        item["class"] = classname;
        //item["layer"] = null;
        this._cellPrototypes[identifier] = item;
    };
    UICollectionView.prototype.registerClassForSupplementaryViewWithReuseIdentifier = function (viewClass, identifier) {
        //TODO:
    };
    UICollectionView.prototype.dequeueReusableCellWithReuseIdentifierFor = function (identifier, indexPath) {
        var view = this.layer.newCellViewByIdentifier(identifier);
        var tapGesture = new _UITapGestureRecognizer__WEBPACK_IMPORTED_MODULE_4__.UITapGestureRecognizer();
        tapGesture.initWithTarget(this, this._cellDidTap);
        view.addGestureRecognizer(tapGesture);
        return view;
        // //instance creation here
        // let className = item["class"];
        // let cell = NSClassFromString(className);
        // cell.constructor.apply(cell);
        //cell.init();
        // let layer = item["layer"];
        // if (layer != null) {
        //     let newLayer = layer.cloneNode(true);
        //     newLayer.style.display = "";
        //     let layerID = newLayer.getAttribute("id");
        //     if (layerID != null) cell._outlets[layerID] = cell;    
        //     cell.initWithLayer(newLayer, cell);
        //     cell.awakeFromHTML();
        // }
        // else {
        //     cell.init();
        // }
        // else {
        //     let cells = item["cells"];
        //     if (cells == null) {
        //         cells = [];
        //         item["cells"] = cells;
        //     }
        //     cells.push(cell);
        // }
        // return v;
    };
    UICollectionView.prototype.dequeueReusableSupplementaryViewWithReuseIdentifier = function (identifier) {
        // let item = this._supplementaryViews[identifier];
        var view = this.layer.newSupplementaryViewByIdentifier(identifier, this);
        return view;
        // //view.init();
        // var layer = item["layer"];
        // if (layer != null) {
        //     var newLayer = layer.cloneNode(true);
        //     newLayer.style.display = "";
        //     // var size = item["size"];
        //     // if (size != null) {
        //     //     view.setWidth(size.width);
        //     //     view.layer.style.width = "100%";
        //     //     view.setHeight(size.height);
        //     // }
        //     // var bg = item["bg"];
        //     // if (bg != null) {
        //     //     view.layer.style.background = bg;
        //     // }
        //     view.initWithLayer(newLayer);
        //     //view._addLayerToDOM();
        //     view.awakeFromHTML();
        // }
        // else {
        //     var views = item["views"];
        //     if (views == null) {
        //         views = [];
        //         item["views"] = views;
        //     }
        //     views.push(view);
        // }
        // return v;
    };
    UICollectionView.prototype.cellAtIndexPath = function (indexPath) {
        var s = this._sections[indexPath.section];
        var c = s.cells[indexPath.row];
        return c;
    };
    UICollectionView.prototype.reloadData = function () {
        if (this.dataSource == null)
            return;
        // Remove all subviews
        for (var index = 0; index < this._sections.length; index++) {
            var sectionView = this._sections[index];
            if (sectionView.header != null)
                sectionView.header.removeFromSuperview();
            if (sectionView.footer != null)
                sectionView.footer.removeFromSuperview();
            for (var count = 0; count < sectionView.cells.length; count++) {
                var cell = sectionView.cells[count];
                cell.removeFromSuperview();
                if (this.delegate != null) {
                    if (typeof this.delegate.didEndDisplayingCellAtIndexPath === "function") {
                        var ip = foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(count, index);
                        this.delegate.didEndDisplayingCellAtIndexPath(this, cell, ip);
                    }
                }
            }
            sectionView.cells = [];
        }
        this.selectedIndexPath = null;
        this._sections = [];
        var sections = 1;
        if (typeof this.dataSource.numberOfSections === "function")
            sections = this.dataSource.numberOfSections(this);
        for (var sectionIndex = 0; sectionIndex < sections; sectionIndex++) {
            var section = new UICollectionViewSection();
            section.init();
            this._sections.push(section);
            if (typeof this.dataSource.viewForSupplementaryViewAtIndex === "function") {
                var hv = this.dataSource.viewForSupplementaryViewAtIndex(this, "header", sectionIndex);
                section.header = hv;
                if (hv != null)
                    this.contentView.addSubview(hv);
            }
            var items = this.dataSource.numberOfItemsInSection(this, sectionIndex);
            for (var index = 0; index < items; index++) {
                var ip = foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(index, sectionIndex);
                var cell = this.dataSource.cellForItemAtIndexPath(this, ip);
                section.cells.addObject(cell);
                this.contentView.addSubview(cell);
                // TODO: Don't save in the cell. Find a better way
                cell._indexPath = ip;
            }
            if (typeof this.dataSource.viewForSupplementaryViewAtIndex === "function") {
                var fv = this.dataSource.viewForSupplementaryViewAtIndex(this, "footer", sectionIndex);
                section.footer = fv;
                if (fv != null)
                    this.contentView.addSubview(fv);
            }
        }
        this.collectionViewLayout.invalidateLayout();
        this.setNeedsDisplay();
    };
    UICollectionView.prototype._cellDidTap = function (gestureRecognizer) {
        if (gestureRecognizer.state != _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_5__.UIGestureRecognizerState.Ended)
            return;
        var cell = gestureRecognizer.view;
        var ip = cell._indexPath;
        var canSelectCell = true;
        // if (this.selectedCellIndex == index && this.selectedCellSection == section)
        //     return;
        if (this.delegate != null && typeof this.delegate.canSelectCellAtIndexPath === "function") {
            canSelectCell = this.delegate.canSelectCellAtIndexPath(this, ip);
        }
        if (canSelectCell == false)
            return;
        if (this.selectedIndexPath != null) {
            this.deselectCellAtIndexPath(this.selectedIndexPath);
        }
        this.selectCellAtIndexPath(ip);
        if (this.delegate != null) {
            if (typeof this.delegate.didSelectCellAtIndexPath === "function") {
                this.delegate.didSelectCellAtIndexPath(this, ip);
            }
        }
    };
    UICollectionView.prototype.selectCellAtIndexPath = function (indexPath) {
        this.selectedIndexPath = indexPath;
        var cell = this._sections[indexPath.section].cells[indexPath.item];
        cell.selected = true;
    };
    UICollectionView.prototype.deselectCellAtIndexPath = function (indexPath) {
        this.selectedIndexPath = null;
        var cell = this._sections[indexPath.section].cells[indexPath.row];
        cell.selected = false;
    };
    /*
    layoutSubviews() {

        if (this.hidden == true) return;
        // if (this._needDisplay == false) return;
        // this._needDisplay = false;

        if (this._sections == null)
            return;

        // var x = this.collectionViewLayout.sectionInset.left;
        // var y = this.collectionViewLayout.sectionInset.top;

        // TODO: Check margins
        let x = 0;
        let y = 0;

        for (let count = 0; count < this._sections.length; count++)
        {
            let section = this._sections[count];
            x = this.collectionViewLayout.sectionInset.left;

            // Add header view
            if (section.header != null)
            {
                section.header.setY(y);
                let offsetY = section.header.getHeight();
                if (offsetY <= 0) offsetY = 23;
                y += offsetY + this.collectionViewLayout.headerReferenceSize.height;
            }

            // Add cells
            let maxX = this.getWidth() - this.collectionViewLayout.sectionInset.right;
            for (let index = 0; index < section.cells.length; index++) {

                let cell = section.cells[index] as UICollectionViewCell;
                if (this.delegate != null) {
                    if (typeof this.delegate.willDisplayCellAtIndexPath === "function")
                        this.delegate.willDisplayCellAtIndexPath(this, cell, IndexPath.indexForRowInSection( index, count ) );
                }

                cell.setWidth(this.collectionViewLayout.itemSize.width);
                cell.setHeight(this.collectionViewLayout.itemSize.height);

                cell.setX(x);
                cell.setY(y);

                cell.setNeedsDisplay();

                x += this.collectionViewLayout.itemSize.width + this.collectionViewLayout.minimumInteritemSpacing;
                // if (x >= maxX) {
                //     x = this.collectionViewLayout.sectionInset.left;
                //     y += this.collectionViewLayout.itemSize.height;
                //     y += this.collectionViewLayout.minimumLineSpacing;
                // }
            }

            //y += this.collectionViewLayout.minimumLineSpacing;

            // Add footer view
            if (section.footer != null)
            {
                section.footer.setY(y);
                let offsetY = section.footer.getHeight();
                if (offsetY <= 0) offsetY = 23;
                y += offsetY + this.collectionViewLayout.footerReferenceSize.height;
            }
        }
    }

    */
    UICollectionView.prototype.scrollToItemAtAtAnimated = function (indexPath, scrollPosition, animated) {
    };
    var _a;
    UICollectionView.ScrollPosition = (_a = /** @class */ (function () {
            function class_1() {
            }
            return class_1;
        }()),
        __setFunctionName(_a, "ScrollPosition"),
        _a.top = 1 << 0,
        _a.centeredVertically = 1 << 1,
        _a.bottom = 1 << 2,
        _a.left = 1 << 3,
        _a.centeredHorizontally = 1 << 4,
        _a.right = 1 << 5,
        _a);
    return UICollectionView;
}(_UIView__WEBPACK_IMPORTED_MODULE_2__.UIView));



/***/ }),

/***/ "./sources/UICollectionViewLayout.ts":
/*!*******************************************!*\
  !*** ./sources/UICollectionViewLayout.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICollectionViewFlowLayout: () => (/* binding */ UICollectionViewFlowLayout),
/* harmony export */   UICollectionViewLayout: () => (/* binding */ UICollectionViewLayout)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _UIEdgeInsets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIEdgeInsets */ "./sources/UIEdgeInsets.ts");
/* harmony import */ var _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreGraphics/CGSize */ "./sources/CoreGraphics/CGSize.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var UICollectionViewLayout = /** @class */ (function (_super) {
    __extends(UICollectionViewLayout, _super);
    function UICollectionViewLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.collectionView = null;
        _this.minimumLineSpacing = 0;
        _this.minimumInteritemSpacing = 0;
        _this.itemSize = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize(0, 0);
        _this.estimatedItemSize = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize(0, 0);
        _this.sectionInset = null;
        _this.headerReferenceSize = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize(0, 0);
        _this.footerReferenceSize = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize(0, 0);
        return _this;
    }
    UICollectionViewLayout.prototype.init = function () {
        _super.prototype.init.call(this);
        this.sectionInset = new _UIEdgeInsets__WEBPACK_IMPORTED_MODULE_1__.UIEdgeInsets();
        this.sectionInset.init();
    };
    UICollectionViewLayout.prototype.initWithLayer = function (layer, owner, options) {
        this.sectionInset = new _UIEdgeInsets__WEBPACK_IMPORTED_MODULE_1__.UIEdgeInsets();
        this.sectionInset.init();
        if (layer.childNodes.length > 0) {
            for (var index = 0; index < layer.childNodes.length; index++) {
                var subLayer = layer.childNodes[index];
                if (subLayer.tagName != "DIV")
                    continue;
                if (subLayer.getAttribute("data-key") != null) {
                    this.setKeyValueFromLayer(subLayer);
                    subLayer.style.display = "none";
                }
            }
        }
    };
    UICollectionViewLayout.prototype.setKeyValueFromLayer = function (layer) {
        var key = layer.getAttribute("data-key");
        var type = layer.getAttribute("data-type");
        if (type == "size") {
            var width = layer.getAttribute("data-width");
            var heigth = layer.getAttribute("data-height");
            var size = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize(parseFloat(width), parseFloat(heigth));
            this[key] = size;
        }
    };
    UICollectionViewLayout.prototype.invalidateLayout = function () { };
    Object.defineProperty(UICollectionViewLayout.prototype, "collectionViewContentSize", {
        get: function () { return _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize.Zero(); },
        enumerable: false,
        configurable: true
    });
    UICollectionViewLayout.prototype.layoutAttributesForItemAtIndexPath = function (indexPath) { return null; };
    ;
    UICollectionViewLayout.prototype.prepareForCollectionViewUpdates = function (updateItems) { };
    UICollectionViewLayout.prototype.initialLayoutAttributesForAppearingItemAtIndexPath = function (itemIndexPath) { return null; };
    UICollectionViewLayout.prototype.finalLayoutAttributesForDisappearingItemAtIndexPath = function (itemIndexPath) { return null; };
    UICollectionViewLayout.prototype.finalizeCollectionViewUpdates = function () { };
    return UICollectionViewLayout;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));

var MIOCollectionViewScrollDirection;
(function (MIOCollectionViewScrollDirection) {
    MIOCollectionViewScrollDirection[MIOCollectionViewScrollDirection["Vertical"] = 0] = "Vertical";
    MIOCollectionViewScrollDirection[MIOCollectionViewScrollDirection["Horizontal"] = 1] = "Horizontal";
})(MIOCollectionViewScrollDirection || (MIOCollectionViewScrollDirection = {}));
var UICollectionViewFlowLayout = /** @class */ (function (_super) {
    __extends(UICollectionViewFlowLayout, _super);
    function UICollectionViewFlowLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollDirection = MIOCollectionViewScrollDirection.Vertical;
        return _this;
    }
    UICollectionViewFlowLayout.prototype.init = function () {
        _super.prototype.init.call(this);
        this.minimumLineSpacing = 10;
        this.minimumInteritemSpacing = 10;
        this.itemSize = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_2__.CGSize(50, 50);
    };
    UICollectionViewFlowLayout.prototype.initWithLayer = function (layer, owner, options) {
        _super.prototype.initWithLayer.call(this, layer, owner, options);
        var direction = layer.getAttribute("data-collection-view-layout-direction");
        if (direction == "horizontal")
            this.scrollDirection = MIOCollectionViewScrollDirection.Horizontal;
        else if (direction == "vertical")
            this.scrollDirection = MIOCollectionViewScrollDirection.Vertical;
    };
    return UICollectionViewFlowLayout;
}(UICollectionViewLayout));



/***/ }),

/***/ "./sources/UICollectionViewLayoutAttributes.ts":
/*!*****************************************************!*\
  !*** ./sources/UICollectionViewLayoutAttributes.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICollectionViewLayoutAttributes: () => (/* binding */ UICollectionViewLayoutAttributes)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UICollectionViewLayoutAttributes = /** @class */ (function (_super) {
    __extends(UICollectionViewLayoutAttributes, _super);
    function UICollectionViewLayoutAttributes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.indexPath = null;
        return _this;
    }
    return UICollectionViewLayoutAttributes;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UICollectionViewUpdateItem.ts":
/*!***********************************************!*\
  !*** ./sources/UICollectionViewUpdateItem.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICollectionViewUpdateItem: () => (/* binding */ UICollectionViewUpdateItem)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UICollectionViewUpdateItem = /** @class */ (function (_super) {
    __extends(UICollectionViewUpdateItem, _super);
    function UICollectionViewUpdateItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UICollectionViewUpdateItem;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIColor.ts":
/*!****************************!*\
  !*** ./sources/UIColor.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIColor: () => (/* binding */ UIColor)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Created by godshadow on 11/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIColor = /** @class */ (function (_super) {
    __extends(UIColor, _super);
    function UIColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UIColor.prototype.initWithRedGreenBlue = function (red, green, blue, alpha) {
    };
    UIColor.prototype.initDisplayP3RedCGFloatGreenCGFloatBlueCGFloatAlphaCGFloat = function (r, g, b, a) {
        var rS = r.toString(16);
        if (rS.length < 2)
            rS = '0' + rS;
        var gS = g.toString(16);
        if (gS.length < 2)
            gS = '0' + gS;
        var bS = b.toString(16);
        if (bS.length < 2)
            bS = '0' + bS;
        var aS = Math.floor(a * 255).toString(16);
        if (aS.length < 2)
            aS = '0' + aS;
        this.hex = rS + gS + bS + aS;
    };
    Object.defineProperty(UIColor, "white", {
        get: function () {
            var c = new UIColor();
            c.initWithRedGreenBlue(255, 255, 255, 1);
            return c;
        },
        enumerable: false,
        configurable: true
    });
    return UIColor;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIControl.ts":
/*!******************************!*\
  !*** ./sources/UIControl.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIControl: () => (/* binding */ UIControl)
/* harmony export */ });
/* harmony import */ var _UIStoryboardSegue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIStoryboardSegue */ "./sources/UIStoryboardSegue.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _UIViewController__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIViewController */ "./sources/UIViewController.ts");
/* harmony import */ var _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreAnimation/CALayer */ "./sources/CoreAnimation/CALayer.ts");
/**
 * Created by godshadow on 12/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __setFunctionName = (undefined && undefined.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};




function MUICoreControlParseEventTypeString(eventTypeString) {
    if (eventTypeString == null)
        return UIControl.Event.allEvents;
    var value = eventTypeString[0].toUpperCase() + eventTypeString.substr(1);
    return UIControl.Event[value];
}
var UIControl = /** @class */ (function (_super) {
    __extends(UIControl, _super);
    function UIControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionSegue = null;
        _this.actionEvents = [];
        _this._selected = false;
        // TODO: Make delegation of the methods above
        _this.mouseOverTarget = null;
        _this.mouseOverAction = null;
        _this.mouseOutTarget = null;
        _this.mouseOutAction = null;
        return _this;
    }
    Object.defineProperty(UIControl, "layerClass", {
        get: function () { return _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_3__.CALayer; },
        enumerable: false,
        configurable: true
    });
    UIControl.prototype.init = function () {
        _super.prototype.init.call(this);
        this._userInteraction = true;
    };
    UIControl.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this._selected = coder.decodeIntegerForKey("selected");
        this._userInteraction = true;
    };
    UIControl.prototype._checkSegues = function () {
        _super.prototype._checkSegues.call(this);
        for (var index = 0; index < this._segues.length; index++) {
            var s = this._segues[index];
            var kind = s["Kind"];
            if (kind == "show") {
                if ((this.owner instanceof _UIViewController__WEBPACK_IMPORTED_MODULE_2__.UIViewController) == false)
                    continue;
                this.actionSegue = {};
                this.actionSegue["VC"] = this.owner;
                this.actionSegue["Destination"] = s["Destination"];
                var identifier = s["Identifier"];
                if (identifier != null)
                    this.actionSegue["Identifier"] = identifier;
                this.addTarget(this, function () {
                    var fromVC = this.actionSegue["VC"];
                    var destination = this.actionSegue["Destination"];
                    var identifier = this.actionSegue["Identifier"];
                    var toVC = fromVC.storyboard._instantiateViewControllerWithDestination(destination);
                    var segue = new _UIStoryboardSegue__WEBPACK_IMPORTED_MODULE_0__.UIStoryboardSegue();
                    segue.initWithIdentifierAndPerformHandler(identifier, fromVC, toVC, function () {
                        fromVC.navigationController.pushViewController(toVC);
                    });
                    segue._sender = this;
                    segue.perform();
                }, UIControl.Event.allEvents);
            }
        }
    };
    UIControl.prototype.addTarget = function (target, action, controlEvents /*UIControl.Event */) {
        if (this.userInteraction == false) {
            return;
        }
        if (action == null)
            throw new Error("UIControl: Can't add a null action");
        var item = {};
        item["Target"] = target;
        item["Action"] = action;
        item["EventType"] = controlEvents;
        this.actionEvents.addObject(item);
        this.layer.registerEventAction(this, this.on_event);
        // if ( this.layer instanceof CAControlLayer) {
        //     this.layer.registerEventBlock( ( event: any) => {
        //         this.sendActions( event );
        //     });
        // }
    };
    UIControl.prototype.sendAction = function (action, target, event) {
        action.call(target, this);
    };
    UIControl.prototype.sendActions = function (controlEvents) {
        for (var _i = 0, _c = this.actionEvents; _i < _c.length; _i++) {
            var item = _c[_i];
            var ev = item["EventType"];
            if ((ev & controlEvents) == 0)
                continue;
            var a = item["Action"];
            var t = item["Target"];
            this.sendAction(a, t, controlEvents);
        }
    };
    Object.defineProperty(UIControl.prototype, "enabled", {
        get: function () { return this.layer.disabled; },
        set: function (value) { this.setEnabled(value); },
        enumerable: false,
        configurable: true
    });
    UIControl.prototype.setEnabled = function (enabled) {
        this.layer.disabled = !enabled;
    };
    Object.defineProperty(UIControl.prototype, "selected", {
        get: function () { return this._selected; },
        set: function (value) { this.setSelected(value); },
        enumerable: false,
        configurable: true
    });
    UIControl.prototype.setSelected = function (value) {
        if (this._selected == value)
            return;
        this.willChangeValue("selected");
        if (value == true) {
            // MUICoreLayerAddStyle(this.layer, "selected");
            this.layer.addStyle("selected");
        }
        else {
            // MUICoreLayerRemoveStyle(this.layer, "selected");
            this.layer.removeStyle("selected");
        }
        this._selected = value;
        this.didChangeValue("selected");
    };
    //
    // Event handling
    //
    UIControl.prototype.touchesBeginWithEvent = function (touches, event) {
        this.sendActions(UIControl.Event.touchDown);
    };
    UIControl.prototype.touchesEndedWithEvent = function (touches, event) {
        // TODO: Check if the event was up inside the bounds or not.
        this.sendActions(UIControl.Event.touchUpInside);
        this._performSegue();
    };
    UIControl.prototype.setOnMouseOverAction = function (target, action) {
        this.mouseOverTarget = target;
        this.mouseOverAction = action;
        var instance = this;
        //  this.layer.onmouseover = function()
        //  {
        //      if (instance.enabled)
        //          instance.mouseOverAction.call(target);
        //  }
    };
    UIControl.prototype.setOnMouseOutAction = function (target, action) {
        this.mouseOutTarget = target;
        this.mouseOutAction = action;
        var instance = this;
        //  this.layer.onmouseout = function()
        //  {
        //      if (instance.enabled)
        //          instance.mouseOutAction.call(target);
        //  }
    };
    var _a, _b;
    UIControl.State = (_a = /** @class */ (function () {
            function class_1() {
            }
            return class_1;
        }()),
        __setFunctionName(_a, "State"),
        _a.normal = 0,
        _a.highlighted = 1,
        _a.disabled = 2,
        _a.selected = 3,
        _a.focused = 4,
        _a.application = 5,
        _a.reserved = 6,
        _a);
    UIControl.Event = (_b = /** @class */ (function () {
            function class_2() {
            }
            return class_2;
        }()),
        __setFunctionName(_b, "Event"),
        _b.touchDown = 1 << 0,
        _b.touchDownRepeat = 1 << 1,
        _b.touchDragInside = 1 << 2,
        _b.touchDragOutside = 1 << 3,
        _b.touchDragEnter = 1 << 4,
        _b.touchDragExit = 1 << 5,
        _b.touchUpInside = 1 << 6,
        _b.touchUpOutside = 1 << 7,
        _b.touchCancel = 1 << 8,
        _b.valueChanged = 1 << 12,
        _b.primaryActionTriggered = 1 << 13,
        _b.editingDidBegin = 1 << 16,
        _b.editingChanged = 1 << 17,
        _b.editingDidEnd = 1 << 18,
        _b.editingDidEndOnExit = 1 << 19,
        _b.allTouchEvents = 0x00000FFF,
        _b.editingEvents = 0x000F0000,
        _b.applicationReserved = 0x0F000000,
        _b.systemReserved = 0xF0000000,
        _b.allEvents = 0xFFFFFFFF,
        _b);
    return UIControl;
}(_UIView__WEBPACK_IMPORTED_MODULE_1__.UIView));



/***/ }),

/***/ "./sources/UIEdgeInsets.ts":
/*!*********************************!*\
  !*** ./sources/UIEdgeInsets.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIEdgeInsets: () => (/* binding */ UIEdgeInsets)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

function MIOEdgeInsetsMake(top, left, bottom, rigth) {
    var ei = new UIEdgeInsets();
    ei.initWithValues(top, left, bottom, rigth);
    return ei;
}
var UIEdgeInsets = /** @class */ (function (_super) {
    __extends(UIEdgeInsets, _super);
    function UIEdgeInsets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.top = 0;
        _this.left = 0;
        _this.bottom = 0;
        _this.right = 0;
        return _this;
    }
    UIEdgeInsets.Zero = function () {
        var ei = new UIEdgeInsets();
        ei.init();
        return ei;
    };
    UIEdgeInsets.prototype.initWithValues = function (top, left, bottom, right) {
        _super.prototype.init.call(this);
        this.top = top;
        this.left = left;
        this.bottom = bottom;
        this.right = right;
    };
    return UIEdgeInsets;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIEvent.ts":
/*!****************************!*\
  !*** ./sources/UIEvent.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIEvent: () => (/* binding */ UIEvent)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIEvent = /** @class */ (function (_super) {
    __extends(UIEvent, _super);
    function UIEvent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.x = 0;
        _this.y = 0;
        return _this;
    }
    UIEvent.eventWithSysEvent = function (sysEvent) {
        var ev = new UIEvent();
        ev.initWithSysEvent(sysEvent);
        return ev;
    };
    UIEvent.prototype.initWithSysEvent = function (e) {
        _super.prototype.init.call(this);
        this.x = e.clientX;
        this.y = e.clientY;
    };
    return UIEvent;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIGestureRecognizer.ts":
/*!****************************************!*\
  !*** ./sources/UIGestureRecognizer.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIGestureRecognizer: () => (/* binding */ UIGestureRecognizer),
/* harmony export */   UIGestureRecognizerState: () => (/* binding */ UIGestureRecognizerState)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIGestureRecognizerState;
(function (UIGestureRecognizerState) {
    UIGestureRecognizerState[UIGestureRecognizerState["Possible"] = 0] = "Possible";
    UIGestureRecognizerState[UIGestureRecognizerState["Began"] = 1] = "Began";
    UIGestureRecognizerState[UIGestureRecognizerState["Changed"] = 2] = "Changed";
    UIGestureRecognizerState[UIGestureRecognizerState["Ended"] = 3] = "Ended";
    UIGestureRecognizerState[UIGestureRecognizerState["Cancelled"] = 4] = "Cancelled";
    UIGestureRecognizerState[UIGestureRecognizerState["Failed"] = 5] = "Failed";
    UIGestureRecognizerState[UIGestureRecognizerState["Recognized"] = 6] = "Recognized";
})(UIGestureRecognizerState || (UIGestureRecognizerState = {}));
var UIGestureRecognizer = /** @class */ (function (_super) {
    __extends(UIGestureRecognizer, _super);
    function UIGestureRecognizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.delegate = null;
        _this.isEnabled = true;
        _this.name = null;
        _this.target = null;
        _this.block = null;
        _this._view = null;
        _this._state = UIGestureRecognizerState.Possible;
        return _this;
    }
    Object.defineProperty(UIGestureRecognizer.prototype, "view", {
        get: function () { return this._view; },
        set: function (v) { this.setView(v); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIGestureRecognizer.prototype, "state", {
        get: function () { return this._state; },
        set: function (value) { this.setState(value); },
        enumerable: false,
        configurable: true
    });
    UIGestureRecognizer.prototype.initWithTarget = function (target, block) {
        _super.prototype.init.call(this);
        this.target = target;
        this.block = block;
    };
    UIGestureRecognizer.prototype.setView = function (view) {
        this._view = view;
    };
    UIGestureRecognizer.prototype.setState = function (state) {
        if (this.isEnabled == false)
            return;
        if (this._state == state && state != UIGestureRecognizerState.Changed)
            return;
        this._state = state;
        this.block.call(this.target, this);
    };
    UIGestureRecognizer.prototype.touchesBeganWithEvent = function (touches, ev) {
        this.state = UIGestureRecognizerState.Began;
    };
    UIGestureRecognizer.prototype.touchesMovedWithEvent = function (touches, ev) {
        this.state = UIGestureRecognizerState.Changed;
    };
    UIGestureRecognizer.prototype.touchesEndedWithEvent = function (touches, ev) {
        this.state = UIGestureRecognizerState.Ended;
    };
    UIGestureRecognizer.prototype.reset = function () {
        this.state = UIGestureRecognizerState.Possible;
    };
    // To call from UIView. Only for internal use
    UIGestureRecognizer.prototype._viewTouchesBeganWithEvent = function (touches, ev) {
        this.reset();
        this.touchesBeganWithEvent(touches, ev);
    };
    UIGestureRecognizer.prototype._viewTouchesMovedWithEvent = function (touches, ev) {
        this.touchesMovedWithEvent(touches, ev);
    };
    UIGestureRecognizer.prototype._viewTouchesEndedWithEvent = function (touches, ev) {
        this.touchesEndedWithEvent(touches, ev);
    };
    return UIGestureRecognizer;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIImageView.ts":
/*!********************************!*\
  !*** ./sources/UIImageView.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIImageView: () => (/* binding */ UIImageView)
/* harmony export */ });
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _CoreAnimation_CAImageLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreAnimation/CAImageLayer */ "./sources/CoreAnimation/CAImageLayer.ts");
/**
 * Created by godshadow on 12/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UIImageView = /** @class */ (function (_super) {
    __extends(UIImageView, _super);
    function UIImageView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UIImageView, "layerClass", {
        get: function () { return _CoreAnimation_CAImageLayer__WEBPACK_IMPORTED_MODULE_1__.CAImageLayer; },
        enumerable: false,
        configurable: true
    });
    UIImageView.prototype.init = function () {
        this.layer = new UIImageView.layerClass();
    };
    Object.defineProperty(UIImageView.prototype, "imageURL", {
        set: function (url) { this.layer.imageURL = url; },
        enumerable: false,
        configurable: true
    });
    return UIImageView;
}(_UIView__WEBPACK_IMPORTED_MODULE_0__.UIView));



/***/ }),

/***/ "./sources/UILabel.ts":
/*!****************************!*\
  !*** ./sources/UILabel.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UILabel: () => (/* binding */ UILabel)
/* harmony export */ });
/* harmony import */ var _CoreAnimation_CATextLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CoreAnimation/CATextLayer */ "./sources/CoreAnimation/CATextLayer.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/**
 * Created by godshadow on 11/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UILabel = /** @class */ (function (_super) {
    __extends(UILabel, _super);
    function UILabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.autoAdjustFontSize = "none";
        _this.autoAdjustFontSizeValue = 4;
        return _this;
    }
    Object.defineProperty(UILabel, "layerClass", {
        get: function () { return _CoreAnimation_CATextLayer__WEBPACK_IMPORTED_MODULE_0__.CATextLayer; },
        enumerable: false,
        configurable: true
    });
    UILabel.prototype.init = function () {
        this.layer = new UILabel.layerClass();
    };
    UILabel.prototype.setText = function (text) { this.text = text; };
    Object.defineProperty(UILabel.prototype, "text", {
        get: function () { return this.layer.string; },
        set: function (text) { this.layer.string = text != null ? text : ""; },
        enumerable: false,
        configurable: true
    });
    UILabel.prototype.setTextAlignment = function (alignment) {
        // this.layer.style.textAlign = alignment;
    };
    UILabel.prototype.setHightlighted = function (value) {
        if (value == true) {
            // this.layer.style[ "StyleClass" ].addObject( "label_highlighted_color" );
        }
        else {
            // this.layer.style[ "StyleClass" ].removeObject( "label_highlighted_color" );
        }
    };
    UILabel.prototype.setTextRGBColor = function (r, g, b) {
        var value = "rgb(" + r + ", " + g + ", " + b + ")";
        // this.layer.style["color"] = value;
    };
    UILabel.prototype.setFontSize = function (size) {
        // this.layer.style[ "fontSize" ] = size;
    };
    UILabel.prototype.setFontStyle = function (style) {
        // this.layer.style[ "FontWeight" ] = style;
    };
    UILabel.prototype.setFontFamily = function (fontFamily) {
        // this.layer.style[ "FontFamily" ] = fontFamily;
    };
    return UILabel;
}(_UIView__WEBPACK_IMPORTED_MODULE_1__.UIView));



/***/ }),

/***/ "./sources/UINavigationBar.ts":
/*!************************************!*\
  !*** ./sources/UINavigationBar.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UINavigationBar: () => (/* binding */ UINavigationBar)
/* harmony export */ });
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/// <reference path="core/UICoreLayer.ts" />
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UINavigationBar = /** @class */ (function (_super) {
    __extends(UINavigationBar, _super);
    function UINavigationBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // initWithLayer(layer, owner, options?){
        //     super.initWithLayer(layer, owner, options);
        //     this.setup();
        // }
        _this.leftView = null;
        _this.titleView = null;
        _this.rigthView = null;
        _this._items = [];
        return _this;
    }
    UINavigationBar.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setup();
    };
    UINavigationBar.prototype.setup = function () {
        // MUICoreLayerAddStyle(this.layer, "navigation-bar");
        // this.layer.style.width = "100%";
        this.leftView = new _UIView__WEBPACK_IMPORTED_MODULE_0__.UIView();
        this.leftView.init();
        // this.leftView.layer.style.position = "absolute";
        // this.leftView.layer.style.top = "0px";
        // this.leftView.layer.style.height = "100%";
        // this.leftView.layer.style.width = "20%";
        // this.leftView.layer.style.left = "0px";
        this.addSubview(this.leftView);
        this.titleView = new _UIView__WEBPACK_IMPORTED_MODULE_0__.UIView();
        this.titleView.init();
        // this.titleView.layer.style.position = "absolute";
        // this.titleView.layer.style.top = "0px";
        // this.titleView.layer.style.height = "100%";
        // this.titleView.layer.style.width = "60%";
        // this.titleView.layer.style.left = "20%";
        this.addSubview(this.titleView);
        this.rigthView = new _UIView__WEBPACK_IMPORTED_MODULE_0__.UIView();
        this.rigthView.init();
        // this.rigthView.layer.style.position = "absolute";
        // this.rigthView.layer.style.top = "0px";
        // this.rigthView.layer.style.height = "100%";
        // this.rigthView.layer.style.width = "44px";
        // this.rigthView.layer.style.right = "0px";        
        this.addSubview(this.rigthView);
    };
    Object.defineProperty(UINavigationBar.prototype, "items", {
        get: function () { return this._items; },
        enumerable: false,
        configurable: true
    });
    UINavigationBar.prototype.setItems = function (items, animated) {
        this._items = items;
        //TODO: Animate!!!
        for (var index = 0; index < items.length; index++) {
            var ni = items[index];
            // Add title
            if (ni.titleView != null) {
                this.titleView.addSubview(ni.titleView);
            }
            // Add right button
            if (ni.leftBarButtonItem != null) {
                this.leftView.addSubview(ni.leftBarButtonItem.customView);
            }
            // Add right button
            if (ni.rightBarButtonItem != null) {
                this.rigthView.addSubview(ni.rightBarButtonItem.customView);
            }
        }
    };
    UINavigationBar.prototype.pushNavigationItem = function (item, animated) {
        this.items.addObject(item);
        // TODO: Make the animation and change the items
    };
    UINavigationBar.prototype.popNavigationItem = function (item, animated) {
        this.items.removeObject(item);
        // TODO: Make the animation and change the items
    };
    Object.defineProperty(UINavigationBar.prototype, "topItem", {
        get: function () {
            if (this.items.length == 0)
                return null;
            return this.items[this.items.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UINavigationBar.prototype, "backItem", {
        get: function () {
            if (this.items.length < 2)
                return null;
            return this.items[this.items.length - 2];
        },
        enumerable: false,
        configurable: true
    });
    return UINavigationBar;
}(_UIView__WEBPACK_IMPORTED_MODULE_0__.UIView));



/***/ }),

/***/ "./sources/UINavigationController.ts":
/*!*******************************************!*\
  !*** ./sources/UINavigationController.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MUIPopAnimationController: () => (/* binding */ MUIPopAnimationController),
/* harmony export */   MUIPushAnimationController: () => (/* binding */ MUIPushAnimationController),
/* harmony export */   UINavigationController: () => (/* binding */ UINavigationController)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_UICore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/UICore */ "./sources/core/UICore.ts");
/* harmony import */ var _UIBarButtonItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIBarButtonItem */ "./sources/UIBarButtonItem.ts");
/* harmony import */ var _UIButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./UIButton */ "./sources/UIButton.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/* harmony import */ var _UINavigationItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./UINavigationItem */ "./sources/UINavigationItem.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _UIViewController__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./UIViewController */ "./sources/UIViewController.ts");
/**
 * Created by godshadow on 9/4/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var UINavigationController = /** @class */ (function (_super) {
    __extends(UINavigationController, _super);
    function UINavigationController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootViewController = null;
        _this.viewControllersStack = [];
        _this.currentViewControllerIndex = -1;
        _this._navigationBar = null;
        // Transitioning delegate
        _this._pushAnimationController = null;
        _this._popAnimationController = null;
        return _this;
    }
    Object.defineProperty(UINavigationController.prototype, "navigationBar", {
        get: function () {
            return this._navigationBar;
        },
        enumerable: false,
        configurable: true
    });
    UINavigationController.prototype.init = function () {
        _super.prototype.init.call(this);
        // this.view.layer.style.overflow = "hidden";        
    };
    UINavigationController.prototype.initWithRootViewController = function (vc) {
        this.init();
        this.setRootViewController(vc);
    };
    UINavigationController.prototype.setRootViewController = function (vc) {
        //this.transitioningDelegate = this;                
        this.rootViewController = vc;
        //this.view.addSubview(vc.view);
        this.viewControllersStack.push(vc);
        this.currentViewControllerIndex = 0;
        this.rootViewController.navigationController = this;
        this.addChildViewController(vc);
        // if (this.presentationController != null) {
        //     var size = vc.preferredContentSize;
        //     this.contentSize = size;
        // }
    };
    UINavigationController.prototype._loadViewFromNib = function (layer, classname) {
        this._contentView = new _UIView__WEBPACK_IMPORTED_MODULE_6__.UIView();
        // this._contentView.initWithLayer(layer, this);
        this._navigationBar = this._contentView.subviews[0];
        this._segues = this._contentView._segues;
        this.view = new _UIView__WEBPACK_IMPORTED_MODULE_6__.UIView();
        this.view.init();
        this.view.addSubview(this._navigationBar);
        this._checkSegues();
        this._didLoadView();
    };
    UINavigationController.prototype._setViewLoaded = function (value) {
        // this.rootViewController.view.layer.style.left = "0px";
        // this.rootViewController.view.layer.style.top = "44px";
        // this.rootViewController.view.layer.style.width = "100%";
        // this.rootViewController.view.layer.style.botton = "0px";
        this.view.addSubview(this.rootViewController.view);
        var navItems = [this.rootViewController.navigationItem];
        this._navigationBar.setItems(navItems, false);
        _super.prototype._setViewLoaded.call(this, value);
    };
    UINavigationController.prototype.viewWillAppear = function (animated) {
        if (this.currentViewControllerIndex < 0)
            return;
        var vc = this.viewControllersStack[this.currentViewControllerIndex];
        vc.viewWillAppear(animated);
    };
    UINavigationController.prototype.viewDidAppear = function (animated) {
        if (this.currentViewControllerIndex < 0)
            return;
        var vc = this.viewControllersStack[this.currentViewControllerIndex];
        vc.viewDidAppear(animated);
    };
    UINavigationController.prototype.viewWillDisappear = function (animated) {
        if (this.currentViewControllerIndex < 0)
            return;
        var vc = this.viewControllersStack[this.currentViewControllerIndex];
        vc.viewWillDisappear(animated);
    };
    UINavigationController.prototype.viewDidDisappear = function (animated) {
        if (this.currentViewControllerIndex < 0)
            return;
        var vc = this.viewControllersStack[this.currentViewControllerIndex];
        vc.viewDidDisappear(animated);
    };
    UINavigationController.prototype.pushViewController = function (vc, animated) {
        var _this = this;
        var lastVC = this.viewControllersStack[this.currentViewControllerIndex];
        this.viewControllersStack.push(vc);
        this.currentViewControllerIndex++;
        vc.navigationController = this;
        vc.onLoadView(function () {
            if (vc.navigationItem == null) {
                vc.navigationItem = new _UINavigationItem__WEBPACK_IMPORTED_MODULE_5__.UINavigationItem();
                vc.navigationItem.init();
            }
            var backButton = new _UIButton__WEBPACK_IMPORTED_MODULE_3__.UIButton();
            backButton.init();
            backButton.setTitle((0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLocalizeString)("Back", "BACK"));
            // MUICoreLayerAddStyle(backButton.layer, "system-back-icon");
            backButton.addTarget(vc, function () {
                this.navigationController.popViewController(true);
            }, _UIControl__WEBPACK_IMPORTED_MODULE_4__.UIControl.Event.touchUpInside);
            var backBarButtonItem = new _UIBarButtonItem__WEBPACK_IMPORTED_MODULE_2__.UIBarButtonItem();
            backBarButtonItem.initWithCustomView(backButton);
            backBarButtonItem.target = vc;
            backBarButtonItem.action = function () {
                this.navigationController.popViewController(true);
            };
            _this.view.addSubview(vc.view);
            _this.addChildViewController(vc);
            if (vc.preferredContentSize != null)
                _this.preferredContentSize = vc.preferredContentSize;
            (0,_core_UICore__WEBPACK_IMPORTED_MODULE_1__._UIShowViewController)(lastVC, vc, _this, animated);
        });
    };
    UINavigationController.prototype.popViewController = function (animated) {
        var _this = this;
        if (this.currentViewControllerIndex == 0)
            return;
        var fromVC = this.viewControllersStack[this.currentViewControllerIndex];
        this.currentViewControllerIndex--;
        this.viewControllersStack.pop();
        var toVC = this.viewControllersStack[this.currentViewControllerIndex];
        // if (toVC.transitioningDelegate == null)
        //     toVC.transitioningDelegate = this;
        if (toVC.preferredContentSize != null)
            this.contentSize = toVC.preferredContentSize;
        (0,_core_UICore__WEBPACK_IMPORTED_MODULE_1__._UICoreHideViewController)(fromVC, toVC, this, function () {
            fromVC.removeChildViewController(_this);
            fromVC.view.removeFromSuperview();
        });
    };
    UINavigationController.prototype.popToRootViewController = function (animated) {
        var _this = this;
        if (this.viewControllersStack.length == 1)
            return;
        var currentVC = this.viewControllersStack.pop();
        for (var index = this.currentViewControllerIndex - 1; index > 0; index--) {
            var vc = this.viewControllersStack.pop();
            vc.view.removeFromSuperview();
            this.removeChildViewController(vc);
        }
        this.currentViewControllerIndex = 0;
        var rootVC = this.viewControllersStack[0];
        this.contentSize = rootVC.preferredContentSize;
        (0,_core_UICore__WEBPACK_IMPORTED_MODULE_1__._UICoreHideViewController)(currentVC, rootVC, this, function () {
            currentVC.view.removeFromSuperview();
            _this.removeChildViewController(currentVC);
        });
    };
    Object.defineProperty(UINavigationController.prototype, "preferredContentSize", {
        get: function () {
            if (this.currentViewControllerIndex < 0)
                return this._preferredContentSize;
            var vc = this.viewControllersStack[this.currentViewControllerIndex];
            return vc.preferredContentSize;
        },
        set: function (size) {
            this.setPreferredContentSize(size);
        },
        enumerable: false,
        configurable: true
    });
    // Segues
    UINavigationController.prototype._checkSegues = function () {
        _super.prototype._checkSegues.call(this);
        for (var index = 0; index < this._segues.length; index++) {
            var s = this._segues[index];
            var kind = s["Kind"];
            if (kind == "relationship") {
                var destination = s["Destination"];
                var relationship = s["Relationship"];
                if (relationship == "rootViewController") {
                    var vc = this.storyboard._instantiateViewControllerWithDestination(destination);
                    this.setRootViewController(vc);
                }
            }
        }
    };
    UINavigationController.prototype.animationControllerForPresentedController = function (presentedViewController, presentingViewController, sourceController) {
        if (this._pushAnimationController == null) {
            this._pushAnimationController = new MUIPushAnimationController();
            this._pushAnimationController.init();
        }
        return this._pushAnimationController;
    };
    UINavigationController.prototype.animationControllerForDismissedController = function (dismissedController) {
        if (this._popAnimationController == null) {
            this._popAnimationController = new MUIPopAnimationController();
            this._popAnimationController.init();
        }
        return this._popAnimationController;
    };
    return UINavigationController;
}(_UIViewController__WEBPACK_IMPORTED_MODULE_7__.UIViewController));

/*
    ANIMATIONS
 */
var MUIPushAnimationController = /** @class */ (function (_super) {
    __extends(MUIPushAnimationController, _super);
    function MUIPushAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MUIPushAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0.25;
    };
    MUIPushAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations before transitions       
    };
    MUIPushAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations after transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    MUIPushAnimationController.prototype.animations = function (transitionContext) {
        // let animations = MUIClassListForAnimationType(MUIAnimationType.Push);
        // return animations;
    };
    return MUIPushAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));

var MUIPopAnimationController = /** @class */ (function (_super) {
    __extends(MUIPopAnimationController, _super);
    function MUIPopAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MUIPopAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0.25;
    };
    MUIPopAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations after transitions
    };
    MUIPopAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations before transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    MUIPopAnimationController.prototype.animations = function (transitionContext) {
        // let animations = MUIClassListForAnimationType(MUIAnimationType.Pop);
        // return animations;
    };
    return MUIPopAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UINavigationItem.ts":
/*!*************************************!*\
  !*** ./sources/UINavigationItem.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UINavigationItem: () => (/* binding */ UINavigationItem)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _UILabel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UILabel */ "./sources/UILabel.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UINavigationItem = /** @class */ (function (_super) {
    __extends(UINavigationItem, _super);
    function UINavigationItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.backBarButtonItem = null;
        _this.title = null;
        return _this;
        // initWithLayer(layer, owner){
        //     let title = layer.getAttribute("data-navigation-title");
        //     this.title = title;
        //     let titleLabel = new UILabel();
        //     titleLabel.init();
        //     titleLabel.text = title;        
        //     this.titleView = titleLabel;
        //     if (layer.childNodes.length > 0) {
        //         for (let index = 0; index < layer.childNodes.length; index++) {
        //             let subLayer = layer.childNodes[index];
        //             if (subLayer.tagName != "DIV") continue;
        //             let key = subLayer.getAttribute("data-bar-button-item-key");
        //             let button = new UIBarButtonItem();
        //             button.initWithLayer(subLayer, owner);
        //             if (key == "leftBarButtonItem") {
        //                 (owner as UIViewController).navigationItem.leftBarButtonItem = button;
        //             }                    
        //             if (key == "rightBarButtonItem") {
        //                 (owner as UIViewController).navigationItem.rightBarButtonItem = button;
        //             }                    
        //             // if (subLayer.getAttribute("data-nav-item-left") != null) {
        //             //     let v:UIView = new UIView();
        //             //     v.initWithLayer(subLayer, this);
        //             //     this.leftView = v;
        //             // }
        //             // else if (subLayer.getAttribute("data-nav-item-center") != null) {
        //             //     let v:UIView = new UIView();
        //             //     v.initWithLayer(subLayer, this);
        //             //     this.titleView = v;
        //             // }
        //             // else if (subLayer.getAttribute("data-nav-item-right") != null) {
        //             //     let v:UIView = new UIView();
        //             //     v.initWithLayer(subLayer, this);
        //             //     this.rightView = v;
        //             // }
        //         }
        //         // let backButtonLayer = MUICoreLayerSearchElementByAttribute(layer, "data-nav-item-back");
        //         // if (backButtonLayer != null) {
        //         //     this.backBarButtonItem = new UIButton();
        //         //     this.backBarButtonItem.initWithLayer(backButtonLayer, this);
        //         // }
        //     }
        // }
    }
    UINavigationItem.prototype.initWithTitle = function (title) {
        _super.prototype.init.call(this);
        this.title = title;
        var titleLabel = new _UILabel__WEBPACK_IMPORTED_MODULE_1__.UILabel();
        titleLabel.init();
        titleLabel.text = title;
        this.titleView = titleLabel;
    };
    return UINavigationItem;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIPopoverPresentationController.ts":
/*!****************************************************!*\
  !*** ./sources/UIPopoverPresentationController.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MIOModalPopOverTransitioningDelegate: () => (/* binding */ MIOModalPopOverTransitioningDelegate),
/* harmony export */   MIOPopOverDismissAnimationController: () => (/* binding */ MIOPopOverDismissAnimationController),
/* harmony export */   MIOPopOverPresentAnimationController: () => (/* binding */ MIOPopOverPresentAnimationController),
/* harmony export */   UIPopoverArrowDirection: () => (/* binding */ UIPopoverArrowDirection),
/* harmony export */   UIPopoverPresentationController: () => (/* binding */ UIPopoverPresentationController)
/* harmony export */ });
/* harmony import */ var _UIPresentationController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIPresentationController */ "./sources/UIPresentationController.ts");
/* harmony import */ var _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreGraphics/CGRect */ "./sources/CoreGraphics/CGRect.ts");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Created by godshadow on 11/11/2016.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var UIPopoverArrowDirection;
(function (UIPopoverArrowDirection) {
    UIPopoverArrowDirection[UIPopoverArrowDirection["any"] = 0] = "any";
    UIPopoverArrowDirection[UIPopoverArrowDirection["up"] = 1] = "up";
    UIPopoverArrowDirection[UIPopoverArrowDirection["down"] = 2] = "down";
    UIPopoverArrowDirection[UIPopoverArrowDirection["left"] = 3] = "left";
    UIPopoverArrowDirection[UIPopoverArrowDirection["right"] = 4] = "right";
})(UIPopoverArrowDirection || (UIPopoverArrowDirection = {}));
var UIPopoverPresentationController = /** @class */ (function (_super) {
    __extends(UIPopoverPresentationController, _super);
    function UIPopoverPresentationController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.permittedArrowDirections = UIPopoverArrowDirection.any;
        _this.sourceView = null;
        _this.sourceRect = _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_1__.CGRect.zero();
        _this.delegate = null;
        _this._contentSize = null;
        _this._canvasLayer = null;
        _this._contentView = null;
        return _this;
    }
    Object.defineProperty(UIPopoverPresentationController.prototype, "transitioningDelegate", {
        get: function () {
            if (this._transitioningDelegate == null) {
                this._transitioningDelegate = new MIOModalPopOverTransitioningDelegate();
                this._transitioningDelegate.init();
            }
            return this._transitioningDelegate;
        },
        enumerable: false,
        configurable: true
    });
    UIPopoverPresentationController.prototype.presentationTransitionWillBegin = function () {
        //if (MIOCoreIsPhone() == true) return;
        this._calculateFrame();
        // MUICoreLayerAddStyle(this.presentedView.layer, "popover_window");                
    };
    UIPopoverPresentationController.prototype.dismissalTransitionDidEnd = function (completed) {
        if (completed == false)
            return;
        if (this.delegate != null && (typeof this.delegate.popoverPresentationControllerDidDismissPopover === "function")) {
            this.delegate.popoverPresentationControllerDidDismissPopover(this);
        }
    };
    UIPopoverPresentationController.prototype._calculateFrame = function () {
        var vc = this.presentedViewController;
        var view = this.presentedView;
        var w = vc.preferredContentSize.width;
        var h = vc.preferredContentSize.height;
        var v = vc.popoverPresentationController.sourceView;
        var f = vc.popoverPresentationController.sourceRect;
        var xShift = false;
        // Below
        var y = v.layer.getBoundingClientRect().top + f.size.height + 10;
        if ((y + h) > window.innerHeight) // Below no, Up?
            y = v.layer.getBoundingClientRect().top - h - 10;
        if (y < 0) // Up no, horizonal shift
         {
            xShift = true;
            y = (window.innerHeight - h) / 2;
        }
        var x = 0;
        if (xShift == false) {
            x = v.layer.getBoundingClientRect().left + 10;
            if ((x + w) > window.innerWidth)
                x = v.layer.getBoundingClientRect().left + f.size.width - w + 10;
        }
        else {
            x = v.layer.getBoundingClientRect().left + f.size.width + 10;
            if ((x + w) > window.innerWidth)
                x = v.layer.getBoundingClientRect().left - w - 10;
        }
        view.setFrame(_CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_1__.CGRect.rectFromValues(0, 0, w, h));
        this.window.setFrame(_CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_1__.CGRect.rectFromValues(x, y, w, h));
    };
    UIPopoverPresentationController.prototype._drawRoundRect = function (x, y, width, height, radius) {
        var ctx = this._canvasLayer.getContext('2d');
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        var color = 'rgba(208, 208, 219, 1)';
        ctx.strokeStyle = color;
        ctx.lineWidth = 1;
        ctx.stroke();
    };
    return UIPopoverPresentationController;
}(_UIPresentationController__WEBPACK_IMPORTED_MODULE_0__.UIPresentationController));

var MIOModalPopOverTransitioningDelegate = /** @class */ (function (_super) {
    __extends(MIOModalPopOverTransitioningDelegate, _super);
    function MIOModalPopOverTransitioningDelegate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalTransitionStyle = null;
        _this._showAnimationController = null;
        _this._dissmissAnimationController = null;
        return _this;
    }
    MIOModalPopOverTransitioningDelegate.prototype.animationControllerForPresentedController = function (presentedViewController, presentingViewController, sourceController) {
        if (this._showAnimationController == null) {
            // if (MIOCoreIsPhone() == false) {
            this._showAnimationController = new MIOPopOverPresentAnimationController();
            this._showAnimationController.init();
            // }
            // else {
            //     this._showAnimationController = new MIOModalPresentAnimationController();
            //     this._showAnimationController.init();
            // }
        }
        return this._showAnimationController;
    };
    MIOModalPopOverTransitioningDelegate.prototype.animationControllerForDismissedController = function (dismissedController) {
        if (this._dissmissAnimationController == null) {
            //            if (MIOCoreIsPhone() == false) {
            this._dissmissAnimationController = new MIOPopOverDismissAnimationController();
            this._dissmissAnimationController.init();
            // }
            // else {
            //     this._dissmissAnimationController = new MIOModalDismissAnimationController();
            //     this._dissmissAnimationController.init();    
            // }
        }
        return this._dissmissAnimationController;
    };
    return MIOModalPopOverTransitioningDelegate;
}(foundation__WEBPACK_IMPORTED_MODULE_2__.NSObject));

var MIOPopOverPresentAnimationController = /** @class */ (function (_super) {
    __extends(MIOPopOverPresentAnimationController, _super);
    function MIOPopOverPresentAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MIOPopOverPresentAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0.25;
    };
    MIOPopOverPresentAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations before transitions
    };
    MIOPopOverPresentAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations after transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    MIOPopOverPresentAnimationController.prototype.animations = function (transitionContext) {
        // let animations = MUIClassListForAnimationType(MUIAnimationType.FadeIn);
        // return animations;
    };
    return MIOPopOverPresentAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_2__.NSObject));

var MIOPopOverDismissAnimationController = /** @class */ (function (_super) {
    __extends(MIOPopOverDismissAnimationController, _super);
    function MIOPopOverDismissAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MIOPopOverDismissAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0.25;
    };
    MIOPopOverDismissAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations after transitions
    };
    MIOPopOverDismissAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations before transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    MIOPopOverDismissAnimationController.prototype.animations = function (transitionContext) {
        // let animations = MUIClassListForAnimationType(MUIAnimationType.FadeOut);
        // return animations;
    };
    return MIOPopOverDismissAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_2__.NSObject));



/***/ }),

/***/ "./sources/UIPresentationController.ts":
/*!*********************************************!*\
  !*** ./sources/UIPresentationController.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIModalPresentationStyle: () => (/* binding */ UIModalPresentationStyle),
/* harmony export */   UIModalTransitionStyle: () => (/* binding */ UIModalTransitionStyle),
/* harmony export */   UIPresentationController: () => (/* binding */ UIPresentationController)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreGraphics/CGRect */ "./sources/CoreGraphics/CGRect.ts");
/* harmony import */ var _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreGraphics/CGSize */ "./sources/CoreGraphics/CGSize.ts");
/* harmony import */ var _CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CoreAnimation/CoreAnimation+Animations */ "./sources/CoreAnimation/CoreAnimation+Animations.ts");
/**
 * Created by godshadow on 06/12/2016.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var UIModalPresentationStyle;
(function (UIModalPresentationStyle) {
    UIModalPresentationStyle[UIModalPresentationStyle["fullScreen"] = 0] = "fullScreen";
    UIModalPresentationStyle[UIModalPresentationStyle["pageSheet"] = 1] = "pageSheet";
    UIModalPresentationStyle[UIModalPresentationStyle["formSheet"] = 2] = "formSheet";
    UIModalPresentationStyle[UIModalPresentationStyle["currentContext"] = 3] = "currentContext";
    UIModalPresentationStyle[UIModalPresentationStyle["custom"] = 4] = "custom";
    UIModalPresentationStyle[UIModalPresentationStyle["overFullScreen"] = 5] = "overFullScreen";
    UIModalPresentationStyle[UIModalPresentationStyle["overCurrentContext"] = 6] = "overCurrentContext";
    UIModalPresentationStyle[UIModalPresentationStyle["popover"] = 7] = "popover";
    UIModalPresentationStyle[UIModalPresentationStyle["none"] = 8] = "none";
})(UIModalPresentationStyle || (UIModalPresentationStyle = {}));
var UIModalTransitionStyle;
(function (UIModalTransitionStyle) {
    UIModalTransitionStyle[UIModalTransitionStyle["coverVertical"] = 0] = "coverVertical";
    UIModalTransitionStyle[UIModalTransitionStyle["flipHorizontal"] = 1] = "flipHorizontal";
    UIModalTransitionStyle[UIModalTransitionStyle["crossDisolve"] = 2] = "crossDisolve";
})(UIModalTransitionStyle || (UIModalTransitionStyle = {}));
var UIPresentationController = /** @class */ (function (_super) {
    __extends(UIPresentationController, _super);
    function UIPresentationController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.presentationStyle = UIModalPresentationStyle.pageSheet;
        _this.shouldPresentInFullscreen = false;
        _this._presentedViewController = null; //ToVC
        _this.presentingViewController = null; //FromVC
        _this.presentedView = null;
        _this._transitioningDelegate = null;
        _this._window = null;
        _this._isPresented = false;
        return _this;
    }
    UIPresentationController.prototype.initWithPresentedViewControllerAndPresentingViewController = function (presentedViewController, presentingViewController) {
        _super.prototype.init.call(this);
        this.presentedViewController = presentedViewController;
        this.presentingViewController = presentingViewController;
    };
    UIPresentationController.prototype.setPresentedViewController = function (vc) {
        this._presentedViewController = vc;
        this.presentedView = vc.view;
    };
    Object.defineProperty(UIPresentationController.prototype, "presentedViewController", {
        get: function () {
            return this._presentedViewController;
        },
        set: function (vc) {
            this.setPresentedViewController(vc);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIPresentationController.prototype, "transitioningDelegate", {
        get: function () {
            if (this._transitioningDelegate == null) {
                this._transitioningDelegate = new UIModalTransitioningDelegate();
                this._transitioningDelegate.init();
            }
            return this._transitioningDelegate;
        },
        enumerable: false,
        configurable: true
    });
    UIPresentationController.prototype.presentationTransitionWillBegin = function () {
        var toVC = this.presentedViewController;
        var view = this.presentedView;
        this._calculateFrame();
        if (toVC.modalPresentationStyle == UIModalPresentationStyle.pageSheet
            || toVC.modalPresentationStyle == UIModalPresentationStyle.formSheet
            || toVC.modalPresentationStyle == UIModalPresentationStyle.fullScreen
            || (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreIsPhone)() == true) {
            // MUICoreLayerAddStyle(view.layer, "modal_window");
        }
    };
    UIPresentationController.prototype.presentationTransitionDidEnd = function (completed) {
    };
    UIPresentationController.prototype.dismissalTransitionWillBegin = function () {
    };
    UIPresentationController.prototype.dismissalTransitionDidEnd = function (completed) {
    };
    UIPresentationController.prototype._calculateFrame = function () {
        var fromVC = this.presentingViewController;
        var toVC = this.presentedViewController;
        var view = this.presentedView;
        if (toVC.modalPresentationStyle == UIModalPresentationStyle.fullScreen) {
            // view.layer.style.left = "0px";
            // view.layer.style.top = "0px";
            // view.layer.style.width = "100%";
            // view.layer.style.height = "100%";
        }
        else if (toVC.modalPresentationStyle == UIModalPresentationStyle.currentContext) {
            var w = fromVC.view.getWidth();
            var h = fromVC.view.getHeight();
            view.setFrame(_CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_2__.CGRect.rectFromValues(0, 0, w, h));
        }
        else if (toVC.modalPresentationStyle == UIModalPresentationStyle.pageSheet) {
            // Present like desktop sheet window
            // let ws = MUIWindowSize();
            // let size = toVC.preferredContentSize;
            // if (size == null) size = new CGSize(320, 200);
            // let w = size.width;
            // let h = size.height;
            // let x = (ws.width - w) / 2;
            // view.setFrame(CGRect.rectFromValues(0, 0, w, h));
            // this.window.setFrame(CGRect.rectFromValues(x, 0, w, h));
            // // view.layer.classList.add("modal");
        }
        else if (toVC.modalPresentationStyle == UIModalPresentationStyle.formSheet) {
            // Present at the center of the screen
            // let ws = MUIWindowSize();
            // let size = toVC.preferredContentSize;
            // if (size == null) size = new CGSize(320, 200);
            // let w = size.width;
            // let h = size.height;
            // let x = (ws.width - w) / 2;
            // let y = (ws.height - h) / 2;
            // view.setFrame(CGRect.rectFromValues(0, 0, w, h));
            // this.window.setFrame(CGRect.rectFromValues(x, y, w, h));
            // // view.layer.classList.add("modal");
        }
        else {
            var size = toVC.preferredContentSize;
            if (size == null)
                size = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_3__.CGSize(320, 200);
            var w = size.width;
            var h = size.height;
            view.setFrame(_CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_2__.CGRect.rectFromValues(0, 0, w, h));
        }
    };
    Object.defineProperty(UIPresentationController.prototype, "window", {
        get: function () {
            return this._window;
        },
        set: function (window) {
            var vc = this.presentedViewController;
            this._window = window;
            // Track view frame changes
            if ((0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreIsMobile)() == false && vc.modalPresentationStyle != UIModalPresentationStyle.currentContext) {
                vc.addObserver(this, "preferredContentSize");
            }
        },
        enumerable: false,
        configurable: true
    });
    UIPresentationController.prototype.observeValueForKeyPath = function (key, type, object) {
        if (key == "preferredContentSize" && type == "did") {
            var vc = this.presentedView;
            //this.window.layer.style.transition = "left 0.25s, width 0.25s, height 0.25s";
            vc.layer.style.transition = "left 0.25s, width 0.25s, height 0.25s";
            this._calculateFrame();
        }
    };
    return UIPresentationController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));

var UIModalTransitioningDelegate = /** @class */ (function (_super) {
    __extends(UIModalTransitioningDelegate, _super);
    function UIModalTransitioningDelegate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalTransitionStyle = null;
        _this._presentAnimationController = null;
        _this._dissmissAnimationController = null;
        return _this;
    }
    UIModalTransitioningDelegate.prototype.animationControllerForPresentedController = function (presentedViewController, presentingViewController, sourceController) {
        if (this._presentAnimationController == null) {
            this._presentAnimationController = new UIModalPresentAnimationController();
            this._presentAnimationController.init();
        }
        return this._presentAnimationController;
    };
    UIModalTransitioningDelegate.prototype.animationControllerForDismissedController = function (dismissedController) {
        if (this._dissmissAnimationController == null) {
            this._dissmissAnimationController = new UIModalDismissAnimationController();
            this._dissmissAnimationController.init();
        }
        return this._dissmissAnimationController;
    };
    return UIModalTransitioningDelegate;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));
var UIAnimationController = /** @class */ (function (_super) {
    __extends(UIAnimationController, _super);
    function UIAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UIAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0;
    };
    UIAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations before transitions        
    };
    UIAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations after transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    UIAnimationController.prototype.animations = function (transitionContext) {
        return null;
    };
    return UIAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));
var UIModalPresentAnimationController = /** @class */ (function (_super) {
    __extends(UIModalPresentAnimationController, _super);
    function UIModalPresentAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UIModalPresentAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0.15;
    };
    UIModalPresentAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations before transitions
    };
    UIModalPresentAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations after transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    UIModalPresentAnimationController.prototype.animations = function (transitionContext) {
        var animations = null;
        var toVC = transitionContext.presentedViewController;
        if (toVC.modalPresentationStyle == UIModalPresentationStyle.pageSheet
            || toVC.modalPresentationStyle == UIModalPresentationStyle.formSheet
            || toVC.modalPresentationStyle == UIModalPresentationStyle.fullScreen) {
            if ((0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreIsPhone)() == true)
                animations = (0,_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAClassListForAnimationType)(_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAAnimationType.SlideInUp);
            else
                animations = (0,_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAClassListForAnimationType)(_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAAnimationType.BeginSheet);
        }
        return animations;
    };
    return UIModalPresentAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));
var UIModalDismissAnimationController = /** @class */ (function (_super) {
    __extends(UIModalDismissAnimationController, _super);
    function UIModalDismissAnimationController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UIModalDismissAnimationController.prototype.transitionDuration = function (transitionContext) {
        return 0.25;
    };
    UIModalDismissAnimationController.prototype.animateTransition = function (transitionContext) {
        // make view configurations after transitions
    };
    UIModalDismissAnimationController.prototype.animationEnded = function (transitionCompleted) {
        // make view configurations before transitions
    };
    // TODO: Not iOS like transitions. For now we use css animations
    UIModalDismissAnimationController.prototype.animations = function (transitionContext) {
        var animations = null;
        var fromVC = transitionContext.presentingViewController;
        if (fromVC.modalPresentationStyle == UIModalPresentationStyle.pageSheet
            || fromVC.modalPresentationStyle == UIModalPresentationStyle.formSheet
            || fromVC.modalPresentationStyle == UIModalPresentationStyle.fullScreen) {
            if ((0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreIsPhone)() == true)
                animations = (0,_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAClassListForAnimationType)(_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAAnimationType.SlideOutDown);
            else
                animations = (0,_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAClassListForAnimationType)(_CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_4__._CAAnimationType.EndSheet);
        }
        return animations;
    };
    return UIModalDismissAnimationController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));


/***/ }),

/***/ "./sources/UIResponder.ts":
/*!********************************!*\
  !*** ./sources/UIResponder.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIResponder: () => (/* binding */ UIResponder)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIResponder = /** @class */ (function (_super) {
    __extends(UIResponder, _super);
    function UIResponder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gestureRecognizers = [];
        return _this;
    }
    UIResponder.prototype.touchesBeganWithEvent = function (touches, event) {
        for (var index = 0; index < this.gestureRecognizers.length; index++) {
            var gr = this.gestureRecognizers[index];
            gr._viewTouchesBeganWithEvent(touches, event);
        }
    };
    UIResponder.prototype.touchesMovedWithEvent = function (touches, event) {
        for (var index = 0; index < this.gestureRecognizers.length; index++) {
            var gr = this.gestureRecognizers[index];
            gr._viewTouchesMovedWithEvent(touches, event);
        }
    };
    UIResponder.prototype.touchesEndedWithEvent = function (touches, event) {
        for (var index = 0; index < this.gestureRecognizers.length; index++) {
            var gr = this.gestureRecognizers[index];
            gr._viewTouchesEndedWithEvent(touches, event);
        }
    };
    return UIResponder;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIScene.ts":
/*!****************************!*\
  !*** ./sources/UIScene.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIScene: () => (/* binding */ UIScene)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIScene = /** @class */ (function (_super) {
    __extends(UIScene, _super);
    function UIScene() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UIScene;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UISceneConfiguration.ts":
/*!*****************************************!*\
  !*** ./sources/UISceneConfiguration.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UISceneConfiguration: () => (/* binding */ UISceneConfiguration)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UISceneConfiguration = /** @class */ (function (_super) {
    __extends(UISceneConfiguration, _super);
    function UISceneConfiguration(name, sessionRole) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.role = sessionRole;
        return _this;
    }
    return UISceneConfiguration;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UISceneConnectionOptions.ts":
/*!*********************************************!*\
  !*** ./sources/UISceneConnectionOptions.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UISceneConnectionOptions: () => (/* binding */ UISceneConnectionOptions)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UISceneConnectionOptions = /** @class */ (function (_super) {
    __extends(UISceneConnectionOptions, _super);
    function UISceneConnectionOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UISceneConnectionOptions;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UISceneSession.ts":
/*!***********************************!*\
  !*** ./sources/UISceneSession.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UISceneSession: () => (/* binding */ UISceneSession),
/* harmony export */   UISceneSessionRole: () => (/* binding */ UISceneSessionRole)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UISceneSessionRole;
(function (UISceneSessionRole) {
    UISceneSessionRole[UISceneSessionRole["windowApplication"] = 0] = "windowApplication";
    UISceneSessionRole[UISceneSessionRole["windowExternalDisplayNonInteractive"] = 1] = "windowExternalDisplayNonInteractive";
    UISceneSessionRole[UISceneSessionRole["carTemplateApplication"] = 2] = "carTemplateApplication";
    UISceneSessionRole[UISceneSessionRole["CPTemplateApplicationDashboardSceneSessionRoleApplication"] = 3] = "CPTemplateApplicationDashboardSceneSessionRoleApplication";
    UISceneSessionRole[UISceneSessionRole["CPTemplateApplicationInstrumentClusterSceneSessionRoleApplication"] = 4] = "CPTemplateApplicationInstrumentClusterSceneSessionRoleApplication";
})(UISceneSessionRole || (UISceneSessionRole = {}));
var UISceneSession = /** @class */ (function (_super) {
    __extends(UISceneSession, _super);
    function UISceneSession() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UISceneSession;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UISegmentedControl.ts":
/*!***************************************!*\
  !*** ./sources/UISegmentedControl.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UISegmentedControl: () => (/* binding */ UISegmentedControl)
/* harmony export */ });
/* harmony import */ var _UIButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIButton */ "./sources/UIButton.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/**
 * Created by godshadow on 29/08/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UISegmentedControl = /** @class */ (function (_super) {
    __extends(UISegmentedControl, _super);
    function UISegmentedControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.segmentedItems = [];
        _this.selectedSegmentIndex = -1;
        return _this;
    }
    UISegmentedControl.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        for (var _i = 0, _a = this.subviews; _i < _a.length; _i++) {
            var v = _a[_i];
            if (v instanceof _UIButton__WEBPACK_IMPORTED_MODULE_0__.UIButton)
                this._addSegmentedItem(v);
        }
        ;
    };
    UISegmentedControl.prototype._addSegmentedItem = function (item) {
        item.addTarget(this, this._didClickSegmentedButton, _UIControl__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.allTouchEvents);
        if (item.selected)
            this.selectedSegmentIndex = this.segmentedItems.count;
        this.segmentedItems.addObject(item);
    };
    UISegmentedControl.prototype._didClickSegmentedButton = function (button) {
        var index = this.segmentedItems.indexOf(button);
        this.selectSegmentedAtIndex(index);
        this.sendActions(_UIControl__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.valueChanged);
    };
    UISegmentedControl.prototype.selectSegmentedAtIndex = function (index) {
        if (this.selectedSegmentIndex == index)
            return;
        if (this.selectedSegmentIndex > -1) {
            var lastItem = this.segmentedItems[this.selectedSegmentIndex];
            lastItem.setSelected(false);
        }
        this.selectedSegmentIndex = index;
        if (index == -1)
            return;
        var item = this.segmentedItems[this.selectedSegmentIndex];
        item.setSelected(true);
    };
    UISegmentedControl.prototype.insertSegmentedItemWithTitle = function (title, atIndex, animated) {
        var item = new _UIButton__WEBPACK_IMPORTED_MODULE_0__.UIButton();
        item.init();
        item.type = _UIButton__WEBPACK_IMPORTED_MODULE_0__.UIButtonType.PushIn;
        item.title = title;
        this.addSubview(item);
        this._addSegmentedItem(item);
    };
    return UISegmentedControl;
}(_UIControl__WEBPACK_IMPORTED_MODULE_1__.UIControl));



/***/ }),

/***/ "./sources/UIStoryboard.ts":
/*!*********************************!*\
  !*** ./sources/UIStoryboard.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIStoryboard: () => (/* binding */ UIStoryboard)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIStoryboard = /** @class */ (function (_super) {
    __extends(UIStoryboard, _super);
    function UIStoryboard(name, bundle) {
        var _this = _super.call(this) || this;
        _this.name = null;
        _this.bundle = null;
        _this.items = null;
        _this.name = name;
        _this.bundle = bundle;
        return _this;
        // let content = MIOCoreGetAppResource(this.name, "json");
        // this.items = JSON.parse(content);
    }
    UIStoryboard.prototype.instantiateInitialViewController = function () {
        var resource = this.items["InitialViewControllerID"];
        if (resource == null)
            return;
        return this._instantiateViewControllerWithDestination(resource);
    };
    UIStoryboard.prototype.instantiateViewControllerWithIdentifier = function (identifier) {
        var resource = null; //TODO: Get from main.json
        return this._instantiateViewControllerWithDestination(resource);
    };
    UIStoryboard.prototype._instantiateViewControllerWithDestination = function (resource) {
        var classname = this.items["ClassByID"][resource];
        if (classname == null)
            return null;
        var vc = (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSClassFromString)(classname);
        vc.initWithNibName(resource + ".html");
        vc.storyboard = this;
        return vc;
    };
    return UIStoryboard;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));

function MUICoreStoryboardParseLayer(layer, object, owner) {
    // Check outlets and segues
    if (layer.childNodes.length > 0) {
        for (var index = 0; index < layer.childNodes.length; index++) {
            var subLayer = layer.childNodes[index];
            if (subLayer.tagName != "DIV" && subLayer.tagName != "SECTION")
                continue;
            if (subLayer.getAttribute("data-connections") == "true") {
                for (var index2 = 0; index2 < subLayer.childNodes.length; index2++) {
                    var d = subLayer.childNodes[index2];
                    if (d.tagName != "DIV")
                        continue;
                    var type = d.getAttribute("data-connection-type");
                    if (type == "outlet") {
                        var prop = d.getAttribute("data-property");
                        var outlet = d.getAttribute("data-outlet");
                        MUICoreStoryboardConnectOutlet(object, owner, prop, outlet);
                    }
                    else if (type == "segue") {
                        var destination = d.getAttribute("data-segue-destination");
                        var kind = d.getAttribute("data-segue-kind");
                        var relationship = d.getAttribute("data-segue-relationship");
                        var identifier = d.getAttribute("data-segue-identifier");
                        MUICoreStoryboardAddSegue(object, destination, kind, relationship, identifier);
                    }
                }
            }
            else if (subLayer.getAttribute("data-navigation-key") == "navigationItem") {
                // owner.navigationItem = new UINavigationItem();
                // owner.navigationItem.initWithLayer(subLayer, owner);
            }
        }
    }
}
function MUICoreStoryboardParseConnectionsLayer(layer, object, owner) {
    // Check outlets and segues
    if (layer.childNodes.length > 0) {
        for (var index = 0; index < layer.childNodes.length; index++) {
            var subLayer = layer.childNodes[index];
            if (subLayer.tagName != "DIV" && subLayer.tagName != "SECTION")
                continue;
            var type = subLayer.getAttribute("data-connection-type");
            if (type == "outlet") {
                var prop = subLayer.getAttribute("data-property");
                var outlet = subLayer.getAttribute("data-outlet");
                MUICoreStoryboardConnectOutlet(object, owner, prop, outlet);
            }
            else if (type == "segue") {
                var destination = subLayer.getAttribute("data-segue-destination");
                var kind = subLayer.getAttribute("data-segue-kind");
                var relationship = subLayer.getAttribute("data-segue-relationship");
                var identifier = subLayer.getAttribute("data-segue-identifier");
                MUICoreStoryboardAddSegue(object, destination, kind, relationship, identifier);
            }
        }
    }
}
function MUICoreStoryboardConnectOutlet(object, owner, property, outletID) {
    console.log("prop: " + property + " - outlet: " + outletID);
    var obj = owner._outlets[outletID];
    object[property] = obj;
}
function MUICoreStoryboardAddSegue(owner, destination, kind, relationship, identifier) {
    var s = {};
    s["Destination"] = destination;
    s["Kind"] = kind;
    if (identifier != null)
        s["Identifier"] = identifier;
    if (relationship != null)
        s["Relationship"] = relationship;
    owner._segues.push(s);
}


/***/ }),

/***/ "./sources/UIStoryboardSegue.ts":
/*!**************************************!*\
  !*** ./sources/UIStoryboardSegue.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIStoryboardSegue: () => (/* binding */ UIStoryboardSegue)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UIStoryboardSegue = /** @class */ (function (_super) {
    __extends(UIStoryboardSegue, _super);
    function UIStoryboardSegue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.identifier = null;
        _this.source = null;
        _this.destination = null;
        _this.performHandler = null;
        _this._sender = null;
        return _this;
    }
    UIStoryboardSegue.prototype.initWithIdentifier = function (identifier, source, destination) {
        _super.prototype.init.call(this);
        this.identifier = identifier;
        this.source = source = source;
        this.destination = destination;
    };
    UIStoryboardSegue.prototype.initWithIdentifierAndPerformHandler = function (identifier, source, destination, performHandler) {
        this.initWithIdentifier(identifier, source, destination);
        this.performHandler = performHandler;
    };
    UIStoryboardSegue.prototype.perform = function () {
        var canPerfom = this.source.shouldPerformSegueWithIdentifier(this.identifier, this._sender);
        if (canPerfom == false)
            return;
        this.source.prepareForSegue(this, this._sender);
        if (this.performHandler != null)
            this.performHandler();
    };
    return UIStoryboardSegue;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));

function _UIStoryboardSeguePerform(kind, sender, identifier, sourceViewController, destination) {
    var vc = sourceViewController.storyboard._instantiateViewControllerWithDestination(destination);
    var segue = new UIStoryboardSegue();
    segue.initWithIdentifierAndPerformHandler(identifier, sourceViewController, vc, function () {
        // if (kind == "show") this.source.navigationController.pushViewController(vc, true);
        // else if (kind == "presentation") this.source.presentViewController(vc, true);
    });
    segue._sender = sender;
    segue.perform();
}


/***/ }),

/***/ "./sources/UITableView.ts":
/*!********************************!*\
  !*** ./sources/UITableView.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UITableView: () => (/* binding */ UITableView),
/* harmony export */   UITableViewCellContentView: () => (/* binding */ UITableViewCellContentView)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIGestureRecognizer */ "./sources/UIGestureRecognizer.ts");
/* harmony import */ var _UITapGestureRecognizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UITapGestureRecognizer */ "./sources/UITapGestureRecognizer.ts");
/* harmony import */ var _UITableViewCell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./UITableViewCell */ "./sources/UITableViewCell.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _CoreAnimation_CATableLayer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CoreAnimation/CATableLayer */ "./sources/CoreAnimation/CATableLayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var UITableView = /** @class */ (function (_super) {
    __extends(UITableView, _super);
    function UITableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSource = null;
        _this.delegate = null;
        _this.allowsMultipleSelection = false;
        _this.contentView = null;
        _this.rows = [];
        _this.sections = [];
        _this.cells = [];
        return _this;
    }
    Object.defineProperty(UITableView, "layerClass", {
        get: function () { return _CoreAnimation_CATableLayer__WEBPACK_IMPORTED_MODULE_5__.CATableLayer; },
        enumerable: false,
        configurable: true
    });
    UITableView.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this.contentView = this.layer.newContentView();
        this.addSubview(this.contentView);
    };
    UITableView.prototype.dequeueReusableCellWithIdentifier = function (identifier) {
        var cell = this.layer.newCellViewByIdentifier(identifier);
        return cell;
    };
    UITableView.prototype.addSectionHeader = function (section) {
        var header = null;
        if (typeof this.dataSource.viewForHeaderInSection === "function")
            header = this.dataSource.viewForHeaderInSection(this, section);
        if (header == null)
            return;
        header.hidden = false;
        this.contentView.addSubview(header);
    };
    UITableView.prototype.addCell = function (indexPath) {
        var cell = this.dataSource.cellForRowAt(this, indexPath);
        var section = this.sections[indexPath.section];
        var nextIP = this.nextIndexPath(indexPath);
        var currentCell = this.cellAtIndexPath(indexPath);
        if (currentCell != null) {
            var index = this.rows.indexOf(currentCell);
            this.contentView.insertSubviewAboveSubview(cell, currentCell);
            this.rows.splice(index, 0, cell);
        }
        else if (nextIP != null) {
            var nextCell = this.cellAtIndexPath(nextIP);
            var index = this.rows.indexOf(nextCell);
            this.contentView.insertSubviewAboveSubview(cell, nextCell);
            this.rows.splice(index, 0, cell);
        }
        else {
            this.contentView.addSubview(cell);
            this.rows.push(cell);
        }
        // Update section
        cell._section = section;
        if (indexPath.row < section.length - 1) {
            section.splice(indexPath.row, 0, cell);
        }
        else {
            section.addObject(cell);
        }
        if (cell.selectionStyle != _UITableViewCell__WEBPACK_IMPORTED_MODULE_3__.UITableViewCellSelectionStyle.none) {
            var tapGesture = new _UITapGestureRecognizer__WEBPACK_IMPORTED_MODULE_2__.UITapGestureRecognizer();
            tapGesture.initWithTarget(this, this.cellDidTap.bind(this));
            cell.addGestureRecognizer(tapGesture);
        }
        //cell._onDblClickFn = this.cellOnDblClickFn;
        //cell._onAccessoryClickFn = this.cellOnAccessoryClickFn;
        cell._onEditingAccessoryClickFn = this.cellOnEditingAccessoryClickFn;
    };
    UITableView.prototype.removeCell = function (indexPath) {
        var section = this.sections[indexPath.section];
        var cell = section[indexPath.row];
        section.removeObjectAtIndex(indexPath.row);
        this.rows.removeObject(cell);
        cell.removeFromSuperview();
    };
    UITableView.prototype.nextIndexPath = function (indexPath) {
        var sectionIndex = indexPath.section;
        var rowIndex = indexPath.row + 1;
        if (sectionIndex >= this.sections.length)
            return null;
        var section = this.sections[sectionIndex];
        if (rowIndex < section.length)
            return foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(rowIndex, sectionIndex);
        sectionIndex++;
        if (sectionIndex >= this.sections.length)
            return null;
        section = this.sections[sectionIndex];
        if (section.length == 0)
            return null;
        return foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(0, sectionIndex);
    };
    UITableView.prototype.addSectionFooter = function (section) {
    };
    UITableView.prototype.reloadData = function () {
        // // Remove all subviews
        // for (let index = 0; index < this.rows.length; index++) {
        //     let row = this.rows[index];
        //     row.removeFromSuperview();                            
        // }
        for (var i = this.contentView.subviews.length - 1; i >= 0; i--) {
            var subview = this.contentView.subviews[i];
            subview.removeFromSuperview();
        }
        this.rows = [];
        this.sections = [];
        this.cells = [];
        if (this.dataSource == null)
            return;
        var sections = 1;
        if (typeof this.dataSource.numberOfSections === "function")
            sections = this.dataSource.numberOfSections(this);
        for (var sectionIndex = 0; sectionIndex < sections; sectionIndex++) {
            var section = [];
            this.sections.push(section);
            var rows = this.dataSource.numberOfRowsInSection(this, sectionIndex);
            if (rows == 0)
                continue;
            this.addSectionHeader(sectionIndex);
            for (var cellIndex = 0; cellIndex < rows; cellIndex++) {
                var ip = foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(cellIndex, sectionIndex);
                this.addCell(ip);
            }
            this.addSectionFooter(sectionIndex);
        }
    };
    UITableView.prototype.insertRowsAtIndexPaths = function (indexPaths, rowAnimation) {
        for (var index = 0; index < indexPaths.length; index++) {
            var ip = indexPaths[index];
            this.addCell(ip);
        }
    };
    UITableView.prototype.deleteRowsAtIndexPaths = function (indexPaths, rowAnimation) {
        for (var index = 0; index < indexPaths.length; index++) {
            var ip = indexPaths[index];
            this.removeCell(ip);
        }
    };
    UITableView.prototype.cellAtIndexPath = function (indexPath) {
        if (indexPath.section >= this.sections.length)
            return null;
        var section = this.sections[indexPath.section];
        if (indexPath.row >= section.length)
            return null;
        return section[indexPath.row];
    };
    UITableView.prototype.indexPathForCell = function (cell) {
        var section = cell._section;
        var sectionIndex = this.sections.indexOf(section);
        var rowIndex = section.indexOf(cell);
        return foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(rowIndex, sectionIndex);
    };
    UITableView.prototype.cellDidTap = function (gesture) {
        if (gesture.state != _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_1__.UIGestureRecognizerState.Ended)
            return;
        var cell = gesture.view;
        var section = cell._section;
        var sectionIndex = this.sections.indexOf(section);
        var rowIndex = section.indexOfObject(cell);
        var indexPath = foundation__WEBPACK_IMPORTED_MODULE_0__.IndexPath.indexForRowInSection(rowIndex, sectionIndex);
        var canSelectCell = true;
        if (this.delegate != null) {
            if (typeof this.delegate.canSelectCellAtIndexPath === "function")
                canSelectCell = this.delegate.canSelectCellAtIndexPath(this, indexPath);
        }
        if (canSelectCell == false)
            return;
        // TODO: Add support for multiple selection
        cell.setSelected(true, true);
        if (this.delegate != null && typeof this.delegate.didSelectCellAtIndexPath === "function") {
            this.delegate.didSelectCellAtIndexPath(this, indexPath);
        }
    };
    UITableView.prototype.cellOnClickFn = function (cell) {
        var indexPath = this.indexPathForCell(cell);
        var canSelectCell = true;
        if (this.delegate != null) {
            if (typeof this.delegate.canSelectCellAtIndexPath === "function")
                canSelectCell = this.delegate.canSelectCellAtIndexPath(this, indexPath);
        }
        if (canSelectCell == false)
            return;
        if (this.allowsMultipleSelection == false) {
            cell.setSelected(true, true);
            if (this.delegate != null && typeof this.delegate.didSelectCellAtIndexPath === "function") {
                this.delegate.didSelectCellAtIndexPath(this, indexPath);
            }
        }
        else {
            //TODO:
        }
    };
    UITableView.prototype.cellOnEditingAccessoryClickFn = function (cell) {
        var indexPath = this.indexPathForCell(cell);
        // if (this.delegate != null && typeof this.delegate.editingStyleForRowAtIndexPath === "function") {
        //     let editingStyle = this.delegate.editingStyleForRowAtIndexPath(this, indexPath);
        //     if (this.delegate != null && typeof this.delegate.commitEditingStyleForRowAtIndexPath === "function") {
        //         this.delegate.commitEditingStyleForRowAtIndexPath(this, editingStyle, indexPath);
        //     }
        // }
    };
    return UITableView;
}(_UIView__WEBPACK_IMPORTED_MODULE_4__.UIView));

var UITableViewSection = /** @class */ (function (_super) {
    __extends(UITableViewSection, _super);
    function UITableViewSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UITableViewSection.section = function () {
    };
    return UITableViewSection;
}(_UIView__WEBPACK_IMPORTED_MODULE_4__.UIView));
var UITableViewRow = /** @class */ (function (_super) {
    __extends(UITableViewRow, _super);
    function UITableViewRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.section = null;
        _this.cell = null;
        return _this;
    }
    UITableViewRow.rowWithSectionAndCell = function (section, cell) {
        var row = new UITableViewRow();
        row.init();
        row.section = section;
        row.cell = cell;
    };
    return UITableViewRow;
}(_UIView__WEBPACK_IMPORTED_MODULE_4__.UIView));
var UITableViewCellContentView = /** @class */ (function (_super) {
    __extends(UITableViewCellContentView, _super);
    function UITableViewCellContentView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UITableViewCellContentView;
}(_UIView__WEBPACK_IMPORTED_MODULE_4__.UIView));



/***/ }),

/***/ "./sources/UITableViewCell.ts":
/*!************************************!*\
  !*** ./sources/UITableViewCell.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UITableViewCell: () => (/* binding */ UITableViewCell),
/* harmony export */   UITableViewCellAccessoryType: () => (/* binding */ UITableViewCellAccessoryType),
/* harmony export */   UITableViewCellEditingStyle: () => (/* binding */ UITableViewCellEditingStyle),
/* harmony export */   UITableViewCellSelectionStyle: () => (/* binding */ UITableViewCellSelectionStyle),
/* harmony export */   UITableViewCellSeparatorStyle: () => (/* binding */ UITableViewCellSeparatorStyle),
/* harmony export */   UITableViewCellStyle: () => (/* binding */ UITableViewCellStyle)
/* harmony export */ });
/* harmony import */ var _UILabel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UILabel */ "./sources/UILabel.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _CoreAnimation_CATableCellLayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreAnimation/CATableCellLayer */ "./sources/CoreAnimation/CATableCellLayer.ts");
/// <reference path="core/UICoreLayer.ts" />
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var UITableViewCellStyle;
(function (UITableViewCellStyle) {
    UITableViewCellStyle[UITableViewCellStyle["custom"] = 0] = "custom";
    UITableViewCellStyle[UITableViewCellStyle["default"] = 1] = "default";
})(UITableViewCellStyle || (UITableViewCellStyle = {}));
var UITableViewCellAccessoryType;
(function (UITableViewCellAccessoryType) {
    UITableViewCellAccessoryType[UITableViewCellAccessoryType["none"] = 0] = "none";
    UITableViewCellAccessoryType[UITableViewCellAccessoryType["disclosureIndicator"] = 1] = "disclosureIndicator";
    UITableViewCellAccessoryType[UITableViewCellAccessoryType["detailDisclosureButton"] = 2] = "detailDisclosureButton";
    UITableViewCellAccessoryType[UITableViewCellAccessoryType["checkmark"] = 3] = "checkmark";
})(UITableViewCellAccessoryType || (UITableViewCellAccessoryType = {}));
var UITableViewCellEditingStyle;
(function (UITableViewCellEditingStyle) {
    UITableViewCellEditingStyle[UITableViewCellEditingStyle["none"] = 0] = "none";
    UITableViewCellEditingStyle[UITableViewCellEditingStyle["delete"] = 1] = "delete";
    UITableViewCellEditingStyle[UITableViewCellEditingStyle["insert"] = 2] = "insert";
})(UITableViewCellEditingStyle || (UITableViewCellEditingStyle = {}));
var UITableViewCellSeparatorStyle;
(function (UITableViewCellSeparatorStyle) {
    UITableViewCellSeparatorStyle[UITableViewCellSeparatorStyle["none"] = 0] = "none";
    UITableViewCellSeparatorStyle[UITableViewCellSeparatorStyle["singleLine"] = 1] = "singleLine";
    UITableViewCellSeparatorStyle[UITableViewCellSeparatorStyle["singleLineEtched"] = 2] = "singleLineEtched"; // TODO 
})(UITableViewCellSeparatorStyle || (UITableViewCellSeparatorStyle = {}));
var UITableViewCellSelectionStyle;
(function (UITableViewCellSelectionStyle) {
    UITableViewCellSelectionStyle[UITableViewCellSelectionStyle["none"] = 0] = "none";
    UITableViewCellSelectionStyle[UITableViewCellSelectionStyle["default"] = 1] = "default";
})(UITableViewCellSelectionStyle || (UITableViewCellSelectionStyle = {}));
var UITableViewCell = /** @class */ (function (_super) {
    __extends(UITableViewCell, _super);
    function UITableViewCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reuseIdentifier = null;
        _this.nodeID = null;
        _this.contentView = null;
        _this.style = UITableViewCellStyle.custom;
        _this.textLabel = null;
        _this.accessoryView = null;
        _this.separatorStyle = UITableViewCellSeparatorStyle.singleLine;
        _this._editing = false;
        _this.editingAccessoryView = null;
        _this.selectionStyle = UITableViewCellSelectionStyle.default;
        _this._selected = false;
        _this._target = null;
        _this._onClickFn = null;
        _this._onDblClickFn = null;
        _this._onAccessoryClickFn = null;
        _this._onEditingAccessoryClickFn = null;
        _this._section = null;
        _this.editingAccessoryInsertView = null;
        _this.editingAccessoryDeleteView = null;
        _this._editingAccessoryType = UITableViewCellEditingStyle.none;
        _this._accessoryType = UITableViewCellAccessoryType.none;
        return _this;
    }
    Object.defineProperty(UITableViewCell, "layerClass", {
        get: function () { return _CoreAnimation_CATableCellLayer__WEBPACK_IMPORTED_MODULE_2__.CATableCellLayer; },
        enumerable: false,
        configurable: true
    });
    UITableViewCell.prototype.initWithStyle = function (style) {
        _super.prototype.init.call(this);
        this.style = style;
        if (style == UITableViewCellStyle.default) {
            this.textLabel = new _UILabel__WEBPACK_IMPORTED_MODULE_0__.UILabel();
            this.textLabel.init();
            this.addSubview(this.textLabel);
        }
        this._setupLayer();
    };
    /*
        initWithLayer(layer, owner, options?) {
            // super.initWithLayer(layer, owner, options);
    
            this.scanLayerNodes(layer, owner);
            
            let style = layer.getAttribute("data-cell-style");
            if (style == "IBUITableViewCellStyleDefault") {
                this.style = UITableViewCellStyle.default;
                let propertyID = layer.getAttribute("data-cell-textlabel-id")
                let item = owner._outlets[propertyID];
                this.textLabel = item;
            }
    
            //MUICoreStoryboardParseLayer(layer, this, owner);
    
            this._setupLayer();
        }
    */
    UITableViewCell.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this._setupLayer();
    };
    UITableViewCell.prototype.accessoryViewDidClick = function (e) {
        e.stopPropagation();
        this._onAccessoryClickFn.call(this._target, this);
    };
    Object.defineProperty(UITableViewCell.prototype, "editingAccessoryType", {
        get: function () { return this._editingAccessoryType; },
        set: function (value) {
            this.setEditingAccessoryType(value);
        },
        enumerable: false,
        configurable: true
    });
    UITableViewCell.prototype.setEditingAccessoryType = function (value) {
        this._editingAccessoryType = value;
        // Reset
        if (this.editingAccessoryDeleteView != null)
            this.editingAccessoryDeleteView.setHidden(true);
        if (this.editingAccessoryInsertView != null)
            this.editingAccessoryInsertView.setHidden(true);
        if (this.editingAccessoryView != null)
            this.editingAccessoryView.setHidden(true);
        // Set the view type
        if (value == UITableViewCellEditingStyle.insert && this.editingAccessoryInsertView != null) {
            this.editingAccessoryView = this.editingAccessoryInsertView;
            this.editingAccessoryInsertView.setHidden(false);
        }
        else if (value == UITableViewCellEditingStyle.delete && this.editingAccessoryDeleteView != null) {
            this.editingAccessoryView = this.editingAccessoryDeleteView;
            this.editingAccessoryDeleteView.setHidden(false);
        }
    };
    UITableViewCell.prototype.editingAccessoryViewDidClick = function (e) {
        e.stopPropagation();
        this._onEditingAccessoryClickFn.call(this._target, this);
    };
    UITableViewCell.prototype._setupLayer = function () {
        // this.layer.registerEventAction( this, this._onClickFn );
        // this.layer.ondblclick = function (e) {
        //     if (instance._onDblClickFn != null) {
        //         e.stopPropagation();
        //         instance._onDblClickFn.call(instance._target, instance);
        //     }
        // };
    };
    Object.defineProperty(UITableViewCell.prototype, "accessoryType", {
        get: function () { return this._accessoryType; },
        set: function (value) {
            this.setAccessoryType(value);
        },
        enumerable: false,
        configurable: true
    });
    UITableViewCell.prototype.setAccessoryType = function (type) {
        if (type == this._accessoryType)
            return;
        if (this.accessoryView == null) {
            // if (this.style == UITableViewCellStyle.default) this.textLabel.layer.style.right = "25px";
            var layer = document.createElement("div");
            layer.style.position = "absolute";
            layer.style.top = "15px";
            layer.style.right = "5px";
            layer.style.width = "15px";
            layer.style.height = "15px";
            // this.accessoryView = new UIView("accessory_view");
            // this.accessoryView.initWithLayer(layer, null);
            // this.addSubview(this.accessoryView);
        }
        // if (type == UITableViewCellAccessoryType.None) this.accessoryView.setHidden(true);
        // else this.accessoryView.setHidden(false);
        // if (type == UITableViewCellAccessoryType.none) MUICoreLayerRemoveStyle(this.layer, "checked");
        // else MUICoreLayerAddStyle(this.layer, "checked");
        // this._accessoryType = type;
    };
    UITableViewCell.prototype.setPaddingIndex = function (value) {
        var offset = (value + 1) * 10;
        if (this.style == UITableViewCellStyle.default)
            this.textLabel.setX(offset);
    };
    UITableViewCell.prototype.setHeight = function (h) {
        _super.prototype.setHeight.call(this, h);
        var offsetY = (h - 15) / 2;
        if (this.accessoryView != null) {
            // this.accessoryView.layer.style.top = offsetY + "px";
        }
    };
    UITableViewCell.prototype.setSelected = function (value, animated) {
        if (this._selected == value)
            return;
        this.willChangeValue("selected");
        this._selected = value;
        this.layer.setSelected(value, animated);
        this.didChangeValue("selected");
    };
    Object.defineProperty(UITableViewCell.prototype, "isSelected", {
        get: function () { return this._selected; },
        set: function (value) { this.setSelected(value, false); },
        enumerable: false,
        configurable: true
    });
    UITableViewCell.prototype._setHightlightedSubviews = function (value) {
        for (var count = 0; count < this.subviews.length; count++) {
            var v = this.subviews[count];
            if (v instanceof _UILabel__WEBPACK_IMPORTED_MODULE_0__.UILabel)
                v.setHightlighted(value);
        }
        if (this.accessoryView == null)
            return;
        if (value == true) {
            switch (this.accessoryType) {
                case UITableViewCellAccessoryType.disclosureIndicator:
                    //this.accessoryView.layer.classList.remove("tableviewcell_accessory_disclosure_indicator");
                    //this.accessoryView.layer.classList.add("tableviewcell_accessory_disclosure_indicator_highlighted");
                    break;
            }
        }
        else {
            switch (this.accessoryType) {
                case UITableViewCellAccessoryType.disclosureIndicator:
                    //this.accessoryView.layer.classList.remove("tableviewcell_accessory_disclosure_indicator_highlighted");
                    //this.accessoryView.layer.classList.add("tableviewcell_accessory_disclosure_indicator");
                    break;
            }
        }
    };
    UITableViewCell.prototype.setEditing = function (editing, animated) {
        if (editing == this._editing)
            return;
        this._editing = editing;
        if (this.editingAccessoryView != null) {
            this.editingAccessoryView.setHidden(!editing);
        }
    };
    Object.defineProperty(UITableViewCell.prototype, "editing", {
        set: function (value) {
            this.setEditing(value, false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UITableViewCell.prototype, "isEditing", {
        get: function () {
            return this._editing;
        },
        enumerable: false,
        configurable: true
    });
    return UITableViewCell;
}(_UIView__WEBPACK_IMPORTED_MODULE_1__.UIView));



/***/ }),

/***/ "./sources/UITapGestureRecognizer.ts":
/*!*******************************************!*\
  !*** ./sources/UITapGestureRecognizer.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UITapGestureRecognizer: () => (/* binding */ UITapGestureRecognizer)
/* harmony export */ });
/* harmony import */ var _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./UIGestureRecognizer */ "./sources/UIGestureRecognizer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UITapGestureRecognizer = /** @class */ (function (_super) {
    __extends(UITapGestureRecognizer, _super);
    function UITapGestureRecognizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.numberOfTapsRequired = 1;
        return _this;
    }
    UITapGestureRecognizer.prototype.touchesBeganWithEvent = function (touches, ev) {
        _super.prototype.touchesBeganWithEvent.call(this, touches, ev);
        this.state = _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_0__.UIGestureRecognizerState.Began;
    };
    UITapGestureRecognizer.prototype.touchesEndedWithEvent = function (touches, ev) {
        _super.prototype.touchesEndedWithEvent.call(this, touches, ev);
        this.state = _UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_0__.UIGestureRecognizerState.Ended;
    };
    return UITapGestureRecognizer;
}(_UIGestureRecognizer__WEBPACK_IMPORTED_MODULE_0__.UIGestureRecognizer));



/***/ }),

/***/ "./sources/UITextArea.ts":
/*!*******************************!*\
  !*** ./sources/UITextArea.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UITextArea: () => (/* binding */ UITextArea)
/* harmony export */ });
/* harmony import */ var _CoreAnimation_CATextAreaLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CoreAnimation/CATextAreaLayer */ "./sources/CoreAnimation/CATextAreaLayer.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/**
 * Created by godshadow on 15/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UITextArea = /** @class */ (function (_super) {
    __extends(UITextArea, _super);
    function UITextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textareaLayer = null;
        _this.textChangeTarget = null;
        _this.textChangeAction = null;
        return _this;
    }
    Object.defineProperty(UITextArea, "layerClass", {
        get: function () { return _CoreAnimation_CATextAreaLayer__WEBPACK_IMPORTED_MODULE_0__.CATextAreaLayer; },
        enumerable: false,
        configurable: true
    });
    /*
    initWithCoder(coder: NSCoder): void {
        super.initWithCoder( coder );
        // (this.layer as CATextAreaLayer).onChangeBlock = ( value:string ) => { this._textDidChange( value ); }
    }
    */
    UITextArea.prototype.setText = function (text) { this.text = text; };
    Object.defineProperty(UITextArea.prototype, "text", {
        get: function () { return this.layer.string; },
        set: function (text) { this.layer.string = text != null ? text : ""; },
        enumerable: false,
        configurable: true
    });
    UITextArea.prototype.setEditMode = function (value) {
        this.textareaLayer.disabled = !value;
    };
    UITextArea.prototype.setOnChangeText = function (target, action) {
        /*    this.textChangeTarget = target;
            this.textChangeAction = action;
            var instance = this;
    
            this.textareaLayer.addEventListener("input", function(e){
                if (instance.enabled) {
                    let value = instance.textareaLayer.value;
                    instance.textChangeAction.call(target, instance, value);
                }
            });
            */
    };
    return UITextArea;
}(_UIControl__WEBPACK_IMPORTED_MODULE_1__.UIControl));



/***/ }),

/***/ "./sources/UITextField.ts":
/*!********************************!*\
  !*** ./sources/UITextField.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UITextField: () => (/* binding */ UITextField),
/* harmony export */   UITextFieldType: () => (/* binding */ UITextFieldType)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CoreAnimation_CAInputLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreAnimation/CAInputLayer */ "./sources/CoreAnimation/CAInputLayer.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/**
 * Created by godshadow on 12/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var UITextFieldType;
(function (UITextFieldType) {
    UITextFieldType[UITextFieldType["normalType"] = 0] = "normalType";
    UITextFieldType[UITextFieldType["passwordType"] = 1] = "passwordType";
    UITextFieldType[UITextFieldType["searchType"] = 2] = "searchType";
})(UITextFieldType || (UITextFieldType = {}));
var UITextField = /** @class */ (function (_super) {
    __extends(UITextField, _super);
    function UITextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.placeHolder = null;
        _this.type = UITextFieldType.normalType;
        _this._inputLayer = null;
        _this.textChangeTarget = null;
        _this.textChangeAction = null;
        _this._textChangeFn = null;
        _this.enterPressTarget = null;
        _this.enterPressAction = null;
        _this.keyPressTarget = null;
        _this.keyPressAction = null;
        _this.formatter = null;
        _this._textStopPropagationFn = null;
        _this.didBeginEditingAction = null;
        _this.didBeginEditingTarget = null;
        _this._textDidBeginEditingFn = null;
        _this.didEndEditingAction = null;
        _this.didEndEditingTarget = null;
        _this._textDidEndEditingFn = null;
        return _this;
    }
    Object.defineProperty(UITextField, "layerClass", {
        get: function () { return _CoreAnimation_CAInputLayer__WEBPACK_IMPORTED_MODULE_1__.CAInputLayer; },
        enumerable: false,
        configurable: true
    });
    UITextField.prototype.initWithCoder = function (coder) {
        var _this = this;
        _super.prototype.initWithCoder.call(this, coder);
        this.layer.onChangeBlock = function (value) { _this._textDidChange(value); };
    };
    // initWithLayer(layer, owner, options?){
    //     super.initWithLayer(layer, owner, options);
    //     this._inputLayer = MUICoreLayerGetFirstElementWithTag(this.layer, "INPUT");
    //     this._setupLayer();
    // }
    UITextField.prototype._setupLayer = function () {
        if (this._inputLayer == null) {
            this._inputLayer = document.createElement("input");
            switch (this.type) {
                case UITextFieldType.searchType:
                    this._inputLayer.setAttribute("type", "search");
                    break;
                default:
                    this._inputLayer.setAttribute("type", "text");
                    break;
            }
            // this.layer.appendChild(this._inputLayer);
        }
        var placeholderKey = this._inputLayer.getAttribute("data-placeholder");
        if (placeholderKey != null)
            this._inputLayer.setAttribute("placeholder", (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLocalizeString)(placeholderKey, placeholderKey));
        this._registerInputEvent();
    };
    // layoutSubviews(){
    //     super.layoutSubviews();
    // var w = this.getWidth();
    // var h = this.getHeight();
    // this._inputLayer.style.marginLeft = "4px";
    // this._inputLayer.style.width = (w - 8) + "px";
    // this._inputLayer.style.marginTop = "4px";
    // this._inputLayer.style.height = (h - 8) + "px";
    //    }
    UITextField.prototype.setText = function (text) {
        this.text = text;
    };
    Object.defineProperty(UITextField.prototype, "text", {
        get: function () {
            return this.layer.string;
        },
        set: function (text) {
            var newValue = text != null ? text : "";
            this.layer.string = newValue;
        },
        enumerable: false,
        configurable: true
    });
    UITextField.prototype.setPlaceholderText = function (text) {
        this.layer.placeHolderText = text;
    };
    Object.defineProperty(UITextField.prototype, "placeholderText", {
        set: function (text) { this.setPlaceholderText(text); },
        enumerable: false,
        configurable: true
    });
    UITextField.prototype.setOnChangeText = function (target, action) {
        this.textChangeTarget = target;
        this.textChangeAction = action;
    };
    UITextField.prototype._registerInputEvent = function () {
        var instance = this;
        this._textChangeFn = function () {
            if (instance.enabled)
                instance._textDidChange.call(instance);
        };
        this._textStopPropagationFn = function (e) {
            //instance._textDidBeginEditing();
            e.stopPropagation();
        };
        this._textDidBeginEditingFn = this._textDidBeginEditing.bind(this);
        this._textDidEndEditingFn = this._textDidEndEditing.bind(this);
        // this.layer.addEventListener("input", this._textChangeFn);        
        // this.layer.addEventListener("click", this._textStopPropagationFn);
        // this._inputLayer.addEventListener("focus", this._textDidBeginEditingFn);
        // this._inputLayer.addEventListener("blur", this._textDidEndEditingFn);
    };
    UITextField.prototype._unregisterInputEvent = function () {
        // this.layer.removeEventListener("input", this._textChangeFn);
        // this.layer.removeEventListener("click", this._textStopPropagationFn);
        // this._inputLayer.removeEventListener("focus", this._textDidBeginEditingFn);
        // this._inputLayer.removeEventListener("blur", this._textDidEndEditingFn);
    };
    UITextField.prototype._textDidChange = function (value) {
        var _a;
        if (this.enabled == false)
            return;
        // Check the formater        
        if (this.formatter == null) {
            this._textDidChangeDelegate(value);
        }
        else {
            var result = void 0, newStr = void 0;
            _a = this.formatter.isPartialStringValid(value), result = _a[0], newStr = _a[1];
            this._unregisterInputEvent();
            this._inputLayer.value = newStr;
            this._registerInputEvent();
            if (result == true) {
                this._textDidChangeDelegate(value);
            }
        }
    };
    UITextField.prototype._textDidChangeDelegate = function (value) {
        if (this.textChangeAction != null && this.textChangeTarget != null)
            this.textChangeAction.call(this.textChangeTarget, this, value);
    };
    UITextField.prototype.setOnBeginEditing = function (target, action) {
        this.didBeginEditingTarget = target;
        this.didBeginEditingAction = action;
    };
    UITextField.prototype._textDidBeginEditing = function () {
        if (this.enabled == false)
            return;
        //if (this.formatter != null) this.text = this.formatter.stringForObjectValue(this.text);
        if (this.didBeginEditingTarget == null || this.didBeginEditingAction == null)
            return;
        this.didBeginEditingAction.call(this.didBeginEditingTarget, this, this.text);
    };
    UITextField.prototype.setOnDidEndEditing = function (target, action) {
        this.didEndEditingTarget = target;
        this.didEndEditingAction = action;
    };
    UITextField.prototype._textDidEndEditing = function () {
        if (this.enabled == false)
            return;
        //if (this.formatter != null) this.text = this.formatter.stringForObjectValue(this.text);
        if (this.didEndEditingTarget == null || this.didEndEditingAction == null)
            return;
        this.didEndEditingAction.call(this.didEndEditingTarget, this, this.text);
    };
    UITextField.prototype.setOnEnterPress = function (target, action) {
        this.enterPressTarget = target;
        this.enterPressAction = action;
        var instance = this;
        // this.layer.onkeyup = function(e){
        //     if (instance.enabled) {
        //         if (e.keyCode == 13)
        //             instance.enterPressAction.call(target, instance, instance._inputLayer.value);
        //     }
        // }
    };
    UITextField.prototype.setOnKeyPress = function (target, action) {
        this.keyPressTarget = target;
        this.keyPressAction = action;
        var instance = this;
        // this.layer.onkeydown = function(e){
        //     if (instance.enabled) {
        //         instance.keyPressAction.call(target, instance, e.keyCode);
        //     }
        // }
    };
    UITextField.prototype.setTextRGBColor = function (r, g, b) {
        var value = "rgb(" + r + ", " + g + ", " + b + ")";
        this._inputLayer.style.color = value;
    };
    Object.defineProperty(UITextField.prototype, "textColor", {
        set: function (color) {
            this._inputLayer.style.color = color;
        },
        enumerable: false,
        configurable: true
    });
    // get textColor(){
    //     let color = this._getValueFromCSSProperty("color");
    //     return color;        
    // }
    UITextField.prototype.setEnabled = function (value) {
        _super.prototype.setEnabled.call(this, value);
        this._inputLayer.readOnly = !value;
    };
    UITextField.prototype.becomeFirstResponder = function () {
        this._inputLayer.focus();
    };
    UITextField.prototype.resignFirstResponder = function () {
        this._inputLayer.blur();
    };
    UITextField.prototype.selectAll = function (control) {
        this._inputLayer.select();
    };
    return UITextField;
}(_UIControl__WEBPACK_IMPORTED_MODULE_2__.UIControl));



/***/ }),

/***/ "./sources/UIView.ts":
/*!***************************!*\
  !*** ./sources/UIView.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIView: () => (/* binding */ UIView)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/UICoreNibParser */ "./sources/core/UICoreNibParser.ts");
/* harmony import */ var _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreAnimation/CALayer */ "./sources/CoreAnimation/CALayer.ts");
/* harmony import */ var _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreGraphics/CGRect */ "./sources/CoreGraphics/CGRect.ts");
/* harmony import */ var _UIEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./UIEvent */ "./sources/UIEvent.ts");
/* harmony import */ var _UIResponder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./UIResponder */ "./sources/UIResponder.ts");
/**
 * Created by godshadow on 11/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var UIView = /** @class */ (function (_super) {
    __extends(UIView, _super);
    function UIView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.layerID = null;
        _this.layerOptions = null;
        _this.alpha = 1;
        _this.tag = 0;
        _this.owner = null;
        _this._superview = null;
        _this._viewIsVisible = false;
        _this._needDisplay = true;
        _this._subviews = [];
        _this._window = null;
        _this._outlets = {};
        _this._segues = [];
        _this._hidden = false;
        _this.x = 0;
        _this.y = 0;
        _this.width = 0;
        _this.height = 0;
        //
        // Event handling and user interaction
        //
        _this._userInteraction = false;
        return _this;
    }
    Object.defineProperty(UIView.prototype, "superview", {
        get: function () { return this._superview; },
        set: function (view) { this.setSuperview(view); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIView.prototype, "subviews", {
        get: function () {
            return this._subviews;
        },
        enumerable: false,
        configurable: true
    });
    UIView.prototype._checkSegues = function () {
    };
    UIView.prototype._performSegue = function () {
        if (this._segues.length == 0)
            return;
        var item = this._segues[0];
        // _UIStoryboardSeguePerform(item["Kind"], this, item["Identifier"], this.owner, item["Destination"]);        
    };
    Object.defineProperty(UIView, "layerClass", {
        // constructor(layerID?) {
        //     super();
        //     this.layerID = layerID ? layerID : MUICoreLayerIDFromObject(this);
        // }
        get: function () { return _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_2__.CALayer; },
        enumerable: false,
        configurable: true
    });
    UIView.prototype.init = function () {
        var c = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreClassByName)(this.className);
        this.layer = c ? new c.layerClass() : new UIView.layerClass();
        //if (this.layer == null) this.layer = new UIView.layerClass();
        // this.layer = MUICoreLayerCreate(this.layerID);        
        //UICoreLayerAddStyle(this.layer, "view");
        //UICoreLayerAddStyle(this.layer, "view");
        //this.layer.style.position = "absolute";
        // this.layer.style.top = "0px";
        // this.layer.style.left = "0px";
        //this.layer.style.width = "100%";
        //this.layer.style.height = "100%";
        //this.layer.style.background = "rgb(255, 255, 255)";                
    };
    UIView.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        if (coder instanceof _core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_1__.UICoreNibCoder) {
            var c = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreClassByName)(this.className);
            this.layer = new c.layerClass(coder.layerContents);
            this._subviews = coder.decodeSubviews();
            // Custom properties
            this.tag = coder.decodeIntegerForKey("tag");
            this._assign_outlets(coder);
        }
        this.awakeFromNib();
    };
    UIView.prototype._assign_outlets = function (coder) {
        for (var key in this._outlets) {
            var obj = coder.outlets[key];
            var prop = this._outlets[key];
            this[prop] = obj;
        }
    };
    UIView.prototype.initWithFrame = function (frame) {
        this.layer = new _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_2__.CALayer(this.layerID);
        // this.layer = MUICoreLayerCreate(this.layerID);
        // this.layer.style.position = "absolute";
        this.setX(frame.origin.x);
        this.setY(frame.origin.y);
        this.setWidth(frame.size.width);
        this.setHeight(frame.size.height);
    };
    UIView.prototype.awakeFromNib = function () { };
    UIView.prototype.setSuperview = function (view) {
        this.willChangeValue("parent");
        this._superview = view;
        this.didChangeValue("parent");
    };
    UIView.prototype._linkViewToSubview = function (view) {
        if ((view instanceof UIView) == false)
            throw new Error("_linkViewToSubview: Trying to add an object that is not a view");
        this.subviews.push(view);
    };
    UIView.prototype.addSubview = function (view, index) {
        if ((view instanceof UIView) == false)
            throw new Error("addSubview: Trying to add an object that is not a view");
        view.setSuperview(this);
        if (index == null)
            this.subviews.push(view);
        else
            this.subviews.splice(index, 0, view);
        this.layer.addSublayer(view.layer);
        view.setNeedsDisplay();
    };
    UIView.prototype.insertSubviewAboveSubview = function (view, siblingSubview) {
        view.setSuperview(this);
        var index = this.subviews.indexOf(siblingSubview);
        this.subviews.splice(index, 0, view);
        this.addLayerBeforeLayer(view.layer, siblingSubview.layer);
        view.setNeedsDisplay();
    };
    UIView.prototype.addLayerBeforeLayer = function (newLayer, layer) {
        // if (newLayer._isLayerInDOM == true) return;
        // if (layer == null || newLayer == null) return;
        // this.layer.insertBefore(newLayer, layer);
        // newLayer._isLayerInDOM = true;
    };
    UIView.prototype.removeFromSuperview = function () {
        if (this.superview == null)
            return;
        this.layer.removeFromSuperlayer();
        this.superview.subviews.removeObject(this);
    };
    // private _removeAllSubviews() {
    //     var node = this.layer;
    //     while (this.layer.hasChildNodes()) {              // selected elem has children
    //         if (node.hasChildNodes()) {                // current node has children
    //             node = node.lastChild;                 // set current node to child
    //         }
    //         else {                                     // last child found
    //             node = node.parentNode;                // set node to parent
    //             node.removeChild(node.lastChild);      // remove last node
    //         }
    //     }
    // }
    UIView.prototype.setViewIsVisible = function (value) {
        this._viewIsVisible = true;
        for (var index = 0; index < this.subviews.length; index++) {
            var v = this.subviews[index];
            v.setViewIsVisible(value);
        }
    };
    UIView.prototype.viewWithTag = function (tag) {
        // TODO: Use also the view tag component
        // let view = MUICoreViewSearchViewTag(this, tag);
        return null;
    };
    UIView.prototype.layoutSubviews = function () {
        for (var index = 0; index < this.subviews.length; index++) {
            var v = this.subviews[index];
            if ((v instanceof UIView) == false)
                throw new Error("layout: Trying to layout an object that is not a view");
            v.setNeedsDisplay();
        }
    };
    UIView.prototype.setNeedsDisplay = function () {
        this._needDisplay = true;
        if (this._viewIsVisible == false)
            return;
        if (this.hidden == true)
            return;
        this._needDisplay = false;
        this.layoutSubviews();
        for (var index = 0; index < this.subviews.length; index++) {
            var v = this.subviews[index];
            if (!(v instanceof UIView)) {
                console.log("ERROR: trying to call setNeedsDisplay: in object that it's not a view");
            }
            else
                v.setNeedsDisplay();
        }
    };
    // layerWithItemID(itemID) {
    //     return MUICoreLayerSearchElementByID(this.layer, itemID);
    // }
    UIView.prototype.copy = function () {
        return (0,_core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_1__.UICoreNibCopy)(this.layer.contents);
    };
    UIView.prototype.setHidden = function (hidden) {
        this._hidden = hidden;
        this.layer.isHidden = hidden;
    };
    Object.defineProperty(UIView.prototype, "hidden", {
        get: function () {
            return this._hidden;
        },
        set: function (value) {
            this.setHidden(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIView.prototype, "backgroundColor", {
        set: function (color) { this.setBackgroundColor(color); },
        enumerable: false,
        configurable: true
    });
    UIView.prototype.setBackgroundColor = function (color) {
        // this.layer.style.backgroundColor = "#" + color;
    };
    // getBackgroundColor() {
    //     var cs = document.defaultView.getComputedStyle(this.layer, null);
    //     var bg = cs.getPropertyValue('background-color');
    //     return bg;
    // }
    UIView.prototype.setAlpha = function (alpha) {
        // this.willChangeValue("alpha");
        // this.alpha = alpha;
        // this.didChangeValue("alpha");
        // if (UIView.animationsChanges != null) {
        //     let animation = { "View": this, "Key": "opacity", "EndValue": alpha };
        //     UIView.animationsChanges.addObject(animation);
        // }
        // else {
        //     this.layer.style.opacity = alpha;
        // }
    };
    UIView.prototype.setX = function (x) {
        this.willChangeValue("frame");
        this.x = x;
        this.didChangeValue("frame");
        if (UIView.animationsChanges != null) {
            var animation = { "View": this, "Key": "x", "EndValue": x + "px" };
            UIView.animationsChanges.addObject(animation);
        }
        else {
            // this.layer.style.left = x + "px";
        }
    };
    UIView.prototype.getX = function () {
        // let x = this._getIntValueFromCSSProperty("left");
        // return x;
        return 0;
    };
    UIView.prototype.setY = function (y) {
        this.willChangeValue("frame");
        this.y = y;
        this.didChangeValue("frame");
        if (UIView.animationsChanges != null) {
            var animation = { "View": this, "Key": "y", "EndValue": y + "px" };
            UIView.animationsChanges.addObject(animation);
        }
        else {
            // this.layer.style.top = y + "px";
        }
    };
    UIView.prototype.getY = function () {
        // let y = this._getIntValueFromCSSProperty("top");
        // return y;
        return 0;
    };
    UIView.prototype.setWidth = function (w) {
        this.willChangeValue("frame");
        this.width = w;
        this.didChangeValue("frame");
        if (UIView.animationsChanges != null) {
            var animation = { "View": this, "Key": "width", "EndValue": w + "px" };
            UIView.animationsChanges.addObject(animation);
        }
        else {
            // this.layer.style.width = w + "px";
        }
    };
    UIView.prototype.getWidth = function () {
        // let w1 = this.layer.clientWidth;
        // let w2 = this._getIntValueFromCSSProperty("width");
        // let w = Math.max(w1, w2);
        // if (isNaN(w)) w = 0;
        // return w;
        return 0;
    };
    UIView.prototype.setHeight = function (height) {
        this.willChangeValue("height");
        this.height = height;
        this.didChangeValue("height");
        if (UIView.animationsChanges != null) {
            var animation = { "View": this, "Key": "height", "EndValue": height + "px" };
            UIView.animationsChanges.addObject(animation);
        }
        else {
            // this.layer.style.height = height + "px";
        }
    };
    UIView.prototype.getHeight = function () {
        // let h = this.height;
        // if (h == 0) h = this.layer.clientHeight;
        // else {
        //     if (h == 0) h = this.layer.height;
        //     else if (h == 0) h = this._getIntValueFromCSSProperty("height");
        // }
        // return h;
        return 0;
    };
    UIView.prototype.setFrameComponents = function (x, y, w, h) {
        this.setX(x);
        this.setY(y);
        this.setWidth(w);
        this.setHeight(h);
    };
    UIView.prototype.setFrame = function (frame) {
        this.willChangeValue("frame");
        this.setFrameComponents(frame.origin.x, frame.origin.y, frame.size.width, frame.size.height);
        this.didChangeValue("frame");
    };
    Object.defineProperty(UIView.prototype, "frame", {
        get: function () {
            return _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__.CGRect.rectFromValues(this.getX(), this.getY(), this.getWidth(), this.getHeight());
        },
        set: function (frame) {
            this.setFrame(frame);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIView.prototype, "bounds", {
        get: function () {
            return _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__.CGRect.rectFromValues(0, 0, this.getWidth(), this.getHeight());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIView.prototype, "userInteraction", {
        get: function () { return this._userInteraction; },
        set: function (value) {
            if (value == this._userInteraction)
                return;
            if (value == true) {
                this.layer.registerEventAction(this, this.on_event);
            }
            else {
                this.layer.unregisterEventAction(this, this.on_event);
            }
        },
        enumerable: false,
        configurable: true
    });
    UIView.prototype.on_event = function (event) {
        switch (event) {
            case _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_2__.CALayerEvent.mouseDown:
                this.on_mouse_down_event(event);
                break;
            case _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_2__.CALayerEvent.mouseUp:
                this.on_mouse_up_event(event);
                break;
        }
    };
    UIView.prototype.on_mouse_down_event = function (event) {
        var e = new _UIEvent__WEBPACK_IMPORTED_MODULE_4__.UIEvent(); //.eventWithSysEvent( event );
        this.touchesBeganWithEvent(null, e);
        // this.isMouseDown = true;
        // window.addEventListener("mousemove", this.mouseMoveEvent.bind(this));
        // ev.preventDefault(); // Prevent selection
    };
    UIView.prototype.on_mouse_up_event = function (event) {
        // this.isMouseDown = false;
        var e = new _UIEvent__WEBPACK_IMPORTED_MODULE_4__.UIEvent(); //.eventWithSysEvent(ev);
        this.touchesEndedWithEvent(null, e);
    };
    UIView.prototype.mouseMoveEvent = function (ev) {
        // if (this.isMouseDown == false) return;
        // if (ev.buttons == 0) {
        //     window.removeEventListener("mousemove", this.mouseMoveEvent);
        //     this.isMouseDown = false;
        //     let e = UIEvent.eventWithSysEvent(ev);
        //     this.touchesEndedWithEvent(null, e);
        // }
        // else {
        //     let e = UIEvent.eventWithSysEvent(ev);
        //     this.touchesMovedWithEvent(null, e);
        // }
    };
    UIView.prototype.addGestureRecognizer = function (gesture) {
        if (this.gestureRecognizers.containsObject(gesture))
            return;
        gesture.view = this;
        this.gestureRecognizers.addObject(gesture);
        this.userInteraction = true;
    };
    UIView.prototype.removeGestureRecognizer = function (gesture) {
        gesture.view = null;
        this.gestureRecognizers.removeObject(gesture);
    };
    UIView.animateWithDurationAnimations = function (duration, animations, completion) {
        UIView.animationsChanges = [];
        UIView.animationsViews = [];
        //UIView.animationTarget = target;
        UIView.animationCompletion = completion;
        //animations.call(target);
        animations();
        var _loop_1 = function (index) {
            var anim = UIView.animationsChanges[index];
            var view = anim["View"];
            var key = anim["Key"];
            var value = anim["EndValue"];
            var cssProp = key === 'x' ? 'left' :
                key === 'y' ? 'top' :
                    key;
            view.layer.style.transition = (view.layer.style.transition ? view.layer.style.transition + ", " : "") + cssProp + " " + duration + "s";
            setTimeout(function () { return view.layer.style[cssProp] = value; });
            UIView.addTrackingAnimationView(view);
        };
        for (var index = 0; index < UIView.animationsChanges.length; index++) {
            _loop_1(index);
        }
        UIView.animationsChanges = null;
    };
    UIView.addTrackingAnimationView = function (view) {
        // let index = UIView.animationsViews.indexOf(view);
        // if (index > -1) return;
        // UIView.animationsViews.addObject(view);
        // view.layer.animationParams = { "View": view };
        // view.layer.addEventListener("webkitTransitionEnd", UIView.animationDidFinish);
    };
    UIView.removeTrackingAnimationView = function (view) {
        // let index = UIView.animationsViews.indexOf(view);
        // if (index == -1) return;
        // UIView.animationsViews.removeObject(view);
        // view.layer.removeEventListener("webkitTransitionEnd", UIView.animationDidFinish);
        // view.layer.style.transition = "none";
        // view.setNeedsDisplay();
    };
    UIView.animationDidFinish = function (event) {
        var view = event.target.animationParams["View"];
        UIView.removeTrackingAnimationView(view);
        if (UIView.animationsViews.length > 0)
            return;
        UIView.animationsChanges = null;
        UIView.animationsViews = null;
        if (UIView.animationTarget != null && UIView.animationCompletion != null)
            UIView.animationCompletion.call(UIView.animationTarget);
        UIView.animationTarget = null;
        UIView.animationCompletion = null;
    };
    //
    // Animations
    //
    UIView.animationsChanges = null;
    UIView.animationsViews = null;
    UIView.animationTarget = null;
    UIView.animationCompletion = null;
    return UIView;
}(_UIResponder__WEBPACK_IMPORTED_MODULE_5__.UIResponder));



/***/ }),

/***/ "./sources/UIViewController.ts":
/*!*************************************!*\
  !*** ./sources/UIViewController.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIViewController: () => (/* binding */ UIViewController)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./core/UICoreNibParser */ "./sources/core/UICoreNibParser.ts");
/* harmony import */ var _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreGraphics/CGSize */ "./sources/CoreGraphics/CGSize.ts");
/* harmony import */ var _UIPopoverPresentationController__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./UIPopoverPresentationController */ "./sources/UIPopoverPresentationController.ts");
/* harmony import */ var _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./UIPresentationController */ "./sources/UIPresentationController.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _UIWindow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./UIWindow */ "./sources/UIWindow.ts");
/* harmony import */ var _core_UICore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./core/UICore */ "./sources/core/UICore.ts");
/**
 * Created by godshadow on 11/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var UIViewController = /** @class */ (function (_super) {
    __extends(UIViewController, _super);
    function UIViewController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.view = null;
        // private _onViewLoadedTarget = null;
        _this._onViewLoadCompletion = null;
        // private _onLoadLayerTarget = null;
        // private _onLoadLayerAction = null;
        _this._viewIsLoaded = false;
        _this._layerIsReady = false;
        _this._childViewControllers = [];
        _this.parentViewController = null;
        _this.presentingViewController = null;
        _this.presentedViewController = null;
        _this.navigationController = null;
        _this.navigationItem = null;
        _this.splitViewController = null;
        _this.tabBarController = null;
        _this.modalPresentationStyle = (0,mio_core__WEBPACK_IMPORTED_MODULE_1__.MIOCoreIsPhone)() == true ? _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__.UIModalPresentationStyle.fullScreen : _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__.UIModalPresentationStyle.pageSheet;
        _this.modalTransitionStyle = _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__.UIModalTransitionStyle.coverVertical;
        _this.transitioningDelegate = null;
        _this._contentSize = new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_3__.CGSize(320, 200);
        _this._preferredContentSize = null;
        // localizeSubLayers(layers) {
        //     if (layers.length == 0)
        //         return;
        //     for (let index = 0; index < layers.length; index++) {
        //         let layer = layers[index];
        //         if (layer.tagName != "DIV") continue;
        //         let key = layer.getAttribute("data-localize-key");
        //         if (key != null)
        //             layer.innerHTML = NSLocalizeString(key, key);
        //         this.localizeSubLayers(layer.childNodes);
        //     }
        // }
        // localizeLayerIDWithKey(layerID, key) {
        //     let layer = MUICoreLayerSearchElementByID(this.view.layer, layerID);
        //     layer.innerHTML = NSLocalizeString(key, key);
        // }
        _this._contentView = null;
        // removeFromParentViewController()
        // {
        //     this.parent.removeChildViewController(this);
        //     this.parent = null;
        //     this.view.removeFromSuperview();
        //     //this.didMoveToParentViewController(null);
        // }
        _this._presentationController = null;
        _this._popoverPresentationController = null;
        // Storyboard
        _this.storyboard = null;
        _this._outlets = {};
        _this._segues = [];
        return _this;
    }
    UIViewController.prototype.init = function () {
        _super.prototype.init.call(this);
        this.loadView();
    };
    UIViewController.prototype.initWithCoder = function (coder) {
        if (coder instanceof _core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_2__.UICoreNibCoder) {
            if (this.view == null) {
                this.view = coder.decodeContentView();
            }
            else {
                var cv = coder.decodeContentView();
                this.view.addSubview(cv);
            }
            this._assign_outlets(coder);
        }
        this._didLoadView();
    };
    UIViewController.prototype._assign_outlets = function (coder) {
        for (var key in this._outlets) {
            var obj = coder.outlets[key];
            var prop = this._outlets[key];
            this[prop] = obj;
        }
    };
    // initWithLayer(layer, owner, options?) {
    //     super.init();
    //     // this.view = MUICoreViewCreateView(layer, owner);
    //     // this.view._checkSegues();
    //     // Search for navigation item
    //     //this.navigationItem = UINavItemSearchInLayer(layer);        
    //     this.loadView();
    // }
    UIViewController.prototype.initWithNibName = function (nibName, bundle) {
        if (nibName == null)
            throw new Error("UIViewController:initWithNibName can't be null");
        _super.prototype.init.call(this);
        this._nibName = nibName;
        this.loadView();
    };
    UIViewController.prototype.loadView = function () {
        if (this.view != null) {
            this._didLoadView();
            return;
        }
        if (this._nibName == null) {
            this.view = new _UIView__WEBPACK_IMPORTED_MODULE_6__.UIView();
            this.view.init();
            // MUICoreLayerAddStyle(this.view.layer, "view-controller");
            //this.view.layer.style.height = "100%";
            this._didLoadView();
            return;
        }
        this.view = new _UIView__WEBPACK_IMPORTED_MODULE_6__.UIView();
        this.view.init();
        (0,_core_UICoreNibParser__WEBPACK_IMPORTED_MODULE_2__.UICoreLoadNibName)(this._nibName, this);
        // UICoreLoadNibName(this._nibName, this, (view:UIView, classname:string) => {
        //     this._loadViewFromNib(view, classname);
        // });
        // let mainBundle = NSBundle.mainBundle();
        // mainBundle.loadNibNamed(this._htmlResourcePath, this, null);
        // mainBundle.loadHTMLNamed(this._htmlResourcePath, this.layerID, this, function (layer) {            
        //     let domParser = new DOMParser();
        //     let items = domParser.parseFromString(layerData, "text/html");
        //     let layer = items.getElementById(layerID);
        //     if (target != null && completion != null)
        //         completion.call(target, layer);
        //     // Search for navigation item
        //     this.navigationItem = UINavItemSearchInLayer(layer);
        //     this.view.initWithLayer(layer);
        //     this.view.awakeFromHTML();
        //     this._didLoadView();
        // });        
    };
    /*
        protected _loadViewFromNib(view:UIView, classname:string){
            // let layerID = layer.getAttribute("id");
            // if (layerID != null) this._outlets[layerID] = this;
    
            // this._contentView = new UIView();
            // this._contentView.initWithLayer(layer, this, {"Object": this});
            // this.view.addSubview( view );
    
            // TODO: merge contents from dymmy view to loaded view
            // this.view = view;
            this.view.addSubview( view );
            
            // this._segues = this._contentView._segues;
            this._checkSegues();
            this._didLoadView();
        }
    */
    // _didLoadNibWithLayer(layerData) {
    //     let domParser = new DOMParser();
    //     let items = domParser.parseFromString(layerData, "text/html");
    //     let layer = items.getElementById("kk");
    //     //this.navigationItem = UINavItemSearchInLayer(layer);
    //     // this.view.initWithLayer(layer, this);
    //     this.view.awakeFromHTML();
    //     this._didLoadView();
    // }
    UIViewController.prototype._didLoadView = function () {
        this._layerIsReady = true;
        // if (MIOCoreIsPhone() == true) MUICoreLayerAddStyle(this.view.layer, "phone");
        // if (this._onLoadLayerTarget != null && this._onViewLoadedAction != null) {
        //     this._onLoadLayerAction.call( this._onLoadLayerTarget );
        //     this._onLoadLayerTarget = null;
        //     this._onLoadLayerAction = null;
        // }
        if (this._onViewLoadCompletion != null) {
            this.viewDidLoad();
            this._loadChildControllers();
        }
        else if (this._nibName == null) {
            this.viewDidLoad();
            this._loadChildControllers();
        }
    };
    UIViewController.prototype._loadChildControllers = function () {
        var count = this._childViewControllers.length;
        if (count > 0)
            this._loadChildViewController(0, count);
        else
            this._setViewLoaded(true);
    };
    UIViewController.prototype._loadChildViewController = function (index, max) {
        var _this = this;
        if (index < max) {
            var vc = this._childViewControllers[index];
            vc.onLoadView(function () {
                var newIndex = index + 1;
                _this._loadChildViewController(newIndex, max);
            });
        }
        else {
            this._setViewLoaded(true);
        }
    };
    UIViewController.prototype._setViewLoaded = function (value) {
        this.willChangeValue("viewLoaded");
        this._viewIsLoaded = value;
        this.didChangeValue("viewLoaded");
        if (value == true && this._onViewLoadCompletion != null) {
            this._onViewLoadCompletion();
        }
        this._onViewLoadCompletion = null;
        this.view.setNeedsDisplay();
    };
    UIViewController.prototype.onLoadView = function (completion) {
        // this._onViewLoadedTarget = target;
        this._onViewLoadCompletion = completion;
        if (this._viewIsLoaded == true) {
            // action.call(target);
            completion();
            //this.view.setNeedsDisplay();
        }
        else if (this._layerIsReady == true) {
            this.viewDidLoad();
            this._loadChildControllers();
            //this.view.setNeedsDisplay();
        }
    };
    Object.defineProperty(UIViewController.prototype, "viewLoaded", {
        // onLoadLayer(target, action) {
        //     if (this._layerIsReady == true) {
        //         action.call(target);
        //     }
        //     else {
        //         this._onLoadLayerAction = target;
        //     }
        // }
        get: function () {
            return this._viewIsLoaded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIViewController.prototype, "childViewControllers", {
        get: function () {
            return this._childViewControllers;
        },
        enumerable: false,
        configurable: true
    });
    UIViewController.prototype.addChildViewController = function (vc) {
        vc.parentViewController = this;
        this._childViewControllers.addObject(vc);
        //vc.willMoveToParentViewController(this);
    };
    UIViewController.prototype.removeChildViewController = function (vc) {
        this._childViewControllers.removeObject(vc);
        vc.parentViewController = null;
    };
    Object.defineProperty(UIViewController.prototype, "isPresented", {
        get: function () {
            if (this._presentationController != null)
                return this._presentationController._isPresented;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIViewController.prototype, "presentationController", {
        get: function () {
            if (this._presentationController == null && this.parentViewController != null)
                return this.parentViewController.presentationController;
            return this._presentationController;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIViewController.prototype, "popoverPresentationController", {
        get: function () {
            if (this._popoverPresentationController == null) {
                this._popoverPresentationController = new _UIPopoverPresentationController__WEBPACK_IMPORTED_MODULE_4__.UIPopoverPresentationController();
                this._popoverPresentationController.init();
                this._popoverPresentationController.presentedViewController = this;
                this._presentationController = this._popoverPresentationController;
            }
            return this._popoverPresentationController;
        },
        enumerable: false,
        configurable: true
    });
    UIViewController.prototype.showViewController = function (vc, animated) {
        var _this = this;
        vc.onLoadView(function () {
            _this.view.addSubview(vc.view);
            _this.addChildViewController(vc);
            (0,_core_UICore__WEBPACK_IMPORTED_MODULE_8__._UIShowViewController)(_this, vc, _this, animated);
        });
    };
    UIViewController.prototype.presentViewController = function (vc, animated) {
        var _this = this;
        var pc = vc.presentationController;
        if (pc == null) {
            pc = new _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__.UIPresentationController();
            // pc.init();
            pc.presentedViewController = vc;
            pc.presentingViewController = this;
            vc._presentationController = pc;
        }
        if (pc.presentingViewController == null) {
            pc.presentingViewController = this;
        }
        if (pc._isPresented == true) {
            throw new Error("You try to present a view controller that is already presented");
        }
        // if (vc.modalPresentationStyle == UIModalPresentationStyle.CurrentContext){            
        //     vc.modalPresentationStyle = MIOCoreIsPhone() == true ? UIModalPresentationStyle.FullScreen : UIModalPresentationStyle.PageSheet;
        // }
        // if (vc.modalPresentationStyle != UIModalPresentationStyle.FullScreen 
        //     && vc.modalPresentationStyle != UIModalPresentationStyle.FormSheet
        //     && vc.modalPresentationStyle != UIModalPresentationStyle.PageSheet
        //     && vc.modalPresentationStyle != UIModalPresentationStyle.Popover
        //     && vc.modalPresentationStyle != UIModalPresentationStyle.Custom)
        //     vc.modalPresentationStyle = UIModalPresentationStyle.PageSheet;
        vc.onLoadView(function () {
            if (vc.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__.UIModalPresentationStyle.currentContext) {
                var wv = new _UIView__WEBPACK_IMPORTED_MODULE_6__.UIView();
                wv.init();
                // MUICoreLayerAddStyle(wv.layer, "window");
                // MUICoreLayerAddStyle(wv.layer, "alert");
                _this.view.addSubview(wv);
                wv.addSubview(vc.presentationController.presentedView);
                _this.addChildViewController(vc);
                // _MUIShowViewController(this, vc, null, animated, this, function () {
                // });
            }
            else {
                // It's a window instead of a view
                var w_1 = vc.presentationController.window;
                if (w_1 == null) {
                    w_1 = new _UIWindow__WEBPACK_IMPORTED_MODULE_7__._UIModalWindow();
                    w_1.init();
                    // w.layer.style.background = "";
                    // w.layer.style.width = "100%";
                    // w.layer.style.height = "100%";
                    w_1.rootViewController = vc;
                    vc.presentationController.presentedView = vc.view;
                    // vc.view.layer.style.width = "100%";
                    // vc.view.layer.style.height = "100%";
                    w_1.addSubview(vc.presentationController.presentedView);
                    vc.presentationController.window = w_1;
                }
                w_1.setHidden(false);
                // if (vc instanceof UIAlertController) MUICoreLayerAddStyle(w.layer, "alert");
                (0,_core_UICore__WEBPACK_IMPORTED_MODULE_8__._UIShowViewController)(_this, vc, null, animated, function () {
                    w_1.makeKey();
                });
            }
        });
    };
    UIViewController.prototype.dismissViewController = function (animate) {
        var pc = this._presentationController;
        var vc = this;
        while (pc == null) {
            vc = vc.parentViewController;
            pc = vc._presentationController;
        }
        var toVC = pc.presentingViewController;
        var fromVC = pc.presentedViewController;
        var fromView = pc.presentedView;
        (0,_core_UICore__WEBPACK_IMPORTED_MODULE_8__._UICoreHideViewController)(fromVC, toVC, null, function () {
            if (fromVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_5__.UIModalPresentationStyle.currentContext) {
                toVC.removeChildViewController(fromVC);
                var pc1 = fromVC.presentationController;
                var view = pc1.presentedView;
                view.removeFromSuperview();
            }
            else {
                // It's a window instead of a view
                var pc1 = fromVC.presentationController;
                var w = pc1.window;
                // w.setHidden(true);
                w.removeFromSuperview();
            }
        });
    };
    UIViewController.prototype.transitionFromViewControllerToViewController = function (fromVC, toVC, duration, options, animations, completion) {
        //TODO
    };
    UIViewController.prototype.viewDidLoad = function () { };
    UIViewController.prototype.viewWillAppear = function (animated) {
        for (var index = 0; index < this._childViewControllers.length; index++) {
            var vc = this._childViewControllers[index];
            vc.viewWillAppear(animated);
        }
        this.view.setViewIsVisible(true);
    };
    UIViewController.prototype.viewDidAppear = function (animated) {
        //this.view.setNeedsDisplay();
        for (var index = 0; index < this._childViewControllers.length; index++) {
            var vc = this._childViewControllers[index];
            vc.viewDidAppear(animated);
        }
    };
    UIViewController.prototype.viewWillDisappear = function (animated) {
        for (var index = 0; index < this._childViewControllers.length; index++) {
            var vc = this._childViewControllers[index];
            vc.viewWillDisappear(animated);
        }
        this.view.setViewIsVisible(false);
    };
    UIViewController.prototype.viewDidDisappear = function (animated) {
        for (var index = 0; index < this._childViewControllers.length; index++) {
            var vc = this._childViewControllers[index];
            vc.viewDidDisappear(animated);
        }
    };
    UIViewController.prototype.contentHeight = function () {
        return this.view.getHeight();
    };
    UIViewController.prototype.setContentSize = function (size) {
        this.willChangeValue("contentSize");
        this._contentSize = size;
        this.didChangeValue("contentSize");
    };
    Object.defineProperty(UIViewController.prototype, "contentSize", {
        get: function () {
            return this._contentSize;
        },
        set: function (size) {
            this.setContentSize(size);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIViewController.prototype, "preferredContentSize", {
        get: function () {
            return this._preferredContentSize;
        },
        set: function (size) {
            this.setPreferredContentSize(size);
        },
        enumerable: false,
        configurable: true
    });
    UIViewController.prototype.setPreferredContentSize = function (size) {
        this.willChangeValue("preferredContentSize");
        this._preferredContentSize = size;
        this.didChangeValue("preferredContentSize");
    };
    UIViewController.prototype._checkSegues = function () {
    };
    UIViewController.prototype.shouldPerformSegueWithIdentifier = function (identifier, sender) {
        return true;
    };
    UIViewController.prototype.prepareForSegue = function (segue, sender) {
    };
    UIViewController.prototype.performSegueWithIdentifier = function (identifier, sender) {
    };
    return UIViewController;
}(foundation__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UIWindow.ts":
/*!*****************************!*\
  !*** ./sources/UIWindow.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UIWindow: () => (/* binding */ UIWindow),
/* harmony export */   _UIModalWindow: () => (/* binding */ _UIModalWindow)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreAnimation/CALayer */ "./sources/CoreAnimation/CALayer.ts");
/* harmony import */ var _UIApplication__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UIApplication */ "./sources/UIApplication.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/**
 * Created by godshadow on 11/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CAWindowLayer = /** @class */ (function (_super) {
    __extends(CAWindowLayer, _super);
    function CAWindowLayer() {
        var _this = _super.call(this) || this;
        _this.addStyle("window");
        document.body.appendChild(_this.contents);
        return _this;
    }
    CAWindowLayer.prototype.removeFromSuperlayer = function () {
        document.body.removeChild(this.contents);
    };
    return CAWindowLayer;
}(_CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_1__.CALayer));
var UIWindow = /** @class */ (function (_super) {
    __extends(UIWindow, _super);
    function UIWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._resizeWindow = false;
        return _this;
    }
    Object.defineProperty(UIWindow, "layerClass", {
        get: function () { return CAWindowLayer; },
        enumerable: false,
        configurable: true
    });
    UIWindow.prototype.init = function () {
        this.layer = new UIWindow.layerClass();
        if ((0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsPhone)())
            this.layer.contents.style.overflow = "scroll";
    };
    UIWindow.prototype.initWithRootViewController = function (vc) {
        this.init();
        this.rootViewController = vc;
    };
    UIWindow.prototype.makeKey = function () {
        _UIApplication__WEBPACK_IMPORTED_MODULE_2__.UIApplication.shared.makeKeyWindow(this);
    };
    UIWindow.prototype.makeKeyAndVisible = function () {
        this.makeKey();
        this.setHidden(false);
    };
    UIWindow.prototype.layoutSubviews = function () {
        if (this.rootViewController != null)
            this.rootViewController.view.layoutSubviews();
        else
            _super.prototype.layoutSubviews.call(this);
    };
    UIWindow.prototype.addSubview = function (view) {
        view._window = this;
        _super.prototype.addSubview.call(this, view);
    };
    // protected _addLayerToDOM(){
    //     if (this._isLayerInDOM == true)
    //         return;
    //     if (this.layer == null)
    //         return;
    //     document.body.appendChild(this.layer);
    //     this._isLayerInDOM = true;
    // }
    UIWindow.prototype.removeFromSuperview = function () {
        this.layer.removeFromSuperlayer();
    };
    // protected _removeLayerFromDOM(){
    //     if (this._isLayerInDOM == false)
    //         return;
    //     document.body.removeChild(this.layer);
    //     this._isLayerInDOM = false;
    // }
    UIWindow.prototype.setHidden = function (hidden) {
        // if (hidden == false){
        //     this._addLayerToDOM();
        // }
        // else{
        //     this._removeLayerFromDOM();
        // }
    };
    UIWindow.prototype._eventHappendOutsideWindow = function () {
        this._dismissRootViewController();
    };
    UIWindow.prototype._becameKeyWindow = function () {
    };
    UIWindow.prototype._resignKeyWindow = function () {
        this._dismissRootViewController();
    };
    UIWindow.prototype._dismissRootViewController = function () {
        // if (this.rootViewController.isPresented == true){
        //     let pc = this.rootViewController.presentationController;
        //     if (pc instanceof UIPopoverPresentationController)
        //         this.rootViewController.dismissViewController(true);
        // }
    };
    return UIWindow;
}(_UIView__WEBPACK_IMPORTED_MODULE_3__.UIView));

var _UIModalWindow = /** @class */ (function (_super) {
    __extends(_UIModalWindow, _super);
    function _UIModalWindow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _UIModalWindow.prototype.init = function () {
        _super.prototype.init.call(this);
        this.layer.addStyle("modal");
        this.layer.addStyle((0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsMobile)() ? "mobile" : "desktop");
    };
    return _UIModalWindow;
}(UIWindow));



/***/ }),

/***/ "./sources/core/UICore.ts":
/*!********************************!*\
  !*** ./sources/core/UICore.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MUIWindowSize: () => (/* binding */ MUIWindowSize),
/* harmony export */   _UICoreAnimationDidStart: () => (/* binding */ _UICoreAnimationDidStart),
/* harmony export */   _UICoreHideViewController: () => (/* binding */ _UICoreHideViewController),
/* harmony export */   _UIShowViewController: () => (/* binding */ _UIShowViewController)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CoreGraphics/CGSize */ "./sources/CoreGraphics/CGSize.ts");
/* harmony import */ var _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UIPresentationController */ "./sources/UIPresentationController.ts");
/* harmony import */ var _CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../CoreAnimation/CoreAnimation+ViewController */ "./sources/CoreAnimation/CoreAnimation+ViewController.ts");




function MUIWindowSize() {
    var w = document.body.clientWidth;
    var h = window.innerHeight;
    return new _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_1__.CGSize(w, h);
}
function _UIShowViewController(fromVC, toVC, sourceVC, animated, completion) {
    toVC.viewWillAppear(false);
    //toVC._childControllersWillAppear();
    if (toVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.fullScreen
        || toVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.currentContext) {
        fromVC.viewWillDisappear(false);
        //fromVC._childControllersWillDisappear();
    }
    var view = null;
    var pc = toVC.presentationController;
    if (pc != null)
        view = pc.presentedView;
    else
        view = toVC.view;
    if (animated == false) {
        _UICoreAnimationDidStart(fromVC, toVC, pc, completion);
        return;
    }
    // Let's go for the animations!!
    var animationContext = {};
    animationContext["presentingViewController"] = fromVC;
    animationContext["presentedViewController"] = toVC;
    animationContext["presentedView"] = view;
    if (pc != null)
        pc.presentationTransitionWillBegin();
    var ac = null;
    if (toVC.transitioningDelegate != null) {
        ac = toVC.transitioningDelegate.animationControllerForPresentedController(toVC, fromVC, sourceVC);
    }
    else if (sourceVC != null && typeof sourceVC.animationControllerForPresentedController === "function") {
        ac = sourceVC.animationControllerForPresentedController(toVC, fromVC, sourceVC);
    }
    else if (pc != null) {
        ac = pc.transitioningDelegate.animationControllerForPresentedController(toVC, fromVC, sourceVC);
    }
    //view.setNeedsDisplay();
    (0,_CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_3__._CAAnimationStart)(view.layer, ac, animationContext, function () {
        _UICoreAnimationDidStart(fromVC, toVC, pc, completion);
    });
}
function _UICoreAnimationDidStart(fromVC, toVC, pc, completion) {
    toVC.viewDidAppear(true);
    //toVC._childControllersDidAppear();
    if (toVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.fullScreen
        || toVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.currentContext) {
        fromVC.viewDidDisappear(true);
        //fromVC._childControllersDidDisappear();
    }
    if (pc != null) {
        pc.presentationTransitionDidEnd(true);
        pc._isPresented = true;
    }
    if (completion != null)
        completion();
}
function _UICoreHideViewController(fromVC, toVC, sourceVC, completion) {
    if (fromVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.fullScreen
        || fromVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.currentContext
        || (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreIsPhone)() == true) {
        toVC.viewWillAppear(false);
        //toVC._childControllersWillAppear();
        //toVC.view.layout();
    }
    fromVC.viewWillDisappear(false);
    //fromVC._childControllersWillDisappear();
    var view = null;
    var pc = fromVC.presentationController;
    if (pc != null)
        view = pc.presentedView;
    else
        view = fromVC.view;
    var ac = null;
    if (fromVC.transitioningDelegate != null) {
        ac = fromVC.transitioningDelegate.animationControllerForDismissedController(fromVC);
    }
    else if (sourceVC != null && typeof sourceVC.animationControllerForDismissedController === "function") {
        ac = sourceVC.animationControllerForDismissedController(fromVC);
    }
    else if (pc != null) {
        ac = pc.transitioningDelegate.animationControllerForDismissedController(fromVC);
    }
    var animationContext = {};
    animationContext["presentingViewController"] = fromVC;
    animationContext["presentedViewController"] = toVC;
    animationContext["presentedView"] = view;
    var layer = view.layer;
    if (pc != null)
        pc.dismissalTransitionWillBegin();
    (0,_CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_3__._CAAnimationStart)(layer, ac, animationContext, function () {
        if (fromVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.fullScreen
            || fromVC.modalPresentationStyle == _UIPresentationController__WEBPACK_IMPORTED_MODULE_2__.UIModalPresentationStyle.currentContext) {
            toVC.viewDidAppear(false);
            //toVC._childControllersDidAppear();
        }
        fromVC.viewDidDisappear(false);
        //fromVC._childControllersDidDisappear();
        if (pc != null) {
            pc.dismissalTransitionDidEnd(true);
            pc._isPresented = false;
        }
        if (completion != null)
            completion();
    });
}
function _UICoreTransitionFromViewControllerToViewController(fromVC, toVC, sourceVC, target, completion) {
    toVC.viewWillAppear();
    //toVC._childControllersWillAppear();
    fromVC.viewWillDisappear();
    //fromVC._childControllersWillDisappear();
    //toVC.view.layout();
    var ac = null;
    if (toVC.transitioningDelegate != null) {
        ac = toVC.transitioningDelegate.animationControllerForPresentedController(toVC, fromVC, sourceVC);
    }
    else if (sourceVC != null && sourceVC.transitioningDelegate != null) {
        ac = sourceVC.transitioningDelegate.animationControllerForPresentedController(toVC, fromVC, sourceVC);
    }
    var animationContext = {};
    animationContext["presentingViewController"] = fromVC;
    animationContext["presentedViewController"] = toVC;
    animationContext["presentedView"] = toVC;
    var layer = toVC.view.layer;
    (0,_CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_3__._CAAnimationStart)(layer, ac, animationContext, function () {
        toVC.viewDidAppear();
        //toVC._childControllersDidAppear();
        fromVC.viewDidDisappear();
        //fromVC._childControllersDidDisappear();
        if (target != null && completion != null)
            completion.call(target);
    });
}
var _miocore_events_event_observers = {};
function UICoreEventRegisterObserverForType(eventType, observer, completion) {
    var item = { "Target": observer, "Completion": completion };
    var array = _miocore_events_event_observers[eventType];
    if (array == null) {
        array = [];
        _miocore_events_event_observers[eventType] = array;
    }
    array.push(item);
}
function UICoreEventUnregisterObserverForType(eventType, observer) {
    var obs = _miocore_events_event_observers[eventType];
    if (obs == null)
        return;
    var index = -1;
    for (var count = 0; count < obs.length; count++) {
        var item = obs[count];
        var target = item["Target"];
        if (target === observer) {
            index = count;
            break;
        }
    }
    if (index > -1) {
        console.log("removing event observer: " + obs.length);
        obs.splice(index, 1);
        console.log("removing event observer: " + obs.length);
        console.log("removing event observer: " + _miocore_events_event_observers[eventType].length);
    }
}
function _UICoreEventSendToObservers(obs, event) {
    if (obs != null) {
        for (var index = 0; index < obs.length; index++) {
            var o = obs[index];
            var target = o["Target"];
            var completion = o["Completion"];
            completion.call(target, event);
        }
    }
}


/***/ }),

/***/ "./sources/core/UICoreLayer.ts":
/*!*************************************!*\
  !*** ./sources/core/UICoreLayer.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICoreLayerIDFromClassname: () => (/* binding */ UICoreLayerIDFromClassname),
/* harmony export */   UICoreLayerIDFromObject: () => (/* binding */ UICoreLayerIDFromObject),
/* harmony export */   _UICoreLayerGetAllElementsWithTag: () => (/* binding */ _UICoreLayerGetAllElementsWithTag),
/* harmony export */   _UICoreLayerGetFirstElementWithTag: () => (/* binding */ _UICoreLayerGetFirstElementWithTag)
/* harmony export */ });
var _MUICoreLayerIDCount = 0;
function UICoreLayerIDFromObject(object) {
    var classname = object.constructor.name;
    return UICoreLayerIDFromClassname(classname);
}
function UICoreLayerIDFromClassname(classname) {
    var digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    var random = "";
    for (var count = 0; count < 4; count++) {
        var randomNumber = Math.floor(Math.random() * 16);
        var randomDigit = digits[randomNumber];
        random += randomDigit;
    }
    var layerID = classname.toLowerCase() + "_" + random;
    _MUICoreLayerIDCount++;
    return layerID;
}
function MUICoreLayerCreate(layerID) {
    var layer = document.createElement("DIV");
    if (layerID != null)
        layer.setAttribute("id", layerID);
    //layer.style.position = "absolute";
    return layer;
}
function MUICoreLayerAddSublayer(layer, subLayer) {
    layer.appendChild(subLayer);
}
function MUICoreLayerRemoveSublayer(layer, subLayer) {
    layer.removeChild(subLayer);
}
function MUICoreLayerCreateWithStyle(style, layerID) {
    var layer = MUICoreLayerCreate(layerID);
    MUICoreLayerAddStyle(layer, style);
    return layer;
}
function MUICoreLayerAddStyle(layer, style) {
    layer.classList.add(style);
}
function MUICoreLayerRemoveStyle(layer, style) {
    layer.classList.remove(style);
}
function MUICoreLayerSearchElementByAttribute(layer, key) {
    if (layer.tagName != "DIV" && layer.tagName != "INPUT" && layer.tagName != "SECTION")
        return null;
    if (layer.getAttribute(key) == "true")
        return layer;
    var elementFound = null;
    for (var count = 0; count < layer.childNodes.length; count++) {
        var l = layer.childNodes[count];
        elementFound = MUICoreLayerSearchElementByAttribute(l, key);
        if (elementFound != null)
            return elementFound;
    }
    return null;
}
function MUICoreLayerSearchElementByID(layer, elementID) {
    if (layer.tagName != "DIV" && layer.tagName != "INPUT" && layer.tagName != "SECTION")
        return null;
    if (layer.getAttribute("data-outlet") == elementID)
        return layer;
    // Deprecated. For old code we still mantein
    if (layer.getAttribute("id") == elementID)
        return layer;
    var elementFound = null;
    for (var count = 0; count < layer.childNodes.length; count++) {
        var l = layer.childNodes[count];
        elementFound = MUICoreLayerSearchElementByID(l, elementID);
        if (elementFound != null)
            return elementFound;
    }
    return null;
}
function _UICoreLayerGetFirstElementWithTag(layer, tag) {
    var foundLayer = null;
    if (layer.childNodes.length > 0) {
        var index = 0;
        foundLayer = layer.childNodes[index];
        while (foundLayer.tagName != tag) {
            index++;
            if (index >= layer.childNodes.length) {
                foundLayer = null;
                break;
            }
            foundLayer = layer.childNodes[index];
        }
    }
    return foundLayer;
}
function _UICoreLayerGetAllElementsWithTag(layer, tag, attribute_name, attribute_value) {
    var layers = [];
    var l = null;
    if (layer.childNodes.length == 0)
        return [];
    for (var _i = 0, _a = layer.childNodes; _i < _a.length; _i++) {
        var l_1 = _a[_i];
        if (l_1.tagName != tag)
            continue;
        if (attribute_name != null) {
            var value = l_1.getAttribute("data-" + attribute_name);
            if (value == null)
                continue;
            if (attribute_value == null)
                layer.addObject(l_1);
            else if (value == attribute_value)
                layer.addObject(l_1);
        }
        else {
            layer.addObject(l_1);
        }
    }
    return layers;
}


/***/ }),

/***/ "./sources/core/UICoreNibParser.ts":
/*!*****************************************!*\
  !*** ./sources/core/UICoreNibParser.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UICoreLoadNibName: () => (/* binding */ UICoreLoadNibName),
/* harmony export */   UICoreNibCoder: () => (/* binding */ UICoreNibCoder),
/* harmony export */   UICoreNibCopy: () => (/* binding */ UICoreNibCopy),
/* harmony export */   UICoreNibLoad: () => (/* binding */ UICoreNibLoad),
/* harmony export */   UICoreNibParser: () => (/* binding */ UICoreNibParser)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_1__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var _UICoreClassesByDestination = {};
function UICoreSetClassesByDestination(classes) {
    _UICoreClassesByDestination = classes;
}
function UICoreGetClassesByDestination(resource) {
    return _UICoreClassesByDestination[resource];
}
function UICoreLoadNibName(name, owner /*, completion:any */) {
    var parser = new UICoreNibParser();
    // parser.completion = completion;
    var resource_name = name + ".html";
    (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetContentsFromURLString)(resource_name, this, function (code, data) {
        if (code == 200)
            parser.parseString(data, owner);
        else
            throw new Error("MUICoreBundleLoadNibName: Couldn't download resource " + name);
    });
}
var _valid_html_tags = ["DIV", "SECTION", "LABEL", "BUTTON"];
var UICoreNibParser = /** @class */ (function (_super) {
    __extends(UICoreNibParser, _super);
    function UICoreNibParser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.completion = null;
        _this.owner = null;
        _this.result = "";
        _this.isCapturing = false;
        _this.elementCapturingCount = 0;
        _this.layerID = null;
        _this.rootClassname = null;
        _this.currentString = null;
        _this.currentStringLocalizedKey = null;
        return _this;
    }
    UICoreNibParser.prototype.parseString = function (data, owner) {
        var parser = new mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreHTMLParser();
        parser.initWithString(data, this);
        parser.parse();
        var domParser = new DOMParser();
        var items = domParser.parseFromString(this.result, "text/html");
        var contents = items.getElementById(this.layerID);
        parse_root_element(contents, owner);
    };
    //
    // XML PARSER
    //
    UICoreNibParser.prototype.parserDidStartDocument = function (parser) {
        console.log("parser started");
    };
    // HTML Parser delegate
    UICoreNibParser.prototype.parserDidStartElement = function (parser, element, attributes) {
        if (element.toLocaleLowerCase() == "div") {
            if (attributes["data-root-view-controller"] == "true") {
                // Start capturing   
                this.isCapturing = true;
                this.layerID = attributes["id"];
                this.rootClassname = attributes["data-class"];
                if (this.rootClassname == null)
                    this.rootClassname = "UIViewController";
            }
        }
        if (this.isCapturing == true) {
            this.openTag(element, attributes);
            this.elementCapturingCount++;
        }
    };
    UICoreNibParser.prototype.parserFoundCharacters = function (parser, characters) {
        if (this.isCapturing == true) {
            if (this.currentString == null) {
                this.currentString = characters;
            }
            else
                this.currentString += " " + characters;
            //this.result += " " + characters;
        }
    };
    UICoreNibParser.prototype.parserFoundComment = function (parser, comment) {
        if (this.isCapturing == true) {
            this.result += "<!-- " + comment + "-->";
        }
    };
    UICoreNibParser.prototype.parserDidEndElement = function (parser, element) {
        if (this.isCapturing == true) {
            this.closeTag(element);
            this.elementCapturingCount--;
        }
        if (this.elementCapturingCount == 0)
            this.isCapturing = false;
        this.currentString = null;
    };
    UICoreNibParser.prototype.parserDidEndDocument = function (parser) {
        console.log("html parser finished");
        console.log(this.result);
    };
    UICoreNibParser.prototype.openTag = function (element, attributes) {
        this.translateCharacters();
        this.result += "<" + element;
        for (var key in attributes) {
            var value = attributes[key];
            if (value != null) {
                this.result += " " + key + "='" + value + "'";
            }
            else {
                this.result += " " + key;
            }
        }
        this.result += ">";
        if (element == "span") {
            this.currentStringLocalizedKey = attributes["localized-key"] || attributes["data-localized-key"];
        }
    };
    UICoreNibParser.prototype.closeTag = function (element) {
        this.translateCharacters();
        this.result += "</" + element + ">";
    };
    UICoreNibParser.prototype.translateCharacters = function () {
        if (this.currentString != null) {
            if (this.currentStringLocalizedKey == null) {
                this.result += this.currentString;
            }
            else {
                this.result += (0,foundation__WEBPACK_IMPORTED_MODULE_1__.NSLocalizeString)(this.currentStringLocalizedKey, this.currentString);
            }
        }
        this.currentString = null;
        this.currentStringLocalizedKey = null;
    };
    return UICoreNibParser;
}(foundation__WEBPACK_IMPORTED_MODULE_1__.NSObject));

function UICoreNibCopy(contents) {
    var new_contents = contents.cloneNode(true);
    new_contents.removeAttribute("id");
    return parse_element(new_contents, null);
}
function UICoreNibLoad(contents, owner) {
    parse_root_element(contents, owner);
}
function parse_root_element(contents, owner) {
    var coder = new UICoreNibCoder();
    coder.initWithContents(contents, owner, {});
    owner.initWithCoder(coder);
}
function parse_element(contents, coder) {
    var classname = contents.getAttribute("data-class");
    if (classname == null && contents.tagName.toLowerCase() == "button")
        classname = "UIButton";
    if (classname == null && contents.tagName.toLowerCase() == "label")
        classname = "UILabel";
    if (classname == null)
        classname = "UIView";
    var obj = (0,foundation__WEBPACK_IMPORTED_MODULE_1__.NSClassFromString)(classname);
    var outlets = (coder === null || coder === void 0 ? void 0 : coder.outlets) || {};
    var outlet_id = contents.getAttribute("id");
    if (outlet_id != null)
        outlets[outlet_id] = obj;
    var new_coder = new UICoreNibCoder();
    new_coder.initWithContents(contents, obj, outlets);
    obj.initWithCoder(new_coder);
    return obj;
}
function parse_connections_layer(contents, object) {
    // Check outlets and segues
    if (contents.childNodes.length > 0) {
        for (var index = 0; index < contents.childNodes.length; index++) {
            var subLayer = contents.childNodes[index];
            if (!_valid_html_tags.containsObject(subLayer.tagName))
                continue;
            var type = subLayer.getAttribute("data-connection-type");
            if (type == "outlet") {
                var prop = subLayer.getAttribute("data-property");
                var outlet = subLayer.getAttribute("data-outlet");
                parse_outlet(object, prop, outlet);
            }
            else if (type == "segue") {
                var destination = subLayer.getAttribute("data-segue-destination");
                var kind = subLayer.getAttribute("data-segue-kind");
                var relationship = subLayer.getAttribute("data-segue-relationship");
                var identifier = subLayer.getAttribute("data-segue-identifier");
                parse_segue(object, destination, kind, relationship, identifier);
            }
        }
    }
}
function parse_outlet(object, property, outletID) {
    console.log("prop: " + property + " - outlet: " + outletID);
    object._outlets[outletID] = property;
    // let obj = outlets[outletID];
    // object[property] = obj;
}
function parse_segue(owner, destination, kind, relationship, identifier) {
    var s = {};
    s["Destination"] = destination;
    s["Kind"] = kind;
    if (identifier != null)
        s["Identifier"] = identifier;
    if (relationship != null)
        s["Relationship"] = relationship;
    owner._segues.push(s);
}
var UICoreNibCoder = /** @class */ (function (_super) {
    __extends(UICoreNibCoder, _super);
    function UICoreNibCoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UICoreNibCoder.prototype.initWithContents = function (contents, owner, outlets) {
        this.contents = contents;
        this.owner = owner;
        this.outlets = outlets;
    };
    UICoreNibCoder.prototype.decodeBoolForKey = function (key) {
        var _a;
        return (_a = this.contents.getAttribute("data-" + key)) !== null && _a !== void 0 ? _a : false;
    };
    UICoreNibCoder.prototype.decodeIntegerForKey = function (key) {
        var _a;
        return (_a = this.contents.getAttribute("data-" + key)) !== null && _a !== void 0 ? _a : 0;
    };
    UICoreNibCoder.prototype.decodeClassname = function () {
        return this.contents.getAttribute("data-class");
    };
    UICoreNibCoder.prototype.decodeContentView = function () {
        return this.decodeSubviews()[0];
    };
    UICoreNibCoder.prototype.decodeSubviews = function () {
        // Add subviews
        if (this.contents.childNodes.length == 0)
            return [];
        var views = [];
        for (var index = 0; index < this.contents.childNodes.length; index++) {
            var subLayer = this.contents.childNodes[index];
            if (!_valid_html_tags.containsObject(subLayer.tagName))
                continue;
            if (subLayer.getAttribute("data-connections") == "true") {
                parse_connections_layer(subLayer, this.owner);
            }
            // let v = parse_contents( subLayer, this.owner, this.outlets );
            var v = parse_element(subLayer, this);
            views.addObject(v);
        }
        return views;
    };
    Object.defineProperty(UICoreNibCoder.prototype, "layerContents", {
        get: function () {
            return this.contents;
        },
        enumerable: false,
        configurable: true
    });
    return UICoreNibCoder;
}(foundation__WEBPACK_IMPORTED_MODULE_1__.NSCoder));



/***/ }),

/***/ "foundation":
/*!*****************************!*\
  !*** external "foundation" ***!
  \*****************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_foundation__;

/***/ }),

/***/ "mio-core":
/*!***************************!*\
  !*** external "mio-core" ***!
  \***************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_mio_core__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./sources/_index.ts ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAGetOrCreateElementWithTag: () => (/* reexport safe */ _CoreAnimation_CALayer_HTML__WEBPACK_IMPORTED_MODULE_6__.CAGetOrCreateElementWithTag),
/* harmony export */   CAInputLayer: () => (/* reexport safe */ _CoreAnimation_CAInputLayer__WEBPACK_IMPORTED_MODULE_8__.CAInputLayer),
/* harmony export */   CALayer: () => (/* reexport safe */ _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_5__.CALayer),
/* harmony export */   CALayerEvent: () => (/* reexport safe */ _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_5__.CALayerEvent),
/* harmony export */   CATextLayer: () => (/* reexport safe */ _CoreAnimation_CATextLayer__WEBPACK_IMPORTED_MODULE_7__.CATextLayer),
/* harmony export */   CGContext: () => (/* reexport safe */ _CoreGraphics_CGContext__WEBPACK_IMPORTED_MODULE_1__.CGContext),
/* harmony export */   CGPoint: () => (/* reexport safe */ _CoreGraphics_CGPoint__WEBPACK_IMPORTED_MODULE_2__.CGPoint),
/* harmony export */   CGRect: () => (/* reexport safe */ _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__.CGRect),
/* harmony export */   CGSize: () => (/* reexport safe */ _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_4__.CGSize),
/* harmony export */   MUIPopAnimationController: () => (/* reexport safe */ _UINavigationController__WEBPACK_IMPORTED_MODULE_26__.MUIPopAnimationController),
/* harmony export */   MUIPushAnimationController: () => (/* reexport safe */ _UINavigationController__WEBPACK_IMPORTED_MODULE_26__.MUIPushAnimationController),
/* harmony export */   NSRectMaxY: () => (/* reexport safe */ _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__.NSRectMaxY),
/* harmony export */   NSRectMinY: () => (/* reexport safe */ _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__.NSRectMinY),
/* harmony export */   UIApplication: () => (/* reexport safe */ _UIApplication__WEBPACK_IMPORTED_MODULE_13__.UIApplication),
/* harmony export */   UIApplicationMain: () => (/* reexport safe */ _UIApplicationMain__WEBPACK_IMPORTED_MODULE_12__.UIApplicationMain),
/* harmony export */   UIButton: () => (/* reexport safe */ _UIButton__WEBPACK_IMPORTED_MODULE_32__.UIButton),
/* harmony export */   UIButtonType: () => (/* reexport safe */ _UIButton__WEBPACK_IMPORTED_MODULE_32__.UIButtonType),
/* harmony export */   UICheckButton: () => (/* reexport safe */ _UICheckButton__WEBPACK_IMPORTED_MODULE_33__.UICheckButton),
/* harmony export */   UICollectionView: () => (/* reexport safe */ _UICollectionView__WEBPACK_IMPORTED_MODULE_36__.UICollectionView),
/* harmony export */   UICollectionViewCell: () => (/* reexport safe */ _UICollectionView__WEBPACK_IMPORTED_MODULE_36__.UICollectionViewCell),
/* harmony export */   UICollectionViewFlowLayout: () => (/* reexport safe */ _UICollectionViewLayout__WEBPACK_IMPORTED_MODULE_37__.UICollectionViewFlowLayout),
/* harmony export */   UICollectionViewLayout: () => (/* reexport safe */ _UICollectionViewLayout__WEBPACK_IMPORTED_MODULE_37__.UICollectionViewLayout),
/* harmony export */   UICollectionViewLayoutAttributes: () => (/* reexport safe */ _UICollectionViewLayoutAttributes__WEBPACK_IMPORTED_MODULE_38__.UICollectionViewLayoutAttributes),
/* harmony export */   UICollectionViewSection: () => (/* reexport safe */ _UICollectionView__WEBPACK_IMPORTED_MODULE_36__.UICollectionViewSection),
/* harmony export */   UICollectionViewUpdateItem: () => (/* reexport safe */ _UICollectionViewUpdateItem__WEBPACK_IMPORTED_MODULE_39__.UICollectionViewUpdateItem),
/* harmony export */   UIColor: () => (/* reexport safe */ _UIColor__WEBPACK_IMPORTED_MODULE_15__.UIColor),
/* harmony export */   UIControl: () => (/* reexport safe */ _UIControl__WEBPACK_IMPORTED_MODULE_28__.UIControl),
/* harmony export */   UICoreLayerIDFromClassname: () => (/* reexport safe */ _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__.UICoreLayerIDFromClassname),
/* harmony export */   UICoreLayerIDFromObject: () => (/* reexport safe */ _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__.UICoreLayerIDFromObject),
/* harmony export */   UIImageView: () => (/* reexport safe */ _UIImageView__WEBPACK_IMPORTED_MODULE_35__.UIImageView),
/* harmony export */   UILabel: () => (/* reexport safe */ _UILabel__WEBPACK_IMPORTED_MODULE_31__.UILabel),
/* harmony export */   UINavigationBar: () => (/* reexport safe */ _UINavigationBar__WEBPACK_IMPORTED_MODULE_25__.UINavigationBar),
/* harmony export */   UINavigationController: () => (/* reexport safe */ _UINavigationController__WEBPACK_IMPORTED_MODULE_26__.UINavigationController),
/* harmony export */   UINavigationItem: () => (/* reexport safe */ _UINavigationItem__WEBPACK_IMPORTED_MODULE_27__.UINavigationItem),
/* harmony export */   UIScene: () => (/* reexport safe */ _UIScene__WEBPACK_IMPORTED_MODULE_16__.UIScene),
/* harmony export */   UISceneConfiguration: () => (/* reexport safe */ _UISceneConfiguration__WEBPACK_IMPORTED_MODULE_17__.UISceneConfiguration),
/* harmony export */   UISceneConnectionOptions: () => (/* reexport safe */ _UISceneConnectionOptions__WEBPACK_IMPORTED_MODULE_18__.UISceneConnectionOptions),
/* harmony export */   UISceneSession: () => (/* reexport safe */ _UISceneSession__WEBPACK_IMPORTED_MODULE_19__.UISceneSession),
/* harmony export */   UISceneSessionRole: () => (/* reexport safe */ _UISceneSession__WEBPACK_IMPORTED_MODULE_19__.UISceneSessionRole),
/* harmony export */   UISegmentedControl: () => (/* reexport safe */ _UISegmentedControl__WEBPACK_IMPORTED_MODULE_34__.UISegmentedControl),
/* harmony export */   UIStoryboard: () => (/* reexport safe */ _UIStoryboard__WEBPACK_IMPORTED_MODULE_20__.UIStoryboard),
/* harmony export */   UIStoryboardSegue: () => (/* reexport safe */ _UIStoryboardSegue__WEBPACK_IMPORTED_MODULE_21__.UIStoryboardSegue),
/* harmony export */   UITableView: () => (/* reexport safe */ _UITableView__WEBPACK_IMPORTED_MODULE_40__.UITableView),
/* harmony export */   UITableViewCell: () => (/* reexport safe */ _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__.UITableViewCell),
/* harmony export */   UITableViewCellAccessoryType: () => (/* reexport safe */ _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__.UITableViewCellAccessoryType),
/* harmony export */   UITableViewCellContentView: () => (/* reexport safe */ _UITableView__WEBPACK_IMPORTED_MODULE_40__.UITableViewCellContentView),
/* harmony export */   UITableViewCellEditingStyle: () => (/* reexport safe */ _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__.UITableViewCellEditingStyle),
/* harmony export */   UITableViewCellSelectionStyle: () => (/* reexport safe */ _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__.UITableViewCellSelectionStyle),
/* harmony export */   UITableViewCellSeparatorStyle: () => (/* reexport safe */ _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__.UITableViewCellSeparatorStyle),
/* harmony export */   UITableViewCellStyle: () => (/* reexport safe */ _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__.UITableViewCellStyle),
/* harmony export */   UITextArea: () => (/* reexport safe */ _UITextArea__WEBPACK_IMPORTED_MODULE_30__.UITextArea),
/* harmony export */   UITextField: () => (/* reexport safe */ _UITextField__WEBPACK_IMPORTED_MODULE_29__.UITextField),
/* harmony export */   UITextFieldType: () => (/* reexport safe */ _UITextField__WEBPACK_IMPORTED_MODULE_29__.UITextFieldType),
/* harmony export */   UIView: () => (/* reexport safe */ _UIView__WEBPACK_IMPORTED_MODULE_23__.UIView),
/* harmony export */   UIViewController: () => (/* reexport safe */ _UIViewController__WEBPACK_IMPORTED_MODULE_22__.UIViewController),
/* harmony export */   UIWindow: () => (/* reexport safe */ _UIWindow__WEBPACK_IMPORTED_MODULE_24__.UIWindow),
/* harmony export */   _CAAddAnimations: () => (/* reexport safe */ _CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_10__._CAAddAnimations),
/* harmony export */   _CAAnimationDidFinish: () => (/* reexport safe */ _CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_11__._CAAnimationDidFinish),
/* harmony export */   _CAAnimationStart: () => (/* reexport safe */ _CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_11__._CAAnimationStart),
/* harmony export */   _CAAnimationType: () => (/* reexport safe */ _CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_10__._CAAnimationType),
/* harmony export */   _CAClassListForAnimationType: () => (/* reexport safe */ _CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_10__._CAClassListForAnimationType),
/* harmony export */   _CARemoveAnimations: () => (/* reexport safe */ _CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_10__._CARemoveAnimations),
/* harmony export */   _UICoreLayerGetAllElementsWithTag: () => (/* reexport safe */ _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetAllElementsWithTag),
/* harmony export */   _UICoreLayerGetFirstElementWithTag: () => (/* reexport safe */ _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag),
/* harmony export */   _UIModalWindow: () => (/* reexport safe */ _UIWindow__WEBPACK_IMPORTED_MODULE_24__._UIModalWindow)
/* harmony export */ });
/* harmony import */ var _core_UICoreLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/UICoreLayer */ "./sources/core/UICoreLayer.ts");
/* harmony import */ var _CoreGraphics_CGContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreGraphics/CGContext */ "./sources/CoreGraphics/CGContext.ts");
/* harmony import */ var _CoreGraphics_CGPoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreGraphics/CGPoint */ "./sources/CoreGraphics/CGPoint.ts");
/* harmony import */ var _CoreGraphics_CGRect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreGraphics/CGRect */ "./sources/CoreGraphics/CGRect.ts");
/* harmony import */ var _CoreGraphics_CGSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CoreGraphics/CGSize */ "./sources/CoreGraphics/CGSize.ts");
/* harmony import */ var _CoreAnimation_CALayer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CoreAnimation/CALayer */ "./sources/CoreAnimation/CALayer.ts");
/* harmony import */ var _CoreAnimation_CALayer_HTML__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CoreAnimation/CALayer+HTML */ "./sources/CoreAnimation/CALayer+HTML.ts");
/* harmony import */ var _CoreAnimation_CATextLayer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CoreAnimation/CATextLayer */ "./sources/CoreAnimation/CATextLayer.ts");
/* harmony import */ var _CoreAnimation_CAInputLayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CoreAnimation/CAInputLayer */ "./sources/CoreAnimation/CAInputLayer.ts");
/* harmony import */ var _CoreAnimation_CoreAnimation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CoreAnimation/CoreAnimation */ "./sources/CoreAnimation/CoreAnimation.ts");
/* harmony import */ var _CoreAnimation_CoreAnimation_Animations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CoreAnimation/CoreAnimation+Animations */ "./sources/CoreAnimation/CoreAnimation+Animations.ts");
/* harmony import */ var _CoreAnimation_CoreAnimation_ViewController__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CoreAnimation/CoreAnimation+ViewController */ "./sources/CoreAnimation/CoreAnimation+ViewController.ts");
/* harmony import */ var _UIApplicationMain__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./UIApplicationMain */ "./sources/UIApplicationMain.ts");
/* harmony import */ var _UIApplication__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./UIApplication */ "./sources/UIApplication.ts");
/* harmony import */ var _UIApplicationDelegate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./UIApplicationDelegate */ "./sources/UIApplicationDelegate.ts");
/* harmony import */ var _UIColor__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./UIColor */ "./sources/UIColor.ts");
/* harmony import */ var _UIScene__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./UIScene */ "./sources/UIScene.ts");
/* harmony import */ var _UISceneConfiguration__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./UISceneConfiguration */ "./sources/UISceneConfiguration.ts");
/* harmony import */ var _UISceneConnectionOptions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./UISceneConnectionOptions */ "./sources/UISceneConnectionOptions.ts");
/* harmony import */ var _UISceneSession__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./UISceneSession */ "./sources/UISceneSession.ts");
/* harmony import */ var _UIStoryboard__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./UIStoryboard */ "./sources/UIStoryboard.ts");
/* harmony import */ var _UIStoryboardSegue__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./UIStoryboardSegue */ "./sources/UIStoryboardSegue.ts");
/* harmony import */ var _UIViewController__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./UIViewController */ "./sources/UIViewController.ts");
/* harmony import */ var _UIView__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./UIView */ "./sources/UIView.ts");
/* harmony import */ var _UIWindow__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./UIWindow */ "./sources/UIWindow.ts");
/* harmony import */ var _UINavigationBar__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./UINavigationBar */ "./sources/UINavigationBar.ts");
/* harmony import */ var _UINavigationController__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./UINavigationController */ "./sources/UINavigationController.ts");
/* harmony import */ var _UINavigationItem__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./UINavigationItem */ "./sources/UINavigationItem.ts");
/* harmony import */ var _UIControl__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./UIControl */ "./sources/UIControl.ts");
/* harmony import */ var _UITextField__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./UITextField */ "./sources/UITextField.ts");
/* harmony import */ var _UITextArea__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./UITextArea */ "./sources/UITextArea.ts");
/* harmony import */ var _UILabel__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./UILabel */ "./sources/UILabel.ts");
/* harmony import */ var _UIButton__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./UIButton */ "./sources/UIButton.ts");
/* harmony import */ var _UICheckButton__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./UICheckButton */ "./sources/UICheckButton.ts");
/* harmony import */ var _UISegmentedControl__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./UISegmentedControl */ "./sources/UISegmentedControl.ts");
/* harmony import */ var _UIImageView__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./UIImageView */ "./sources/UIImageView.ts");
/* harmony import */ var _UICollectionView__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./UICollectionView */ "./sources/UICollectionView.ts");
/* harmony import */ var _UICollectionViewLayout__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./UICollectionViewLayout */ "./sources/UICollectionViewLayout.ts");
/* harmony import */ var _UICollectionViewLayoutAttributes__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./UICollectionViewLayoutAttributes */ "./sources/UICollectionViewLayoutAttributes.ts");
/* harmony import */ var _UICollectionViewUpdateItem__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./UICollectionViewUpdateItem */ "./sources/UICollectionViewUpdateItem.ts");
/* harmony import */ var _UITableView__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./UITableView */ "./sources/UITableView.ts");
/* harmony import */ var _UITableViewCell__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./UITableViewCell */ "./sources/UITableViewCell.ts");











































})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=uikit.js.map